import React, { useState, useMemo, useEffect, forwardRef, useRef, useCallback } from "react";
import styled from "styled-components";
import classNames from "classnames";
import pluralize from "pluralize";
import InfiniteLoader from "react-window-infinite-loader";
import { FixedSizeList } from "react-window";
import ReactDatePicker from "react-datepicker";
import { format } from "date-fns";
import { ListboxButton, ListboxOption, ListboxPopover, ListboxList, ListboxInput } from "@reach/listbox";
var style = /* @__PURE__ */ (() => '@charset "UTF-8";:root{--reach-listbox: 1}[data-reach-listbox-popover]{display:block;position:absolute;min-width:-moz-fit-content;min-width:-webkit-min-content;min-width:min-content;padding:.25rem 0;background:hsl(0,0%,100%);outline:none;border:solid 1px hsla(0,0%,0%,.25)}[data-reach-listbox-popover]:focus-within{box-shadow:0 0 4px Highlight;outline:-webkit-focus-ring-color auto 4px}[data-reach-listbox-popover][hidden]{display:none}[data-reach-listbox-list]{margin:0;padding:0;list-style:none}[data-reach-listbox-list]:focus{box-shadow:none;outline:none}[data-reach-listbox-option]{display:block;margin:0;padding:.25rem .5rem;white-space:nowrap;user-select:none}[data-reach-listbox-option][data-current-nav]{background:hsl(211,81%,46%);color:#fff}[data-reach-listbox-option][data-current-selected]{font-weight:bolder}[data-reach-listbox-option][data-current-selected][data-confirming]{animation:flash .1s;animation-iteration-count:1}[data-reach-listbox-option][aria-disabled=true]{opacity:.5}[data-reach-listbox-button]{display:inline-flex;align-items:center;justify-content:space-between;padding:1px 10px 2px;border:1px solid;border-color:rgb(216,216,216) rgb(209,209,209) rgb(186,186,186);cursor:default;user-select:none}[data-reach-listbox-button][aria-disabled=true]{opacity:.5}[data-reach-listbox-arrow]{margin-left:.5rem;display:block;font-size:.5em}[data-reach-listbox-group-label]{display:block;margin:0;padding:.25rem .5rem;white-space:nowrap;user-select:none;font-weight:bolder}@keyframes flash{0%{background:hsla(211,81%,36%,1);color:#fff;opacity:1}50%{opacity:.5;background:inherit;color:inherit}to{background:hsla(211,81%,36%,1);color:#fff;opacity:1}}.react-datepicker__year-read-view--down-arrow,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__navigation-icon:before{border-color:#ccc;border-style:solid;border-width:3px 3px 0 0;content:"";display:block;height:9px;position:absolute;top:6px;width:9px}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle{margin-left:-4px;position:absolute;width:0}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:after,.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:after{box-sizing:content-box;position:absolute;border:8px solid transparent;height:0;width:1px;content:"";z-index:-1;border-width:8px;left:-8px}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before{border-bottom-color:#aeaeae}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle{top:0;margin-top:-8px}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before,.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:after{border-top:none;border-bottom-color:#f0f0f0}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:after{top:0}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before{top:-1px;border-bottom-color:#aeaeae}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle{bottom:0;margin-bottom:-8px}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:after{border-bottom:none;border-top-color:#fff}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:after{bottom:0}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before{bottom:-1px;border-top-color:#aeaeae}.react-datepicker-wrapper{display:inline-block;padding:0;border:0;width:100%}.react-datepicker{font-family:Helvetica Neue,helvetica,arial,sans-serif;font-size:.8rem;background-color:#fff;color:#000;border:1px solid #aeaeae;border-radius:.3rem;display:inline-block;position:relative}.react-datepicker--time-only .react-datepicker__triangle{left:35px}.react-datepicker--time-only .react-datepicker__time-container{border-left:0}.react-datepicker--time-only .react-datepicker__time,.react-datepicker--time-only .react-datepicker__time-box{border-bottom-left-radius:.3rem;border-bottom-right-radius:.3rem}.react-datepicker__triangle{position:absolute;left:50px}.react-datepicker-popper{z-index:1}.react-datepicker-popper[data-placement^=bottom]{padding-top:10px}.react-datepicker-popper[data-placement=bottom-end] .react-datepicker__triangle,.react-datepicker-popper[data-placement=top-end] .react-datepicker__triangle{left:auto;right:50px}.react-datepicker-popper[data-placement^=top]{padding-bottom:10px}.react-datepicker-popper[data-placement^=right]{padding-left:8px}.react-datepicker-popper[data-placement^=right] .react-datepicker__triangle{left:auto;right:42px}.react-datepicker-popper[data-placement^=left]{padding-right:8px}.react-datepicker-popper[data-placement^=left] .react-datepicker__triangle{left:42px;right:auto}.react-datepicker__header{text-align:center;background-color:#f0f0f0;border-bottom:1px solid #aeaeae;border-top-left-radius:.3rem;padding:8px 0;position:relative}.react-datepicker__header--time{padding-bottom:8px;padding-left:5px;padding-right:5px}.react-datepicker__header--time:not(.react-datepicker__header--time--only){border-top-left-radius:0}.react-datepicker__header:not(.react-datepicker__header--has-time-select){border-top-right-radius:.3rem}.react-datepicker__year-dropdown-container--select,.react-datepicker__month-dropdown-container--select,.react-datepicker__month-year-dropdown-container--select,.react-datepicker__year-dropdown-container--scroll,.react-datepicker__month-dropdown-container--scroll,.react-datepicker__month-year-dropdown-container--scroll{display:inline-block;margin:0 2px}.react-datepicker__current-month,.react-datepicker-time__header,.react-datepicker-year-header{margin-top:0;color:#000;font-weight:700;font-size:.944rem}.react-datepicker-time__header{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.react-datepicker__navigation{align-items:center;background:none;display:flex;justify-content:center;text-align:center;cursor:pointer;position:absolute;top:2px;padding:0;border:none;z-index:1;height:32px;width:32px;text-indent:-999em;overflow:hidden}.react-datepicker__navigation--previous{left:2px}.react-datepicker__navigation--next{right:2px}.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button){right:85px}.react-datepicker__navigation--years{position:relative;top:0;display:block;margin-left:auto;margin-right:auto}.react-datepicker__navigation--years-previous{top:4px}.react-datepicker__navigation--years-upcoming{top:-4px}.react-datepicker__navigation:hover *:before{border-color:#a6a6a6}.react-datepicker__navigation-icon{position:relative;top:-1px;font-size:20px;width:0}.react-datepicker__navigation-icon--next{left:-2px}.react-datepicker__navigation-icon--next:before{transform:rotate(45deg);left:-7px}.react-datepicker__navigation-icon--previous{right:-2px}.react-datepicker__navigation-icon--previous:before{transform:rotate(225deg);right:-7px}.react-datepicker__month-container{float:left}.react-datepicker__year{margin:.4rem;text-align:center}.react-datepicker__year-wrapper{display:flex;flex-wrap:wrap;max-width:180px}.react-datepicker__year .react-datepicker__year-text{display:inline-block;width:4rem;margin:2px}.react-datepicker__month{margin:.4rem;text-align:center}.react-datepicker__month .react-datepicker__month-text,.react-datepicker__month .react-datepicker__quarter-text{display:inline-block;width:4rem;margin:2px}.react-datepicker__input-time-container{clear:both;width:100%;float:left;margin:5px 0 10px 15px;text-align:left}.react-datepicker__input-time-container .react-datepicker-time__caption,.react-datepicker__input-time-container .react-datepicker-time__input-container{display:inline-block}.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input{display:inline-block;margin-left:10px}.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input{width:auto}.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-inner-spin-button,.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]{-moz-appearance:textfield}.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__delimiter{margin-left:5px;display:inline-block}.react-datepicker__time-container{float:right;border-left:1px solid #aeaeae;width:85px}.react-datepicker__time-container--with-today-button{display:inline;border:1px solid #aeaeae;border-radius:.3rem;position:absolute;right:-72px;top:0}.react-datepicker__time-container .react-datepicker__time{position:relative;background:white;border-bottom-right-radius:.3rem}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box{width:85px;overflow-x:hidden;margin:0 auto;text-align:center;border-bottom-right-radius:.3rem}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list{list-style:none;margin:0;height:calc(195px + .85rem);overflow-y:scroll;padding-right:0;padding-left:0;width:100%;box-sizing:content-box}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item{height:30px;padding:5px 10px;white-space:nowrap}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover{cursor:pointer;background-color:#f0f0f0}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected{background-color:#216ba5;color:#fff;font-weight:700}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover{background-color:#216ba5}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled{color:#ccc}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover{cursor:default;background-color:transparent}.react-datepicker__week-number{color:#ccc;display:inline-block;width:1.7rem;line-height:1.7rem;text-align:center;margin:.166rem}.react-datepicker__week-number.react-datepicker__week-number--clickable{cursor:pointer}.react-datepicker__week-number.react-datepicker__week-number--clickable:hover{border-radius:.3rem;background-color:#f0f0f0}.react-datepicker__day-names,.react-datepicker__week{white-space:nowrap}.react-datepicker__day-names{margin-bottom:-8px}.react-datepicker__day-name,.react-datepicker__day,.react-datepicker__time-name{color:#000;display:inline-block;width:1.7rem;line-height:1.7rem;text-align:center;margin:.166rem}.react-datepicker__month--selected,.react-datepicker__month--in-selecting-range,.react-datepicker__month--in-range,.react-datepicker__quarter--selected,.react-datepicker__quarter--in-selecting-range,.react-datepicker__quarter--in-range{border-radius:.3rem;background-color:#216ba5;color:#fff}.react-datepicker__month--selected:hover,.react-datepicker__month--in-selecting-range:hover,.react-datepicker__month--in-range:hover,.react-datepicker__quarter--selected:hover,.react-datepicker__quarter--in-selecting-range:hover,.react-datepicker__quarter--in-range:hover{background-color:#1d5d90}.react-datepicker__month--disabled,.react-datepicker__quarter--disabled{color:#ccc;pointer-events:none}.react-datepicker__month--disabled:hover,.react-datepicker__quarter--disabled:hover{cursor:default;background-color:transparent}.react-datepicker__day,.react-datepicker__month-text,.react-datepicker__quarter-text,.react-datepicker__year-text{cursor:pointer}.react-datepicker__day:hover,.react-datepicker__month-text:hover,.react-datepicker__quarter-text:hover,.react-datepicker__year-text:hover{border-radius:.3rem;background-color:#f0f0f0}.react-datepicker__day--today,.react-datepicker__month-text--today,.react-datepicker__quarter-text--today,.react-datepicker__year-text--today{font-weight:700}.react-datepicker__day--highlighted,.react-datepicker__month-text--highlighted,.react-datepicker__quarter-text--highlighted,.react-datepicker__year-text--highlighted{border-radius:.3rem;background-color:#3dcc4a;color:#fff}.react-datepicker__day--highlighted:hover,.react-datepicker__month-text--highlighted:hover,.react-datepicker__quarter-text--highlighted:hover,.react-datepicker__year-text--highlighted:hover{background-color:#32be3f}.react-datepicker__day--highlighted-custom-1,.react-datepicker__month-text--highlighted-custom-1,.react-datepicker__quarter-text--highlighted-custom-1,.react-datepicker__year-text--highlighted-custom-1{color:#f0f}.react-datepicker__day--highlighted-custom-2,.react-datepicker__month-text--highlighted-custom-2,.react-datepicker__quarter-text--highlighted-custom-2,.react-datepicker__year-text--highlighted-custom-2{color:green}.react-datepicker__day--selected,.react-datepicker__day--in-selecting-range,.react-datepicker__day--in-range,.react-datepicker__month-text--selected,.react-datepicker__month-text--in-selecting-range,.react-datepicker__month-text--in-range,.react-datepicker__quarter-text--selected,.react-datepicker__quarter-text--in-selecting-range,.react-datepicker__quarter-text--in-range,.react-datepicker__year-text--selected,.react-datepicker__year-text--in-selecting-range,.react-datepicker__year-text--in-range{border-radius:.3rem;background-color:#216ba5;color:#fff}.react-datepicker__day--selected:hover,.react-datepicker__day--in-selecting-range:hover,.react-datepicker__day--in-range:hover,.react-datepicker__month-text--selected:hover,.react-datepicker__month-text--in-selecting-range:hover,.react-datepicker__month-text--in-range:hover,.react-datepicker__quarter-text--selected:hover,.react-datepicker__quarter-text--in-selecting-range:hover,.react-datepicker__quarter-text--in-range:hover,.react-datepicker__year-text--selected:hover,.react-datepicker__year-text--in-selecting-range:hover,.react-datepicker__year-text--in-range:hover{background-color:#1d5d90}.react-datepicker__day--keyboard-selected,.react-datepicker__month-text--keyboard-selected,.react-datepicker__quarter-text--keyboard-selected,.react-datepicker__year-text--keyboard-selected{border-radius:.3rem;background-color:#2579ba;color:#fff}.react-datepicker__day--keyboard-selected:hover,.react-datepicker__month-text--keyboard-selected:hover,.react-datepicker__quarter-text--keyboard-selected:hover,.react-datepicker__year-text--keyboard-selected:hover{background-color:#1d5d90}.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range,.react-datepicker__month-text--in-range,.react-datepicker__quarter-text--in-range,.react-datepicker__year-text--in-range),.react-datepicker__month-text--in-selecting-range:not(.react-datepicker__day--in-range,.react-datepicker__month-text--in-range,.react-datepicker__quarter-text--in-range,.react-datepicker__year-text--in-range),.react-datepicker__quarter-text--in-selecting-range:not(.react-datepicker__day--in-range,.react-datepicker__month-text--in-range,.react-datepicker__quarter-text--in-range,.react-datepicker__year-text--in-range),.react-datepicker__year-text--in-selecting-range:not(.react-datepicker__day--in-range,.react-datepicker__month-text--in-range,.react-datepicker__quarter-text--in-range,.react-datepicker__year-text--in-range){background-color:#216ba580}.react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range,.react-datepicker__month-text--in-selecting-range,.react-datepicker__quarter-text--in-selecting-range,.react-datepicker__year-text--in-selecting-range),.react-datepicker__month--selecting-range .react-datepicker__month-text--in-range:not(.react-datepicker__day--in-selecting-range,.react-datepicker__month-text--in-selecting-range,.react-datepicker__quarter-text--in-selecting-range,.react-datepicker__year-text--in-selecting-range),.react-datepicker__month--selecting-range .react-datepicker__quarter-text--in-range:not(.react-datepicker__day--in-selecting-range,.react-datepicker__month-text--in-selecting-range,.react-datepicker__quarter-text--in-selecting-range,.react-datepicker__year-text--in-selecting-range),.react-datepicker__month--selecting-range .react-datepicker__year-text--in-range:not(.react-datepicker__day--in-selecting-range,.react-datepicker__month-text--in-selecting-range,.react-datepicker__quarter-text--in-selecting-range,.react-datepicker__year-text--in-selecting-range){background-color:#f0f0f0;color:#000}.react-datepicker__day--disabled,.react-datepicker__month-text--disabled,.react-datepicker__quarter-text--disabled,.react-datepicker__year-text--disabled{cursor:default;color:#ccc}.react-datepicker__day--disabled:hover,.react-datepicker__month-text--disabled:hover,.react-datepicker__quarter-text--disabled:hover,.react-datepicker__year-text--disabled:hover{background-color:transparent}.react-datepicker__month-text.react-datepicker__month--selected:hover,.react-datepicker__month-text.react-datepicker__month--in-range:hover,.react-datepicker__month-text.react-datepicker__quarter--selected:hover,.react-datepicker__month-text.react-datepicker__quarter--in-range:hover,.react-datepicker__quarter-text.react-datepicker__month--selected:hover,.react-datepicker__quarter-text.react-datepicker__month--in-range:hover,.react-datepicker__quarter-text.react-datepicker__quarter--selected:hover,.react-datepicker__quarter-text.react-datepicker__quarter--in-range:hover{background-color:#216ba5}.react-datepicker__month-text:hover,.react-datepicker__quarter-text:hover{background-color:#f0f0f0}.react-datepicker__input-container{position:relative;display:inline-block;width:100%}.react-datepicker__year-read-view,.react-datepicker__month-read-view,.react-datepicker__month-year-read-view{border:1px solid transparent;border-radius:.3rem;position:relative}.react-datepicker__year-read-view:hover,.react-datepicker__month-read-view:hover,.react-datepicker__month-year-read-view:hover{cursor:pointer}.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow{border-top-color:#b3b3b3}.react-datepicker__year-read-view--down-arrow,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow{transform:rotate(135deg);right:-16px;top:0}.react-datepicker__year-dropdown,.react-datepicker__month-dropdown,.react-datepicker__month-year-dropdown{background-color:#f0f0f0;position:absolute;width:50%;left:25%;top:30px;z-index:1;text-align:center;border-radius:.3rem;border:1px solid #aeaeae}.react-datepicker__year-dropdown:hover,.react-datepicker__month-dropdown:hover,.react-datepicker__month-year-dropdown:hover{cursor:pointer}.react-datepicker__year-dropdown--scrollable,.react-datepicker__month-dropdown--scrollable,.react-datepicker__month-year-dropdown--scrollable{height:150px;overflow-y:scroll}.react-datepicker__year-option,.react-datepicker__month-option,.react-datepicker__month-year-option{line-height:20px;width:100%;display:block;margin-left:auto;margin-right:auto}.react-datepicker__year-option:first-of-type,.react-datepicker__month-option:first-of-type,.react-datepicker__month-year-option:first-of-type{border-top-left-radius:.3rem;border-top-right-radius:.3rem}.react-datepicker__year-option:last-of-type,.react-datepicker__month-option:last-of-type,.react-datepicker__month-year-option:last-of-type{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border-bottom-left-radius:.3rem;border-bottom-right-radius:.3rem}.react-datepicker__year-option:hover,.react-datepicker__month-option:hover,.react-datepicker__month-year-option:hover{background-color:#ccc}.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming{border-bottom-color:#b3b3b3}.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous{border-top-color:#b3b3b3}.react-datepicker__year-option--selected,.react-datepicker__month-option--selected,.react-datepicker__month-year-option--selected{position:absolute;left:15px}.react-datepicker__close-icon{cursor:pointer;background-color:transparent;border:0;outline:0;padding:0 6px 0 0;position:absolute;top:0;right:0;height:100%;display:table-cell;vertical-align:middle}.react-datepicker__close-icon:after{cursor:pointer;background-color:#216ba5;color:#fff;border-radius:50%;height:16px;width:16px;padding:2px;font-size:12px;line-height:1;text-align:center;display:table-cell;vertical-align:middle;content:"\\d7"}.react-datepicker__today-button{background:#f0f0f0;border-top:1px solid #aeaeae;cursor:pointer;text-align:center;font-weight:700;padding:5px 0;clear:left}.react-datepicker__portal{position:fixed;width:100vw;height:100vh;background-color:#000c;left:0;top:0;justify-content:center;align-items:center;display:flex;z-index:2147483647}.react-datepicker__portal .react-datepicker__day-name,.react-datepicker__portal .react-datepicker__day,.react-datepicker__portal .react-datepicker__time-name{width:3rem;line-height:3rem}@media (max-width: 400px),(max-height: 550px){.react-datepicker__portal .react-datepicker__day-name,.react-datepicker__portal .react-datepicker__day,.react-datepicker__portal .react-datepicker__time-name{width:2rem;line-height:2rem}}.react-datepicker__portal .react-datepicker__current-month,.react-datepicker__portal .react-datepicker-time__header{font-size:1.44rem}\n')();
const palette = {
  jordan: "rgba(238, 8, 49, 1.0)",
  "jordan-90": "rgba(238, 8, 49, 0.9)",
  "jordan-80": "rgba(238, 8, 49, 0.8)",
  "jordan-70": "rgba(238, 8, 49, 0.7)",
  "jordan-60": "rgba(238, 8, 49, 0.6)",
  "jordan-50": "rgba(238, 8, 49, 0.5)",
  "jordan-40": "rgba(238, 8, 49, 0.4)",
  "jordan-30": "rgba(238, 8, 49, 0.3)",
  "jordan-20": "rgba(238, 8, 49, 0.2)",
  "jordan-10": "rgba(238, 8, 49, 0.1)",
  "jordan-op-80": "#EA4D59",
  "jordan-op-40": "#F5A6AC",
  "jordan-op-24": "#F9CACD",
  "jordan-op-16": "#FBDBDE",
  "jordan-op-08": "#FDEEEF",
  "jordan-dp": "rgba(229, 32, 47, 1)",
  "jordan-dp-30": "rgba(229, 32, 47, 0.3)",
  ripkin: "rgba(240, 100, 36, 1.0)",
  "ripkin-90": "rgba(240, 100, 36, 0.9)",
  "ripkin-80": "rgba(240, 100, 36, 0.8)",
  "ripkin-70": "rgba(240, 100, 36, 0.7)",
  "ripkin-60": "rgba(240, 100, 36, 0.6)",
  "ripkin-50": "rgba(240, 100, 36, 0.5)",
  "ripkin-40": "rgba(240, 100, 36, 0.4)",
  "ripkin-30": "rgba(240, 100, 36, 0.3)",
  "ripkin-20": "rgba(240, 100, 36, 0.2)",
  "ripkin-10": "rgba(240, 100, 36, 0.1)",
  pele: "rgba(250, 165, 26, 1.0)",
  "pele-90": "rgba(250, 165, 26, 0.9)",
  "pele-80": "rgba(250, 165, 26, 0.8)",
  "pele-70": "rgba(250, 165, 26, 0.7)",
  "pele-60": "rgba(250, 165, 26, 0.6)",
  "pele-50": "rgba(250, 165, 26, 0.5)",
  "pele-40": "rgba(250, 165, 26, 0.4)",
  "pele-30": "rgba(250, 165, 26, 0.3)",
  "pele-20": "rgba(250, 165, 26, 0.2)",
  "pele-10": "rgba(250, 165, 26, 0.1)",
  "pele-op-80": "#FBB748",
  "pele-op-40": "#FDDBA3",
  "pele-op-24": "#FEEAC8",
  "pele-op-16": "#FEF0DA",
  "pele-op-08": "#FFF8ED",
  kobe: "rgba(158, 7, 174, 1.0)",
  "kobe-90": "rgba(158, 7, 174, 0.9)",
  "kobe-80": "rgba(158, 7, 174, 0.8)",
  "kobe-70": "rgba(158, 7, 174, 0.7)",
  "kobe-60": "rgba(158, 7, 174, 0.6)",
  "kobe-50": "rgba(158, 7, 174, 0.5)",
  "kobe-40": "rgba(158, 7, 174, 0.4)",
  "kobe-30": "rgba(158, 7, 174, 0.3)",
  "kobe-20": "rgba(158, 7, 174, 0.2)",
  "kobe-10": "rgba(158, 7, 174, 0.1)",
  serena: "rgba(32, 215, 127, 1.0)",
  "serena-90": "rgba(32, 215, 127, 0.9)",
  "serena-80": "rgba(32, 215, 127, 0.8)",
  "serena-70": "rgba(32, 215, 127, 0.7)",
  "serena-60": "rgba(32, 215, 127, 0.6)",
  "serena-50": "rgba(32, 215, 127, 0.5)",
  "serena-40": "rgba(32, 215, 127, 0.4)",
  "serena-30": "rgba(32, 215, 127, 0.3)",
  "serena-20": "rgba(32, 215, 127, 0.2)",
  "serena-10": "rgba(32, 215, 127, 0.1)",
  "serena-op-80": "#4DDF99",
  "serena-op-40": "#A6EFCC",
  "serena-op-24": "#CAF6E0",
  "serena-op-16": "#DBF8EA",
  "serena-op-08": "#EEFCF5",
  tendulkar: "rgba(0, 108, 250, 1.0)",
  "tendulkar-90": "rgba(0, 108, 250, 0.9)",
  "tendulkar-80": "rgba(0, 108, 250, 0.8)",
  "tendulkar-70": "rgba(0, 108, 250, 0.7)",
  "tendulkar-60": "rgba(0, 108, 250, 0.6)",
  "tendulkar-50": "rgba(0, 108, 250, 0.5)",
  "tendulkar-40": "rgba(0, 108, 250, 0.4)",
  "tendulkar-30": "rgba(0, 108, 250, 0.3)",
  "tendulkar-20": "rgba(0, 108, 250, 0.2)",
  "tendulkar-10": "rgba(0, 108, 250, 0.1)",
  "tendulkar-op-80": "#3389FB",
  "tendulkar-op-40": "#99C4FD",
  "tendulkar-op-24": "#C2DCFE",
  "tendulkar-op-16": "#D6E7FE",
  "tendulkar-op-08": "#EBF4FF",
  "sp-black": "rgba(34, 34, 34, 1.0)",
  "sp-dark-gray-75": "rgba(68, 68, 68, 1.0)",
  "sp-dark-gray-50": "rgba(90, 90, 90, 1.0)",
  "sp-dark-gray-25": "rgba(111, 111, 111, 1.0)",
  "sp-mid-gray": "rgba(155, 155, 155, 1.0)",
  "sp-light-gray-75": "rgba(198, 198, 198, 1.0)",
  "sp-light-gray-50": "rgba(226, 226, 226, 1.0)",
  "sp-light-gray-25": "rgba(242, 242, 242, 1.0)",
  "sp-white": "rgba(255, 255, 255, 1.0)",
  "sp-overlay": "rgba(34, 34, 34, 0.25)",
  "sp-hover-light": "rgba(34, 34, 34, 0.08)",
  "sp-hover-dark": "rgba(255, 255, 255, 0.08)",
  "sp-hover-red": "rgba(255, 0, 60, 1.0)",
  "sp-hover-orange": "rgba(255, 136, 0, 1.0)",
  "sp-shadow": "rgba(0, 0, 0, 0.1)",
  "sp-table-hover": "#F2F7FF",
  "sp-max-gray": "rgba(68, 68, 68, 1.0)",
  "sp-dark-gray": "rgba(111, 111, 111, 1.0)",
  "sp-gray": "rgba(155, 155, 155, 1.0)",
  "sp-light-gray": "rgba(198, 198, 198, 1.0)",
  "sp-light-min-gray": "rgba(226, 226, 226, 1.0)",
  "sp-min-gray": "rgba(242, 242, 242, 1.0)"
};
const color = (key) => {
  return palette[key];
};
const typography = `
  font-size: 14px;
  font-weight: normal;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.14;
  letter-spacing: normal;
  color: ${palette["sp-black"]}
`;
const getUniqueId = (prefix) => {
  const uuid = Date.now().toString(36) + Math.random().toString(36).substr(2);
  return prefix ? prefix + uuid : uuid;
};
const iconData = {
  account: {
    title: "Icon/Account",
    data: "M12,2 C17.5228475,2 22,6.4771525 22,12 C22,17.5228475 17.5228475,22 12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 Z M12,13 C9.23857625,13 7,12.2385763 7,15 C7,17.7614237 9.23857625,20 12,20 C14.7614237,20 17,17.7614237 17,15 C17,12.2385763 14.7614237,13 12,13 Z M12,6 C10.3431458,6 9,7.34314575 9,9 C9,10.6568542 10.3431458,12 12,12 C13.6568542,12 15,10.6568542 15,9 C15,7.34314575 13.6568542,6 12,6 Z"
  },
  admin: {
    title: "Icon/Admin",
    data: "M12,11.6 C13.5475098,11.6 14.8,10.3475098 14.8,8.8 C14.8,7.25249023 13.5475098,6 12,6 C10.4524902,6 9.2,7.25249023 9.2,8.8 C9.2,10.3475098 10.4524902,11.6 12,11.6 Z M6.4,10.8 C7.28249512,10.8 8,10.0824951 8,9.2 C8,8.31750488 7.28249512,7.6 6.4,7.6 C5.51750488,7.6 4.8,8.31750488 4.8,9.2 C4.8,10.0824951 5.51750488,10.8 6.4,10.8 Z M17.6,10.8 C18.4824951,10.8 19.2,10.0824951 19.2,9.2 C19.2,8.31750488 18.4824951,7.6 17.6,7.6 C16.7175049,7.6 16,8.31750488 16,9.2 C16,10.0824951 16.7175049,10.8 17.6,10.8 Z M19.2,14.8 C19.6425049,14.8 20,14.4425049 20,14 L20,13.2 C20,12.3175049 19.2824951,11.6 18.4,11.6 L16.8,11.6 C16.3600098,11.6 15.9625,11.7774902 15.6725098,12.0649902 C16.6800049,12.6175049 17.3949951,13.6149902 17.55,14.8 L19.2,14.8 Z M6.44750977,14.8 C6.60500488,13.6149902 7.31999512,12.6175049 8.32749023,12.0649902 C8.0375,11.7774902 7.63999023,11.6 7.2,11.6 L5.6,11.6 C4.71750488,11.6 4,12.3175049 4,13.2 L4,14 C4,14.4425049 4.35749512,14.8 4.8,14.8 L6.44750977,14.8 Z M15.6,17.2 C16.2625,17.2 16.8,16.6625 16.8,16 L16.8,15.2800049 C16.8,13.6899902 15.5100098,12.4 13.9199951,12.4 L13.7125,12.4 C13.1925049,12.65 12.6149902,12.8 12,12.8 C11.3850098,12.8 10.8100098,12.65 10.2875,12.4 L10.0800049,12.4 C8.48999023,12.4 7.2,13.6899902 7.2,15.2800049 L7.2,16 C7.2,16.6625 7.7375,17.2 8.4,17.2 L15.6,17.2 Z"
  },
  "arrow-down": {
    title: "Icon/Arrow/Down",
    data: "M12.6046052,17.8062664 L17.8111741,12.4644026 C18.062942,12.2088282 18.062942,11.7911718 17.8111741,11.5328603 L12.6046052,6.19373363 C12.3555313,5.93542212 11.9484289,5.93542212 11.6966871,6.19373363 L11.1021058,6.8037685 C10.8450023,7.06481715 10.8503379,7.49073865 11.1128293,7.74628618 L14.3401456,10.9008478 L6.64278498,10.9008478 C6.2865802,10.9008478 6,11.1948763 6,11.5603391 L6,12.4396609 C6,12.8051237 6.2865802,13.0991522 6.64278498,13.0991522 L14.3401456,13.0991522 L11.1128293,16.2537138 C10.8530319,16.5092614 10.8476701,16.9351828 11.1021058,17.1962315 L11.6966871,17.8062664 C11.9457611,18.0645779 12.3528635,18.0645779 12.6046052,17.8062664 Z",
    transform: "translate(12.000000, 12.000000) rotate(90.000000) translate(-12.000000, -12.000000) "
  },
  "arrow-left": {
    title: "Icon/Arrow/Left",
    data: "M12.6046052,17.8062664 L17.8111741,12.4644026 C18.062942,12.2088282 18.062942,11.7911718 17.8111741,11.5328603 L12.6046052,6.19373363 C12.3555313,5.93542212 11.9484289,5.93542212 11.6966871,6.19373363 L11.1021058,6.8037685 C10.8450023,7.06481715 10.8503379,7.49073865 11.1128293,7.74628618 L14.3401456,10.9008478 L6.64278498,10.9008478 C6.2865802,10.9008478 6,11.1948763 6,11.5603391 L6,12.4396609 C6,12.8051237 6.2865802,13.0991522 6.64278498,13.0991522 L14.3401456,13.0991522 L11.1128293,16.2537138 C10.8530319,16.5092614 10.8476701,16.9351828 11.1021058,17.1962315 L11.6966871,17.8062664 C11.9457611,18.0645779 12.3528635,18.0645779 12.6046052,17.8062664 Z",
    transform: "translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) "
  },
  "arrow-right": {
    title: "Icon/Arrow/Right",
    data: "M12.6046052,17.8062664 L17.8111741,12.4644026 C18.062942,12.2088282 18.062942,11.7911718 17.8111741,11.5328603 L12.6046052,6.19373363 C12.3555313,5.93542212 11.9484289,5.93542212 11.6966871,6.19373363 L11.1021058,6.8037685 C10.8450023,7.06481715 10.8503379,7.49073865 11.1128293,7.74628618 L14.3401456,10.9008478 L6.64278498,10.9008478 C6.2865802,10.9008478 6,11.1948763 6,11.5603391 L6,12.4396609 C6,12.8051237 6.2865802,13.0991522 6.64278498,13.0991522 L14.3401456,13.0991522 L11.1128293,16.2537138 C10.8530319,16.5092614 10.8476701,16.9351828 11.1021058,17.1962315 L11.6966871,17.8062664 C11.9457611,18.0645779 12.3528635,18.0645779 12.6046052,17.8062664 Z"
  },
  "arrow-up": {
    title: "Icon/Arrow/Right",
    data: "M12.6046052,17.8062664 L17.8111741,12.4644026 C18.062942,12.2088282 18.062942,11.7911718 17.8111741,11.5328603 L12.6046052,6.19373363 C12.3555313,5.93542212 11.9484289,5.93542212 11.6966871,6.19373363 L11.1021058,6.8037685 C10.8450023,7.06481715 10.8503379,7.49073865 11.1128293,7.74628618 L14.3401456,10.9008478 L6.64278498,10.9008478 C6.2865802,10.9008478 6,11.1948763 6,11.5603391 L6,12.4396609 C6,12.8051237 6.2865802,13.0991522 6.64278498,13.0991522 L14.3401456,13.0991522 L11.1128293,16.2537138 C10.8530319,16.5092614 10.8476701,16.9351828 11.1021058,17.1962315 L11.6966871,17.8062664 C11.9457611,18.0645779 12.3528635,18.0645779 12.6046052,17.8062664 Z",
    transform: "translate(12.000000, 12.000000) rotate(-90.000000) translate(-12.000000, -12.000000)"
  },
  "balls-soccer": {
    title: "Icon/Balls/Soccer",
    data: "M7.997 15.758c.794 0 1.601-.122 2.4-.382 4.072-1.323 6.302-5.7 4.98-9.772C14.312 2.326 11.271.242 8.002.242c-.794 0-1.601.122-2.4.382-4.072 1.323-6.302 5.7-4.98 9.772 1.064 3.279 4.105 5.362 7.374 5.362zm2.512-9.11L8.5 5.195V2.886l1.482-.82c1.226.407 2.296 1.189 3.063 2.234l-.326 1.66-2.211.689zm-5.018 0l-2.208-.687-.316-1.643c.76-1.044 1.811-1.833 3.06-2.249l1.472.817v2.308L5.491 6.65zm5.922 5.216l-1.367-1.906.763-2.352 2.224-.691 1.217 1.138c-.006.96-.231 1.912-.679 2.79-.147.292-.334.558-.525.82l-1.633.2zm-6.823 0l-1.66-.204c-.451-.629-1.168-1.864-1.183-3.607l1.22-1.138 2.224.694.76 2.324-1.36 1.93zm1.508 2.095l-.7-1.504 1.363-1.93H9.22l1.386 1.93-.7 1.504c-.195.057-1.803.639-3.808 0z",
    transform: "translate(4 4)"
  },
  bookmark: {
    title: "Icon/Bookmark",
    data: "M17,4 C17.5522847,4 18,4.44771525 18,5 L18,18.1314829 C18,18.6837677 17.5522847,19.1315892 17,19.1315892 C16.802575,19.1315892 16.6095673,19.0730449 16.4452998,18.9635332 L12.5547002,16.3698001 C12.2188008,16.1458672 11.7811992,16.1458672 11.4452998,16.3698001 L7.5547002,18.9635332 C7.09517151,19.2698857 6.47430216,19.1457118 6.16794971,18.6861831 C6.05843803,18.5219156 6,18.3289079 6,18.1314829 L6,5 C6,4.44771525 6.44771525,4 7,4 L17,4 Z M16.5,5.5 L7.5,5.5 L7.5,17.196 L10.6132495,15.1217247 C11.4005138,14.5968819 12.4112447,14.5640792 13.2264422,15.0233167 L13.3867505,15.1217247 L16.5,17.197 L16.5,5.5 Z"
  },
  calendar: {
    title: "Icon/Calendar",
    data: "M16,3 C16.5522847,3 17,3.44335318 17,4.0093689 L17,5 L20,5 L20,19.2221278 C20,20.2040195 19.2065575,21 18.2265873,21 L5.7734127,21 C4.79398391,21 4,20.208837 4,19.2221278 L4,5 L7,5 L7,4.0093689 C7,3.49172835 7.38272018,3.06509707 7.88266744,3.00679076 L8,3 C8.55228475,3 9,3.44335318 9,4.0093689 L9,5 L15,5 L15,4.0093689 C15,3.49172835 15.3827202,3.06509707 15.8826674,3.00679076 L16,3 Z M17.9999978,10 L6,10 L6,18.9999044 L18,19 L18,19 L17.9999999,18.9874231 L17.9999999,18.9874231 L17.9999978,10 L17.9999978,10 Z M11,14 L11,18 L7,18 L7,14 L11,14 Z"
  },
  camera: {
    title: "Icon/Camera",
    data: "M14.2,6.4 C14.7522847,6.4 15.2,6.84771525 15.2,7.4 L15.2,7.8 C15.2,7.86877376 15.1930574,7.935926 15.1798348,8.0007941 L19,8 C19.5522847,8 20,8.44771525 20,9 L20,16.6 C20,17.1522847 19.5522847,17.6 19,17.6 L5,17.6 C4.44771525,17.6 4,17.1522847 4,16.6 L4,9 C4,8.44771525 4.44771525,8 5,8 L5.6,8 L5.6,8 C5.6,7.5581722 5.9581722,7.2 6.4,7.2 L7.2,7.2 C7.6418278,7.2 8,7.5581722 8,8 L8.82016515,8.0007941 C8.80694259,7.935926 8.8,7.86877376 8.8,7.8 L8.8,7.4 C8.8,6.84771525 9.24771525,6.4 9.8,6.4 L14.2,6.4 Z M12,9.6 C10.2326888,9.6 8.8,11.0326888 8.8,12.8 C8.8,14.5673112 10.2326888,16 12,16 C13.7673112,16 15.2,14.5673112 15.2,12.8 C15.2,11.0326888 13.7673112,9.6 12,9.6 Z M12,11.2 C12.8836556,11.2 13.6,11.9163444 13.6,12.8 C13.6,13.6836556 12.8836556,14.4 12,14.4 C11.1163444,14.4 10.4,13.6836556 10.4,12.8 C10.4,11.9163444 11.1163444,11.2 12,11.2 Z M18.8,8.8 L18,8.8 C17.7790861,8.8 17.6,8.9790861 17.6,9.2 C17.6,9.4209139 17.7790861,9.6 18,9.6 L18,9.6 L18.8,9.6 C19.0209139,9.6 19.2,9.4209139 19.2,9.2 C19.2,8.9790861 19.0209139,8.8 18.8,8.8 L18.8,8.8 Z"
  },
  chart: {
    title: "Icon/Chart",
    data: "M12.9906311,5 C13.5480902,5 14,5.44994876 14,6.00684547 L14,17.9931545 C14,18.5492199 13.5566468,19 12.9906311,19 L11.0093689,19 C10.4519098,19 10,18.5500512 10,17.9931545 L10,6.00684547 C10,5.45078007 10.4433532,5 11.0093689,5 L12.9906311,5 Z M18.9906311,10.6 C19.5480902,10.6 20,11.0516205 20,11.5965765 L20,18.0034235 C20,18.5538175 19.5566468,19 18.9906311,19 L17.0093689,19 C16.4519098,19 16,18.5483795 16,18.0034235 L16,11.5965765 C16,11.0461825 16.4433532,10.6 17.0093689,10.6 L18.9906311,10.6 Z M6.9906311,13.4 C7.54809015,13.4 8,13.8394226 8,14.4011678 L8,17.9988322 C8,18.5517619 7.55664682,19 6.9906311,19 L5.0093689,19 C4.45190985,19 4,18.5605774 4,17.9988322 L4,14.4011678 C4,13.8482381 4.44335318,13.4 5.0093689,13.4 L6.9906311,13.4 Z"
  },
  check: {
    title: "Icon/Check",
    data: "M9.25233483,17.5031873 C9.50770676,17.5024904 9.762707,17.4040267 9.95789419,17.2088395 L19.8561564,7.31057724 C20.2494781,6.9172556 20.2472971,6.28627161 19.8567728,5.89574732 C19.4635258,5.50250036 18.8328076,5.50549898 18.4419429,5.89636367 L9.25017106,15.0881355 L5.71253714,11.5505016 C5.32787542,11.1658398 4.69094788,11.1620773 4.30042359,11.5526016 C3.90717663,11.9458485 3.90895909,12.5753506 4.29832358,12.9647151 L8.54516429,17.2115558 C8.73749541,17.4038869 8.99289315,17.500993 9.24902364,17.5012006 L9.25233483,17.5031873 Z"
  },
  "checkbox-unselected": {
    title: "Icon/Checkbox/Unselected",
    data: "M20.007 3c.548 0 .993.445.993.993v16.014c0 .548-.445.993-.993.993H3.993C3.445 21 3 20.555 3 20.007V3.993C3 3.445 3.445 3 3.993 3h16.014zM19 5H5v14h14V5z"
  },
  "chevron-down": {
    title: "Icon/Chevron/Down",
    data: "M17.8853024,7.75280837 C18.2558672,7.34869564 18.8624474,7.33659022 19.2527612,7.73877806 L19.3035081,7.79106874 C19.6881699,8.18743274 19.6947663,8.84161634 19.3226345,9.24743794 L12.8910266,16.2613113 C12.516928,16.6692778 11.9017056,16.6783029 11.513369,16.2778395 L4.70029212,9.2520073 C4.31353146,8.85316907 4.29773987,8.20540565 4.67729659,7.79181032 L4.72664487,7.73803649 C5.10070545,7.33043019 5.71242237,7.318114 6.10294261,7.72082921 L12.1738563,13.9813224 L17.8853024,7.75280837 Z"
  },
  "chevron-left": {
    title: "Icon/Chevron/Left",
    data: "M17.8853024,7.75280837 C18.2558672,7.34869564 18.8624474,7.33659022 19.2527612,7.73877806 L19.3035081,7.79106874 C19.6881699,8.18743274 19.6947663,8.84161634 19.3226345,9.24743794 L12.8910266,16.2613113 C12.516928,16.6692778 11.9017056,16.6783029 11.513369,16.2778395 L4.70029212,9.2520073 C4.31353146,8.85316907 4.29773987,8.20540565 4.67729659,7.79181032 L4.72664487,7.73803649 C5.10070545,7.33043019 5.71242237,7.318114 6.10294261,7.72082921 L12.1738563,13.9813224 L17.8853024,7.75280837 Z",
    transform: "translate(12.000000, 12.000000) rotate(90.000000) translate(-12.000000, -12.000000) "
  },
  "chevron-right": {
    title: "Icon/Chevron/Right",
    data: "M17.8853024,7.75280837 C18.2558672,7.34869564 18.8624474,7.33659022 19.2527612,7.73877806 L19.3035081,7.79106874 C19.6881699,8.18743274 19.6947663,8.84161634 19.3226345,9.24743794 L12.8910266,16.2613113 C12.516928,16.6692778 11.9017056,16.6783029 11.513369,16.2778395 L4.70029212,9.2520073 C4.31353146,8.85316907 4.29773987,8.20540565 4.67729659,7.79181032 L4.72664487,7.73803649 C5.10070545,7.33043019 5.71242237,7.318114 6.10294261,7.72082921 L12.1738563,13.9813224 L17.8853024,7.75280837 Z",
    transform: "translate(12.000000, 12.000000) rotate(-90.000000) translate(-12.000000, -12.000000) "
  },
  "chevron-up": {
    title: "Icon/Chevron/Up",
    data: "M17.8853024,7.75280837 C18.2558672,7.34869564 18.8624474,7.33659022 19.2527612,7.73877806 L19.3035081,7.79106874 C19.6881699,8.18743274 19.6947663,8.84161634 19.3226345,9.24743794 L12.8910266,16.2613113 C12.516928,16.6692778 11.9017056,16.6783029 11.513369,16.2778395 L4.70029212,9.2520073 C4.31353146,8.85316907 4.29773987,8.20540565 4.67729659,7.79181032 L4.72664487,7.73803649 C5.10070545,7.33043019 5.71242237,7.318114 6.10294261,7.72082921 L12.1738563,13.9813224 L17.8853024,7.75280837 Z",
    transform: "translate(12.000000, 12.000000) rotate(180.000000) translate(-12.000000, -12.000000) "
  },
  clock: {
    title: "Icon/Clock",
    data: "M12,20 C16.4193548,20 20,16.4193548 20,12 C20,7.58064516 16.4193548,4 12,4 C7.58064516,4 4,7.58064516 4,12 C4,16.4193548 7.58064516,20 12,20 Z M12,18.4516129 C8.43548387,18.4516129 5.5483871,15.5645161 5.5483871,12 C5.5483871,8.43548387 8.43548387,5.5483871 12,5.5483871 C15.5645161,5.5483871 18.4516129,8.43548387 18.4516129,12 C18.4516129,15.5645161 15.5645161,18.4516129 12,18.4516129 Z M14.5354713,15 L15.1419481,14.1645035 C15.2677356,13.9903289 15.2322644,13.7483934 15.0580582,13.6225743 L12.9032258,12.054845 L12.9032258,7.48387097 C12.9032258,7.27098034 12.7290197,7.09677419 12.516129,7.09677419 L11.483871,7.09677419 C11.2709803,7.09677419 11.0967742,7.27098034 11.0967742,7.48387097 L11.0967742,12.7806515 C11.0967742,12.9032258 11.1548324,13.0193422 11.2548513,13.093561 L13.9935421,15.0838584 C14.1677482,15.2096774 14.4096837,15.1709614 14.5354713,15 Z"
  },
  copy: {
    title: "Icon/Copy",
    data: "M18,8 C18.5522847,8 19,8.44771525 19,9 L19,19 C19,19.5522847 18.5522847,20 18,20 L10,20 C9.44771525,20 9,19.5522847 9,19 L9,9 C9,8.44771525 9.44771525,8 10,8 L18,8 Z M17.5,9.5 L10.5,9.5 L10.5,18.5 L17.5,18.5 L17.5,9.5 Z M14,4 C14.5522847,4 15,4.44771525 15,5 L15,7 L13.5,7 L13.5,5.5 L6.5,5.5 L6.5,14.5 L8,14.5 L8,16 L6,16 C5.44771525,16 5,15.5522847 5,15 L5,5 C5,4.44771525 5.44771525,4 6,4 L14,4 Z"
  },
  delete: {
    title: "Icon/Delete",
    data: "M18,8 L17.0835394,18.9975267 C17.0374019,19.5511774 16.5443356,20 16.0046024,20 L7.99539757,20 C7.44565467,20 6.96201992,19.544239 6.91646056,18.9975267 L6,8 L18,8 Z M14,4 L15,5 L17.9931545,5 C18.509501,5 18.9350657,5.38272018 18.9932262,5.88266744 L19,6 C19,6.55228475 18.5500512,7 17.9931545,7 L6.00684547,7 C5.45078007,7 5,6.55613518 5,6 C5,5.44771525 5.44994876,5 6.00684547,5 L9,5 L10,4 L14,4 Z"
  },
  download: {
    title: "Icon/Download",
    data: "M20,15 C20.5522847,15 21,15.4477153 21,16 L21,18 C21,19.1045695 20.1045695,20 19,20 L5,20 C3.8954305,20 3,19.1045695 3,18 L3,16 C3,15.4477153 3.44771525,15 4,15 C4.55228475,15 5,15.4477153 5,16 L5,18 L19,18 L19,16 C19,15.4477153 19.4477153,15 20,15 Z M12.4396609,4 C12.8051237,4 13.0991522,4.2865802 13.0991522,4.64278498 L13.0991522,4.64278498 L13.0991522,12.3401456 L16.2537138,9.11282935 C16.5092614,8.85033789 16.9351828,8.84500227 17.1962315,9.1021058 L17.1962315,9.1021058 L17.8062664,9.69668714 C18.0645779,9.9484289 18.0645779,10.3555313 17.8062664,10.6046052 L17.8062664,10.6046052 L12.4671397,15.8111741 C12.2088282,16.062942 11.7911718,16.062942 11.5355974,15.8111741 L11.5355974,15.8111741 L6.19373363,10.6046052 C5.93542212,10.3528635 5.93542212,9.94576109 6.19373363,9.69668714 L6.19373363,9.69668714 L6.8037685,9.1021058 C7.06481715,8.84767008 7.49073865,8.85303185 7.74628618,9.11282935 L7.74628618,9.11282935 L10.9008478,12.3401456 L10.9008478,4.64278498 C10.9008478,4.2865802 11.1948763,4 11.5603391,4 L11.5603391,4 Z"
  },
  edit: {
    title: "Icon/Edit",
    data: "M20.9906311,10 C21.5480902,10 22,10.4433532 22,11.0093689 L22,12.9906311 C22,13.5480902 21.5566468,14 20.9906311,14 L18,14 L18,10 L20.9906311,10 Z M17,10 L17,14 L4.33333333,14 L2,12 L4.33333333,10 L17,10 Z",
    transform: "translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) "
  },
  error: {
    title: "Icon/Error",
    data: "M14.7239112,3 C15.2856837,3 16.0482072,3.31820719 16.4407356,3.71073565 L16.4407356,3.71073565 L20.2892644,7.55926435 C20.6861197,7.95611974 21,8.7204413 21,9.27608879 L21,9.27608879 L21,14.7239112 C21,15.2856837 20.6817928,16.0482072 20.2892644,16.4407356 L20.2892644,16.4407356 L16.4407356,20.2892644 C16.0438803,20.6861197 15.2795587,21 14.7239112,21 L14.7239112,21 L9.27608879,21 C8.71431627,21 7.95179281,20.6817928 7.55926435,20.2892644 L7.55926435,20.2892644 L3.71073565,16.4407356 C3.31388026,16.0438803 3,15.2795587 3,14.7239112 L3,14.7239112 L3,9.27608879 C3,8.71431627 3.31820719,7.95179281 3.71073565,7.55926435 L3.71073565,7.55926435 L7.55926435,3.71073565 C7.95611974,3.31388026 8.7204413,3 9.27608879,3 L9.27608879,3 Z M12,15 C11.4871642,15 11.0644928,15.3827202 11.0067277,15.8826674 L11,16 C11,16.5128358 11.3827202,16.9355072 11.8826674,16.9932723 L12,17 C12.5522847,17 13,16.5561352 13,16 C13,15.4871642 12.6172798,15.0644928 12.1173326,15.0067277 L12,15 Z M12,7 C11.4477153,7 11,7.43788135 11,8.00292933 L11,12.9970707 C11,13.5114088 11.3827202,13.9353182 11.8826674,13.9932526 L12,14 C12.5522847,14 13,13.5621186 13,12.9970707 L13,8.00292933 C13,7.48859123 12.6172798,7.06468176 12.1173326,7.00674744 L12,7 Z"
  },
  export: {
    title: "Icon/Export",
    data: "M10.9428571,7.2 L8.37142857,9.23636364 L6.05714286,9.23636364 L6.05714286,16.3636364 L16.3428571,16.3636364 L16.3428571,14.3272727 L18.4,12.6981818 L18.4,18.4 L4,18.4 L4,7.2 L10.9428571,7.2 Z M15.0137123,5.6 L20,9.50114153 L15.0137123,13.4022831 L15.0137123,10.5438038 C11.6898529,10.4277449 9.68935428,12.7907791 8,14.4 C8,10.5749307 11.4834206,8.63077321 15.0137123,8.59663822 L15.0137123,8.59663822 L15.0137123,5.6 Z"
  },
  flag: {
    title: "Icon/Flag",
    data: "M5.0237978,4 L5.13603865,4.0060158 C5.65173847,4.06167685 6.0475956,4.4967501 6.0475956,5.02521157 L6.046,5 L13.2376768,5 C13.7901279,5 14.3660643,5.43788135 14.5183941,5.95864271 L15.115,8 L19.3753848,8 C19.9306408,8 20.1616362,8.38696043 19.885099,8.87529901 L18.3331692,11.6158607 L16.8022684,14.1460388 C16.5169058,14.6176685 15.8437995,15 15.2849573,15 L10.1427868,15 L9.265,12 L6.047,12 L6.0475956,18.9747884 C6.0475956,19.5008318 5.6483045,19.9380007 5.13535185,19.993952 L5.0237978,20 L4.91155696,19.9939842 C4.39585713,19.9383231 4,19.5032499 4,18.9747884 L4,18.9747884 L4,5 C4.01366567,4.44795794 4.46678399,4 5.0237978,4 L5.0237978,4 Z"
  },
  globe: {
    title: "Icon/Globe",
    data: "M12,20 C16.4193548,20 20,16.4193548 20,12 C20,7.58064516 16.4193548,4 12,4 C7.58064516,4 4,7.58064516 4,12 C4,16.4193548 7.58064516,20 12,20 Z M14.038716,9.16129032 L9.96128402,9.16129032 C10.4322707,6.87742566 11.4000126,5.5483871 12,5.5483871 C12.5999874,5.5483871 13.5677293,6.87742566 14.038716,9.16129032 Z M17.7838647,9.16129032 L15.6161164,9.16129032 C15.4000126,7.98387097 15.0516003,6.94194178 14.60969,6.10644531 C15.9935421,6.71934854 17.1161164,7.80645161 17.7838647,9.16129032 Z M8.38388357,9.16129032 L6.21613533,9.16129032 C6.88388357,7.80645161 8.00645791,6.71934854 9.39030998,6.10644531 C8.9483997,6.94194178 8.5999874,7.98387097 8.38388357,9.16129032 Z M8.18387727,13.2903226 L5.67741935,13.2903226 C5.59356099,12.8741809 5.5483871,12.4419418 5.5483871,12 C5.5483871,11.5580582 5.59356099,11.1258191 5.67741935,10.7096774 L8.18387727,10.7096774 C8.1516192,11.1322455 8.12903226,11.5580582 8.12903226,12 C8.12903226,12.4419418 8.1516192,12.8677545 8.18387727,13.2903226 Z M14.2612777,13.2903226 L9.73872228,13.2903226 C9.70321951,12.8774257 9.67741935,12.4516129 9.67741935,12 C9.67741935,11.5483871 9.70321951,11.1225743 9.73872228,10.7096774 L14.2645224,10.7096774 C14.2999937,11.1225743 14.3257939,11.5483871 14.3257939,12 C14.3257939,12.4516129 14.2967805,12.8774257 14.2612777,13.2903226 Z M18.3225806,13.2903226 L15.8161227,13.2903226 C15.8483808,12.8677545 15.8709677,12.4419418 15.8709677,12 C15.8709677,11.5580582 15.8483808,11.1322455 15.8161227,10.7096774 L18.3225806,10.7096774 C18.406439,11.1258191 18.4516129,11.5580582 18.4516129,12 C18.4516129,12.4419418 18.406439,12.8741809 18.3225806,13.2903226 Z M9.39030998,17.8935547 C8.00645791,17.2806515 6.88388357,16.1935484 6.21613533,14.8387097 L8.38388357,14.8387097 C8.5999874,16.016129 8.9483997,17.0580582 9.39030998,17.8935547 Z M12,18.4516129 C11.4000126,18.4516129 10.4322707,17.1225743 9.96128402,14.8387097 L14.0419292,14.8387097 C13.5677293,17.1225743 12.5999874,18.4516129 12,18.4516129 Z M14.60969,17.8935547 C15.0516003,17.0580582 15.3967679,16.016129 15.6161164,14.8387097 L17.7838647,14.8387097 C17.1161164,16.1935484 15.9935421,17.2806515 14.60969,17.8935547 Z"
  },
  handle: {
    title: "Icon/Handle",
    data: "M9,16 C10.1045695,16 11,16.8954305 11,18 C11,19.1045695 10.1045695,20 9,20 C7.8954305,20 7,19.1045695 7,18 C7,16.8954305 7.8954305,16 9,16 Z M15,16 C16.1045695,16 17,16.8954305 17,18 C17,19.1045695 16.1045695,20 15,20 C13.8954305,20 13,19.1045695 13,18 C13,16.8954305 13.8954305,16 15,16 Z M9,10 C10.1045695,10 11,10.8954305 11,12 C11,13.1045695 10.1045695,14 9,14 C7.8954305,14 7,13.1045695 7,12 C7,10.8954305 7.8954305,10 9,10 Z M15,10 C16.1045695,10 17,10.8954305 17,12 C17,13.1045695 16.1045695,14 15,14 C13.8954305,14 13,13.1045695 13,12 C13,10.8954305 13.8954305,10 15,10 Z M9,4 C10.1045695,4 11,4.8954305 11,6 C11,7.1045695 10.1045695,8 9,8 C7.8954305,8 7,7.1045695 7,6 C7,4.8954305 7.8954305,4 9,4 Z M15,4 C16.1045695,4 17,4.8954305 17,6 C17,7.1045695 16.1045695,8 15,8 C13.8954305,8 13,7.1045695 13,6 C13,4.8954305 13.8954305,4 15,4 Z"
  },
  info: {
    title: "Icon/Info",
    data: "M12,4 C16.418278,4 20,7.581722 20,12 C20,16.418278 16.418278,20 12,20 C7.581722,20 4,16.418278 4,12 C4,7.581722 7.581722,4 12,4 Z M13.347541,9.90491803 L11.1311475,9.90491803 L11.1311475,17 L13.347541,17 L13.347541,9.90491803 Z M12.2262295,7 C11.8633862,7 11.5683071,7.10054544 11.3409836,7.30163934 C11.1136601,7.50273325 11,7.76065416 11,8.07540984 C11,8.39016551 11.1136601,8.64808643 11.3409836,8.84918033 C11.5683071,9.05027423 11.8633862,9.15081967 12.2262295,9.15081967 C12.5890729,9.15081967 12.8841519,9.05027423 13.1114754,8.84918033 C13.338799,8.64808643 13.452459,8.39016551 13.452459,8.07540984 C13.452459,7.76065416 13.338799,7.50273325 13.1114754,7.30163934 C12.8841519,7.10054544 12.5890729,7 12.2262295,7 Z"
  },
  loading: {
    title: "Icon/Loading",
    data: "M12,21 C16.9705627,21 21,16.9705627 21,12 C21,7.02943725 16.9705627,3 12,3 C7.02943725,3 3,7.02943725 3,12 C3,13.3011467 3.27691302,14.5651197 3.80497814,15.7251626 C4.03379272,16.2278179 4.6267662,16.4498096 5.12942149,16.220995 C5.63207677,15.9921804 5.85406852,15.399207 5.62525394,14.8965517 C5.2150448,13.9954124 5,13.0138378 5,12 C5,8.13400675 8.13400675,5 12,5 C15.8659932,5 19,8.13400675 19,12 C19,15.8659932 15.8659932,19 12,19 C11.4477153,19 11,19.4477153 11,20 C11,20.5522847 11.4477153,21 12,21 Z"
  },
  "order-first": {
    title: "Icon/Order/First",
    data: "M6.5,4 C7.05228475,4 7.5,4.44463086 7.5,5.00087166 L7.5,18.9991283 C7.5,19.5124112 7.11727982,19.9354509 6.61733256,19.9932664 L6.5,20 C5.94771525,20 5.5,19.5553691 5.5,18.9991283 L5.5,5.00087166 C5.5,4.4875888 5.88272018,4.06454906 6.38266744,4.0067336 L6.5,4 Z M17.7081897,4.67729659 L17.7619635,4.72664487 C18.1695698,5.10070545 18.181886,5.71242237 17.7791708,6.10294261 L11.5186776,12.1738563 L17.7471916,17.8853024 C18.1513044,18.2558672 18.1634098,18.8624474 17.7612219,19.2527612 L17.7089313,19.3035081 C17.3125673,19.6881699 16.6583837,19.6947663 16.2525621,19.3226345 L9.23868869,12.8910266 C8.83072219,12.516928 8.82169709,11.9017056 9.2221605,11.513369 L16.2479927,4.70029212 C16.6468309,4.31353146 17.2945944,4.29773987 17.7081897,4.67729659 Z"
  },
  "order-last": {
    title: "Icon/Order/Last",
    data: "M6.5,4 C7.05228475,4 7.5,4.44463086 7.5,5.00087166 L7.5,18.9991283 C7.5,19.5124112 7.11727982,19.9354509 6.61733256,19.9932664 L6.5,20 C5.94771525,20 5.5,19.5553691 5.5,18.9991283 L5.5,5.00087166 C5.5,4.4875888 5.88272018,4.06454906 6.38266744,4.0067336 L6.5,4 Z M17.7081897,4.67729659 L17.7619635,4.72664487 C18.1695698,5.10070545 18.181886,5.71242237 17.7791708,6.10294261 L11.5186776,12.1738563 L17.7471916,17.8853024 C18.1513044,18.2558672 18.1634098,18.8624474 17.7612219,19.2527612 L17.7089313,19.3035081 C17.3125673,19.6881699 16.6583837,19.6947663 16.2525621,19.3226345 L9.23868869,12.8910266 C8.83072219,12.516928 8.82169709,11.9017056 9.2221605,11.513369 L16.2479927,4.70029212 C16.6468309,4.31353146 17.2945944,4.29773987 17.7081897,4.67729659 Z",
    transform: "translate(11.787269, 12.000000) scale(-1, 1) translate(-11.787269, -12.000000) "
  },
  overflow: {
    title: "Icon/Overflow",
    data: "M12,16 C13.1045695,16 14,16.8954305 14,18 C14,19.1045695 13.1045695,20 12,20 C10.8954305,20 10,19.1045695 10,18 C10,16.8954305 10.8954305,16 12,16 Z M12,10 C13.1045695,10 14,10.8954305 14,12 C14,13.1045695 13.1045695,14 12,14 C10.8954305,14 10,13.1045695 10,12 C10,10.8954305 10.8954305,10 12,10 Z M12,4 C13.1045695,4 14,4.8954305 14,6 C14,7.1045695 13.1045695,8 12,8 C10.8954305,8 10,7.1045695 10,6 C10,4.8954305 10.8954305,4 12,4 Z",
    transform: "translate(12.000000, 12.000000) rotate(-270.000000) translate(-12.000000, -12.000000) "
  },
  plus: {
    title: "Icon/Plus",
    data: "M12,4 L12.1173326,4.0067336 C12.6172798,4.06454906 13,4.4875888 13,5.00087166 L13,5.00087166 L13,11 L18.9991283,11 C19.5124112,11 19.9354509,11.3827202 19.9932664,11.8826674 L20,12 C20,12.5522847 19.5553691,13 18.9991283,13 L13,13 L13,18.9991283 C13,19.5156377 12.6139598,19.9359119 12.1166211,19.9933158 L12,20 L11.8826674,19.9932664 C11.3827202,19.9354509 11,19.5124112 11,18.9991283 L11,18.9991283 L11,13 L5.00087166,13 C4.4875888,13 4.06454906,12.6172798 4.0067336,12.1173326 L4,12 C4,11.4477153 4.44463086,11 5.00087166,11 L11,10.999 L11,5.00087166 C11,4.48436235 11.3860402,4.06408813 11.8833789,4.00668421 L12,4 Z"
  },
  question: {
    title: "Icon/Question",
    data: "M12,4 C16.418278,4 20,7.581722 20,12 C20,16.418278 16.418278,20 12,20 C7.581722,20 4,16.418278 4,12 C4,7.581722 7.581722,4 12,4 Z M12.1223958,14.5434028 C11.7983201,14.5434028 11.5279235,14.6396113 11.3111979,14.8320313 C11.0944723,15.0244512 10.9861111,15.2705425 10.9861111,15.5703125 C10.9861111,15.8700825 11.0944723,16.1161738 11.3111979,16.3085938 C11.5279235,16.5010137 11.7983201,16.5972222 12.1223958,16.5972222 C12.4464715,16.5972222 12.7168681,16.5010137 12.9335938,16.3085938 C13.1503194,16.1161738 13.2586806,15.8700825 13.2586806,15.5703125 C13.2586806,15.2705425 13.1503194,15.0244512 12.9335938,14.8320313 C12.7168681,14.6396113 12.4464715,14.5434028 12.1223958,14.5434028 Z M12.2135417,7.55555556 C11.3061297,7.55555556 10.6012757,7.78139242 10.0989583,8.23307292 C9.59664101,8.68475342 9.34143523,9.31567882 9.33333333,10.1258681 L9.33333333,10.1258681 L11.3871528,10.1258681 C11.3952547,9.82204709 11.4742469,9.58101941 11.6241319,9.40277778 C11.774017,9.22453615 11.9704849,9.13541667 12.2135417,9.13541667 C12.7401647,9.13541667 13.0034722,9.44125852 13.0034722,10.0529514 C13.0034722,10.3041101 12.9254927,10.5339978 12.7695312,10.7426215 C12.6135698,10.9512453 12.3857075,11.181133 12.0859375,11.4322917 C11.7861675,11.6834503 11.5694451,11.9801777 11.4357639,12.3224826 C11.3020827,12.6647876 11.2352431,13.1316521 11.2352431,13.7230903 L11.2352431,13.7230903 L12.9730903,13.7230903 C12.9811922,13.4152184 13.0237265,13.1610253 13.1006944,12.9605035 C13.1776624,12.7599816 13.3153925,12.5645264 13.5138889,12.3741319 L13.5138889,12.3741319 L14.2126736,11.7239583 C14.5083927,11.4363412 14.7230896,11.1548046 14.8567708,10.8793403 C14.9904521,10.6038759 15.0572917,10.2980341 15.0572917,9.96180556 C15.0572917,9.19212578 14.8091749,8.59867107 14.312934,8.18142361 C13.8166931,7.76417615 13.1169027,7.55555556 12.2135417,7.55555556 Z"
  },
  refresh: {
    title: "Icon/Refresh",
    data: "M12.1219115,4.58742731 L12.1219229,6.17859491 C15.842467,6.28943255 18.8245241,9.34033688 18.8245241,13.087738 C18.8245241,16.9052749 15.7297989,20 11.912262,20 C8.09472513,20 5,16.9052749 5,13.087738 L5,13.087738 L6.97493201,13.087738 C6.97493201,15.81455 9.18544996,18.025068 11.912262,18.025068 C14.6390741,18.025068 16.8495921,15.81455 16.8495921,13.087738 C16.8495921,10.3609259 14.6390741,8.15040794 11.912262,8.15040794 L12.121,8.154 L12.1219115,9.91088906 C12.1219115,10.4654104 11.8093692,10.6023963 11.4151122,10.2081393 L9.16293038,7.95595754 C8.77257587,7.56560303 8.7686734,6.9366158 9.16293038,6.54235882 L11.4151122,4.29017702 C11.8054667,3.89982251 12.1219115,4.03096322 12.1219115,4.58742731 Z",
    transform: "translate(11.912262, 12.000000) scale(-1, 1) translate(-11.912262, -12.000000) "
  },
  save: {
    title: "Icon/Save",
    data: "M16,4 L20,8 L20,18.9975267 C20,19.5511774 19.5553691,20 18.9991283,20 L5.00087166,20 C4.4481055,20 4,19.5553691 4,18.9991283 L4,5.00087166 C4,4.4481055 4.45576096,4 5.00247329,4 L16,4 Z M12.5,13 C11.1192881,13 10,14.1192881 10,15.5 C10,16.8807119 11.1192881,18 12.5,18 C13.8807119,18 15,16.8807119 15,15.5 C15,14.1192881 13.8807119,13 12.5,13 Z M14,6 L6,6 L6,10 L14,10 L14,6 Z M13,7 L13,9 L11,9 L11,7 L13,7 Z"
  },
  search: {
    title: "Icon/Search",
    data: "M9.36301871,4 C12.3249322,4 14.7260374,6.40110526 14.7260374,9.36301871 C14.7260374,10.6809771 14.2506258,11.8878971 13.4619371,12.821644 L14.5025379,13.8620847 C14.7983754,13.7833813 15.1242944,13.8599319 15.3545998,14.0902374 L15.3545998,14.0902374 L19.7470079,18.4826455 C20.0848985,18.8205361 20.0895423,19.3911258 19.7404774,19.7401906 L19.7404774,19.7401906 L19.6484923,19.8207555 C19.2970415,20.0893684 18.7996023,20.0633911 18.4829323,19.7467211 L18.4829323,19.7467211 L14.0905242,15.354313 C13.8660113,15.1298002 13.7886268,14.8025508 13.8643731,14.5058143 L12.821644,13.4619371 C11.8878971,14.2506258 10.6809771,14.7260374 9.36301871,14.7260374 C6.40110526,14.7260374 4,12.3249322 4,9.36301871 C4,6.40110526 6.40110526,4 9.36301871,4 Z M9.36301871,5.7876729 C7.38840975,5.7876729 5.7876729,7.38840975 5.7876729,9.36301871 C5.7876729,11.3376277 7.38840975,12.9383645 9.36301871,12.9383645 C11.3376277,12.9383645 12.9383645,11.3376277 12.9383645,9.36301871 C12.9383645,7.38840975 11.3376277,5.7876729 9.36301871,5.7876729 Z"
  },
  settings: {
    title: "Icon/Settings",
    data: "M12.8839106,4 C13.4334112,4 13.986761,4.43156624 14.1232428,4.97749329 L14.6051906,6.90456028 C14.8505403,7.01675637 15.0863788,7.14615186 15.3111641,7.29120448 L17.3862761,6.69712238 C17.9273036,6.54235553 18.5777259,6.80578741 18.8524762,7.2816689 L18.8524762,7.2816689 L19.4575173,8.32963087 C19.7325236,8.80595574 19.6306954,9.50486141 19.2306494,9.89167068 L19.2306494,9.89167068 L17.8287605,11.2476144 C17.8618069,11.4937052 17.8788695,11.74486 17.8788695,12 C17.8788695,12.1806858 17.8703122,12.3593728 17.8535808,12.5356781 L19.2306494,13.8671124 C19.6351952,14.2582726 19.7322676,14.9532707 19.4575173,15.4291522 L19.4575173,15.4291522 L18.8524762,16.4771141 C18.5774699,16.953439 17.9212857,17.214706 17.3862761,17.0616607 L17.3862761,17.0616607 L15.5587434,16.5394924 C15.2618144,16.7544038 14.9429679,16.9408966 14.6061937,17.0949809 L14.1232428,19.0225067 C13.986761,19.5684338 13.4334112,20 12.8839106,20 L12.8839106,20 L11.6738283,20 C11.1238157,20 10.5694598,19.5623613 10.4344961,19.0225067 L10.4344961,19.0225067 L9.95227471,17.0953146 C9.62840525,16.947191 9.32111061,16.7690969 9.03393855,16.5645802 L7.29429638,17.0616607 C6.75928672,17.214706 6.10310255,16.953439 5.82809626,16.4771141 L5.22305514,15.4291522 C4.94830483,14.9532707 5.04537724,14.2582726 5.44992305,13.8671124 L6.71540139,12.6431572 C6.69126956,12.4321133 6.67886946,12.2175047 6.67886946,12 C6.67886946,11.7089053 6.70107986,11.4229981 6.74389845,11.1438807 L5.44992305,9.89167068 C5.04987706,9.50486141 4.94804884,8.80595574 5.22305514,8.32963087 L5.82809626,7.2816689 C6.10284657,6.80578741 6.7532688,6.54235553 7.29429638,6.69712238 L9.28466781,7.26684035 C9.49787693,7.13168139 9.72084406,7.01053157 9.95227471,6.90468539 L10.4344961,4.97749329 C10.5694598,4.43763865 11.1238157,4 11.6738283,4 L12.8839106,4 Z M12.2788695,9.6 C10.9533861,9.6 9.87886946,10.6745166 9.87886946,12 C9.87886946,13.3254834 10.9533861,14.4 12.2788695,14.4 C13.6043529,14.4 14.6788695,13.3254834 14.6788695,12 C14.6788695,10.6745166 13.6043529,9.6 12.2788695,9.6 Z"
  },
  share: {
    title: "Icon/Share",
    data: "M17,4 C18.3254834,4 19.4,5.0745166 19.4,6.4 C19.4,7.7254834 18.3254834,8.8 17,8.8 C16.4494826,8.8 15.9422573,8.61464398 15.5373282,8.30293576 L9.77196114,11.6319899 C9.79042271,11.751961 9.8,11.8748621 9.8,12 C9.8,12.1892021 9.77810644,12.3732906 9.73671455,12.5498704 L15.3944294,15.8161162 C15.8196951,15.4331113 16.3826245,15.2 17,15.2 C18.3254834,15.2 19.4,16.2745166 19.4,17.6 C19.4,18.9254834 18.3254834,20 17,20 C15.6745166,20 14.6,18.9254834 14.6,17.6 C14.6,17.471017 14.6101749,17.3444106 14.6297658,17.2209394 L8.87065474,13.896764 C8.46441831,14.2121958 7.95414117,14.4 7.4,14.4 C6.0745166,14.4 5,13.3254834 5,12 C5,10.6745166 6.0745166,9.6 7.4,9.6 C8.02082723,9.6 8.58659789,9.83572523 9.01269075,10.2225545 L14.6654069,6.95884259 C14.622642,6.77952944 14.6,6.59240888 14.6,6.4 C14.6,5.0745166 15.6745166,4 17,4 Z"
  },
  star: {
    title: "Icon/Star",
    data: "M12,17.2668737 L7.92828337,19.5176633 C7.4463844,19.7840505 7.12670196,19.5648951 7.21591095,19.0179998 L8,14.2111456 L4.69674683,10.8255676 C4.31194418,10.4311747 4.43376222,10.0451832 4.98827131,9.96046176 L9.52786405,9.26687371 L11.5750247,4.90540787 C11.8097321,4.40536491 12.1939844,4.41328275 12.4249753,4.90540787 L14.472136,9.26687371 L19.0117287,9.96046176 C19.5575359,10.0438537 19.6861267,10.4331519 19.3032532,10.8255676 L16,14.2111456 L16.7840891,19.0179998 C16.8725556,19.5603435 16.5563032,19.7855362 16.0717166,19.5176633 L12,17.2668737 Z"
  },
  tag: {
    title: "Icon/Tag",
    data: "M13.5079881,4.59846274 L17.299211,8.40910533 C17.6862461,8.79812292 18,9.55365804 18,10.1179797 L18,18.0017577 C18,19.1043504 17.0980496,19.9981785 15.9914698,19.9981785 L8.0085302,19.9981785 C6.8992496,19.9981785 6,19.1074382 6,18.0017577 L6,10.1179797 C6,9.56321204 6.32759424,8.79427938 6.72289178,8.40910533 L10.6645774,4.5683655 C11.4535566,3.79959198 12.7252869,3.81175226 13.5079881,4.59846274 Z M12,7.16767228 C11.4477153,7.16767228 11,7.61538753 11,8.16767228 C11,8.71995703 11.4477153,9.16767228 12,9.16767228 C12.5522847,9.16767228 13,8.71995703 13,8.16767228 C13,7.61538753 12.5522847,7.16767228 12,7.16767228 Z",
    transform: "translate(12.000000, 11.999089) rotate(-45.000000) translate(-12.000000, -11.999089) "
  },
  upload: {
    title: "Icon/Upload",
    data: "M20,15 C20.5522847,15 21,15.4477153 21,16 L21,18 C21,19.1045695 20.1045695,20 19,20 L5,20 C3.8954305,20 3,19.1045695 3,18 L3,16 C3,15.4477153 3.44771525,15 4,15 C4.55228475,15 5,15.4477153 5,16 L5,18 L19,18 L19,16 C19,15.4477153 19.4477153,15 20,15 Z M12.4671397,4.18882594 L17.8062664,9.39539476 C18.0645779,9.64446871 18.0645779,10.0515711 17.8062664,10.3033129 L17.1962315,10.8978942 C16.9351828,11.1549977 16.5092614,11.1496621 16.2537138,10.8871707 L13.0991522,7.65985438 L13.0991522,15.357215 C13.0991522,15.7134198 12.8051237,16 12.4396609,16 L11.5603391,16 C11.1948763,16 10.9008478,15.7134198 10.9008478,15.357215 L10.9008478,7.65985438 L7.74628618,10.8871707 C7.49073865,11.1469681 7.06481715,11.1523299 6.8037685,10.8978942 L6.19373363,10.3033129 C5.93542212,10.0542389 5.93542212,9.64713652 6.19373363,9.39539476 L11.5355974,4.18882594 C11.7911718,3.93705802 12.2088282,3.93705802 12.4671397,4.18882594 Z"
  },
  "back-10": {
    title: "Icon/Back-10",
    data: "M12.1525092,4.57834878 L12.1532015,4.84423449 C16.5007779,4.92158814 20,8.28439583 20,12.4214363 C20,16.6069615 16.418278,20 12,20 C7.581722,20 4,16.6069615 4,12.4214363 L4,12.4214363 L6.28571429,12.4214363 C6.28571429,15.4110971 8.84408714,17.8346961 12,17.8346961 C15.1559129,17.8346961 17.7142857,15.4110971 17.7142857,12.4214363 C17.7142857,9.4317755 15.1559129,7.00817655 12,7.00817655 L12.152,7.011 L12.1525092,7.34463417 C12.1525092,7.89612921 11.7883237,8.08831928 11.3287266,7.76665804 L9.57324548,6.53803771 L9.485,6.468 L9.48584256,7.34463417 C9.48584256,7.89612921 9.12165699,8.08831928 8.66205997,7.76665804 L6.90657881,6.53803771 C6.45161625,6.21962002 6.44698179,5.70660649 6.90657881,5.38494525 L8.66205997,4.15632492 C9.11702253,3.83790723 9.48584256,4.01937216 9.48584256,4.57834878 L9.48553907,5.45343244 C9.51261045,5.4297922 9.54184444,5.4069221 9.57324548,5.38494525 L11.3287266,4.15632492 C11.7836892,3.83790723 12.1525092,4.01937216 12.1525092,4.57834878 Z M13.5719401,10.0077729 C13.9593099,10.0077729 14.2555339,10.1350339 14.460612,10.389556 C14.6656901,10.644078 14.7706706,11.0095977 14.7755534,11.4861151 L14.7755534,11.4861151 L14.7755534,12.1399034 L14.770785,12.3186736 C14.7485326,12.7231746 14.6483968,13.0392689 14.4703776,13.2669563 C14.2669271,13.5271706 13.9690755,13.6572777 13.5768229,13.6572777 C13.1894531,13.6572777 12.8932292,13.5296101 12.688151,13.2742749 C12.4830729,13.0189396 12.3780924,12.6530134 12.3732096,12.176496 L12.3732096,12.176496 L12.3732096,11.5227077 L12.3780352,11.3422984 C12.4005547,10.9344177 12.5018921,10.6180566 12.6820475,10.3932153 C12.8879395,10.1362537 13.1845703,10.0077729 13.5719401,10.0077729 Z M9.39794922,12.8839535 C9.51350911,12.8839535 9.60913086,12.9189198 9.68481445,12.9888524 C9.76049805,13.0587849 9.79833984,13.1498599 9.79833984,13.2620773 C9.79833984,13.3726684 9.76090495,13.4625236 9.68603516,13.531643 C9.61116536,13.6007624 9.51513672,13.6353221 9.39794922,13.6353221 C9.28238932,13.6353221 9.18717448,13.6007624 9.11230469,13.531643 C9.0374349,13.4625236 9,13.3726684 9,13.2620773 C9,13.1498599 9.0378418,13.0587849 9.11352539,12.9888524 C9.18920898,12.9189198 9.28401693,12.8839535 9.39794922,12.8839535 Z M11.6448568,10.0516841 L11.6448568,13.6084875 L10.9392904,13.6084875 L10.9392904,10.890875 L10.0970052,11.1519024 L10.0970052,10.5786179 L11.5691732,10.0516841 L11.6448568,10.0516841 Z M13.5719401,10.5786179 C13.4059245,10.5786179 13.2834473,10.6424517 13.2045085,10.7701193 C13.1255697,10.8977869 13.0836589,11.0974201 13.078776,11.3690187 L13.078776,11.3690187 L13.078776,12.2326047 L13.0835124,12.3973691 C13.0961426,12.6051502 13.1340332,12.7653121 13.1971842,12.8778547 C13.276123,13.0185331 13.4026693,13.0888722 13.5768229,13.0888722 C13.749349,13.0888722 13.8738607,13.0213792 13.9503581,12.886393 C14.0268555,12.7514069 14.0667318,12.5448618 14.069987,12.2667578 L14.069987,12.2667578 L14.069987,11.4226879 L14.06663,11.282179 C14.0554403,11.059122 14.016276,10.8916882 13.9491374,10.7798774 C13.868571,10.6457044 13.7428385,10.5786179 13.5719401,10.5786179 Z M9.39794922,10.885996 C9.51350911,10.885996 9.60913086,10.9209623 9.68481445,10.9908949 C9.76049805,11.0608274 9.79833984,11.1519024 9.79833984,11.2641198 C9.79833984,11.3747109 9.76090495,11.4645661 9.68603516,11.5336855 C9.61116536,11.6028049 9.51513672,11.6373646 9.39794922,11.6373646 C9.28238932,11.6373646 9.18717448,11.6028049 9.11230469,11.5336855 C9.0374349,11.4645661 9,11.3747109 9,11.2641198 C9,11.1519024 9.0378418,11.0608274 9.11352539,10.9908949 C9.18920898,10.9209623 9.28401693,10.885996 9.39794922,10.885996 Z"
  },
  "fast-forward": {
    title: "Icon/Fast-Forward",
    data: "M11.2279688,6.59024724 C11.2279688,6.0400693 11.6047935,5.81845577 12.0696304,6.10841612 L12.0696304,6.10841612 L20.6712683,11.474028 C21.134685,11.7631025 21.1361052,12.234107 20.6712683,12.5240673 L20.6712683,12.5240673 L12.0696304,17.8896792 C11.6062137,18.1787537 11.2279688,17.9639164 11.2279688,17.4078481 L11.2279688,17.4078481 Z M3,6.59024724 C3,6.0400693 3.36348936,5.84428294 3.81187622,6.16610271 L3.81187622,6.16610271 L10.1994727,10.7506593 L10.1994727,13.2750187 L3.81187622,17.8351031 C3.36692078,18.1527553 3,17.9639164 3,17.4078481 L3,17.4078481 Z"
  },
  "forward-10": {
    title: "Icon/Forward-10",
    data: "M14.6658051,4.56635237 C14.6658051,4.00694092 15.0346251,3.82533483 15.4895877,4.14400021 L15.4895877,4.14400021 L17.2450688,5.37357628 C17.7046658,5.69548774 17.7000314,6.20890034 17.2450688,6.52756572 L17.2450688,6.52756572 L15.4895877,7.75714179 C15.0299906,8.07905325 14.6658051,7.88671367 14.6658051,7.33478963 L14.6658051,7.33478963 L14.665,6.45755369 L14.5784021,6.52756572 L12.822921,7.75714179 C12.363324,8.07905325 11.9991384,7.88671367 11.9991384,7.33478963 L11.9991384,7.33478963 L12,6.99807028 C8.84408714,6.99807028 6.28571429,9.42355454 6.28571429,12.415541 C6.28571429,15.4075275 8.84408714,17.8330117 12,17.8330117 C15.1559129,17.8330117 17.7142857,15.4075275 17.7142857,12.415541 L20,12.415541 C20,16.604322 16.418278,20 12,20 C7.581722,20 4,16.604322 4,12.415541 C4,8.22675995 7.581722,4.83108199 12,4.83108199 L11.9991384,4.56635237 C11.9991384,4.00694092 12.3679584,3.82533483 12.822921,4.14400021 L12.822921,4.14400021 L14.5784021,5.37357628 C14.6097875,5.39555924 14.639008,5.41843525 14.666068,5.44208129 Z M13.5719401,10 C13.9593099,10 14.2555339,10.12736 14.460612,10.3820801 C14.6656901,10.6368001 14.7706706,11.0026042 14.7755534,11.4794922 L14.7755534,11.4794922 L14.7755534,12.1337891 L14.770785,12.3126984 C14.7485326,12.717514 14.6483968,13.0338542 14.4703776,13.2617188 C14.2669271,13.5221354 13.9690755,13.6523438 13.5768229,13.6523438 C13.1894531,13.6523438 12.8932292,13.5245768 12.688151,13.269043 C12.4830729,13.0135091 12.3780924,12.6472982 12.3732096,12.1704102 L12.3732096,12.1704102 L12.3732096,11.5161133 L12.3780352,11.3355637 C12.4005547,10.9273656 12.5018921,10.6107585 12.6820475,10.3857422 C12.8879395,10.1285807 13.1845703,10 13.5719401,10 Z M9.39794922,12.878418 C9.51350911,12.878418 9.60913086,12.9134115 9.68481445,12.9833984 C9.76049805,13.0533854 9.79833984,13.1445312 9.79833984,13.2568359 C9.79833984,13.367513 9.76090495,13.4574382 9.68603516,13.5266113 C9.61116536,13.5957845 9.51513672,13.6303711 9.39794922,13.6303711 C9.28238932,13.6303711 9.18717448,13.5957845 9.11230469,13.5266113 C9.0374349,13.4574382 9,13.367513 9,13.2568359 C9,13.1445312 9.0378418,13.0533854 9.11352539,12.9833984 C9.18920898,12.9134115 9.28401693,12.878418 9.39794922,12.878418 Z M11.6448568,10.0439453 L11.6448568,13.6035156 L10.9392904,13.6035156 L10.9392904,10.8837891 L10.0970052,11.1450195 L10.0970052,10.5712891 L11.5691732,10.0439453 L11.6448568,10.0439453 Z M13.5719401,10.5712891 C13.4059245,10.5712891 13.2834473,10.6351725 13.2045085,10.7629395 C13.1255697,10.8907064 13.0836589,11.0904948 13.078776,11.3623047 L13.078776,11.3623047 L13.078776,12.2265625 L13.0835124,12.3914551 C13.0961426,12.5993978 13.1340332,12.7596842 13.1971842,12.8723145 C13.276123,13.0131022 13.4026693,13.0834961 13.5768229,13.0834961 C13.749349,13.0834961 13.8738607,13.0159505 13.9503581,12.8808594 C14.0268555,12.7457682 14.0667318,12.5390625 14.069987,12.2607422 L14.069987,12.2607422 L14.069987,11.4160156 L14.06663,11.2753974 C14.0554403,11.052167 14.016276,10.8846029 13.9491374,10.7727051 C13.868571,10.6384277 13.7428385,10.5712891 13.5719401,10.5712891 Z M9.39794922,10.8789062 C9.51350911,10.8789062 9.60913086,10.9138997 9.68481445,10.9838867 C9.76049805,11.0538737 9.79833984,11.1450195 9.79833984,11.2573242 C9.79833984,11.3680013 9.76090495,11.4579264 9.68603516,11.5270996 C9.61116536,11.5962728 9.51513672,11.6308594 9.39794922,11.6308594 C9.28238932,11.6308594 9.18717448,11.5962728 9.11230469,11.5270996 C9.0374349,11.4579264 9,11.3680013 9,11.2573242 C9,11.1450195 9.0378418,11.0538737 9.11352539,10.9838867 C9.18920898,10.9138997 9.28401693,10.8789062 9.39794922,10.8789062 Z"
  },
  "full-screen": {
    title: "Icon/Full-Screen",
    data: "M10.8607995,13.1214413 C10.8645889,13.1251567 10.8683416,13.1289094 10.872057,13.1326988 C11.1926182,13.4596373 11.1926182,13.9829785 10.872057,14.309917 L6.925,18.3348889 L9.86422585,18.335162 C10.3136519,18.335162 10.6779837,18.7046435 10.6779837,19.167581 C10.6779837,19.6273133 10.3082237,20 9.86422585,20 L4.96228706,20 C4.69245183,20 4.45329135,19.8668094 4.30524152,19.660169 C4.11925867,19.5079692 4,19.2739856 4,19.0152915 L4,14.0158332 C4,13.5574662 4.3622744,13.1858864 4.81618182,13.1858864 C5.26694659,13.1858864 5.63236363,13.5630024 5.63236363,14.0158332 L5.632,17.2978889 L9.7178016,13.1326988 C10.0303231,12.8139599 10.5420607,12.8089198 10.8607995,13.1214413 Z M19.0377129,4 C19.3075482,4 19.5467086,4.13319058 19.6947585,4.33983101 C19.8807413,4.49203079 20,4.72601438 20,4.98470849 L20,9.98416678 C20,10.4425338 19.6377256,10.8141136 19.1838182,10.8141136 C18.7330534,10.8141136 18.3676364,10.4369976 18.3676364,9.98416678 L18.3668889,6.701 L14.2821984,10.8673012 C13.9696769,11.1860401 13.4579393,11.1910802 13.1392005,10.8785587 L13.127943,10.8673012 C12.8073818,10.5403627 12.8073818,10.0170215 13.127943,9.690083 L17.0748889,5.664 L14.1357742,5.66483799 C13.6863481,5.66483799 13.3220163,5.29535648 13.3220163,4.83241899 C13.3220163,4.37268668 13.6917763,4 14.1357742,4 L19.0377129,4 Z"
  },
  next: {
    title: "Icon/Next",
    data: "M16,6 L16.1173326,6.00674437 C16.6172798,6.06465235 17,6.48836906 17,7.00247329 L17,7.00247329 L17,16.9975267 C17,17.544239 16.5522847,18 16,18 L16,18 L15.8826674,17.9933155 C15.3827202,17.9359215 15,17.5159659 15,17.0064252 L15,17.0064252 L15,6.99403976 C15,6.44794513 15.4477153,6 16,6 L16,6 Z M7,7.00247329 C7,6.45576096 7.37181877,6.25668727 7.83048046,6.57332705 L7.83048046,6.57332705 L14,10.8324911 L14,13.1933046 L7.83048046,17.4297333 C7.3763504,17.7415712 7,17.5511774 7,16.9975267 L7,16.9975267 Z"
  },
  pause: {
    title: "Icon/Pause",
    data: "M8.9906311,5 C9.55664682,5 10,5.45078007 10,6.00684547 L10,6.00684547 L10,17.9931545 C10,18.5500512 9.54809015,19 8.9906311,19 L8.9906311,19 L7.0093689,19 C6.44335318,19 6,18.5492199 6,17.9931545 L6,17.9931545 L6,6.00684547 C6,5.44994876 6.45190985,5 7.0093689,5 L7.0093689,5 Z M16.9906311,5 C17.5566468,5 18,5.45078007 18,6.00684547 L18,6.00684547 L18,17.9931545 C18,18.5500512 17.5480902,19 16.9906311,19 L16.9906311,19 L15.0093689,19 C14.4433532,19 14,18.5510412 14,17.9972224 L14,17.9972224 L14,6.0054598 C14,5.44856959 14.4519098,5 15.0093689,5 L15.0093689,5 Z"
  },
  play: {
    title: "Icon/Play",
    data: "M16.1474056,12.5115566 C16.6182805,12.2290317 16.6201992,11.7721195 16.1474056,11.4884434 L7.85259438,6.51155663 C7.3817195,6.2290317 7,6.45576096 7,7.00247329 L7,16.9975267 C7,17.5511774 7.3798008,17.7721195 7.85259438,17.4884434 L16.1474056,12.5115566 Z"
  },
  previous: {
    title: "Icon/Previous",
    data: "M16,6 L16.1173326,6.00674437 C16.6172798,6.06465235 17,6.48836906 17,7.00247329 L17,7.00247329 L17,16.9975267 C17,17.544239 16.5522847,18 16,18 L16,18 L15.8826674,17.9933155 C15.3827202,17.9359215 15,17.5159659 15,17.0064252 L15,17.0064252 L15,6.99403976 C15,6.44794513 15.4477153,6 16,6 L16,6 Z M7,7.00247329 C7,6.45576096 7.37181877,6.25668727 7.83048046,6.57332705 L7.83048046,6.57332705 L14,10.8324911 L14,13.1933046 L7.83048046,17.4297333 C7.3763504,17.7415712 7,17.5511774 7,16.9975267 L7,16.9975267 Z",
    transform: "translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) "
  },
  "radio-selected": {
    title: "Icon/Radio/Selected",
    data: "M12 3c4.97 0 9 4.03 9 9s-4.03 9-9 9-9-4.03-9-9 4.03-9 9-9zm0 7c-1.105 0-2 .895-2 2s.895 2 2 2 2-.895 2-2-.895-2-2-2z"
  },
  "radio-unselected": {
    title: "Icon/Radio/Unselected",
    data: "M12 3c4.97 0 9 4.03 9 9s-4.03 9-9 9-9-4.03-9-9 4.03-9 9-9zm0 2c-3.866 0-7 3.134-7 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7z"
  },
  replay: {
    title: "Icon/Replay",
    data: "M12.1525092,4.57834878 L12.1532015,4.84423449 C16.5007779,4.92158814 20,8.28439583 20,12.4214363 C20,16.6069615 16.418278,20 12,20 C7.581722,20 4,16.6069615 4,12.4214363 L4,12.4214363 L6.28571429,12.4214363 C6.28571429,15.4110971 8.84408714,17.8346961 12,17.8346961 C15.1559129,17.8346961 17.7142857,15.4110971 17.7142857,12.4214363 C17.7142857,9.4317755 15.1559129,7.00817655 12,7.00817655 L12.152,7.011 L12.1525092,7.34463417 C12.1525092,7.89612921 11.7883237,8.08831928 11.3287266,7.76665804 L9.57324548,6.53803771 L9.485,6.468 L9.48584256,7.34463417 C9.48584256,7.89612921 9.12165699,8.08831928 8.66205997,7.76665804 L6.90657881,6.53803771 C6.45161625,6.21962002 6.44698179,5.70660649 6.90657881,5.38494525 L8.66205997,4.15632492 C9.11702253,3.83790723 9.48584256,4.01937216 9.48584256,4.57834878 L9.48553907,5.45343244 C9.51261045,5.4297922 9.54184444,5.4069221 9.57324548,5.38494525 L11.3287266,4.15632492 C11.7836892,3.83790723 12.1525092,4.01937216 12.1525092,4.57834878 Z M10,9.99077797 C10,9.45097518 10.384825,9.23089499 10.8595306,9.51571839 L10.8595306,9.51571839 L14.1404694,11.4842816 C14.6076584,11.764595 14.615175,12.230895 14.1404694,12.5157184 L14.1404694,12.5157184 L10.8595306,14.4842816 C10.3923416,14.764595 10,14.5564136 10,14.009222 L10,14.009222 Z"
  },
  rewind: {
    title: "Icon/Rewind",
    data: "M11.2279688,6.59024724 C11.2279688,6.0400693 11.6047935,5.81845577 12.0696304,6.10841612 L12.0696304,6.10841612 L20.6712683,11.474028 C21.134685,11.7631025 21.1361052,12.234107 20.6712683,12.5240673 L20.6712683,12.5240673 L12.0696304,17.8896792 C11.6062137,18.1787537 11.2279688,17.9639164 11.2279688,17.4078481 L11.2279688,17.4078481 Z M3,6.59024724 C3,6.0400693 3.36348936,5.84428294 3.81187622,6.16610271 L3.81187622,6.16610271 L10.1994727,10.7506593 L10.1994727,13.2750187 L3.81187622,17.8351031 C3.36692078,18.1527553 3,17.9639164 3,17.4078481 L3,17.4078481 Z",
    transform: "translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) "
  },
  sort: {
    title: "Icon/Sort",
    data: "M16.1994385,13.2003761 C17.8004817,13.2003761 18.5991176,15.1434776 17.474268,16.2726033 L17.474268,16.2726033 L13.2748295,20.4739196 C12.5699311,21.1753601 11.4300689,21.1753601 10.7289053,20.4739196 L10.7289053,20.4739196 L6.53323829,16.2726033 C5.39714753,15.139741 6.20702459,13.2003761 7.80429637,13.2003761 L7.80429637,13.2003761 Z M10.7251705,3.52608036 C11.4300689,2.82463988 12.5699311,2.82463988 13.2710947,3.52608036 L13.2710947,3.52608036 L17.4667617,7.72739669 C18.6028525,8.86025895 17.7929754,10.7996239 16.1957036,10.7996239 L16.1957036,10.7996239 L7.80056151,10.7996239 C6.19951827,10.7996239 5.40088238,8.85652243 6.52573197,7.72739669 L6.52573197,7.72739669 Z"
  },
  "volume-max": {
    title: "Icon/Volume-Max",
    data: "M13.9310345,6.50893231 L13.9310345,17.4865216 C13.9310345,18.0367059 13.5750775,18.2034003 13.1455554,17.866356 L9.799,15.24 L5.00554026,15.2402227 C4.45019571,15.2402227 4,14.794483 4,14.2411548 L4,9.75429911 C4,9.20252917 4.45506681,8.75523125 5.00554026,8.75523125 L9.82,8.755 L13.1455554,6.1324057 C13.5793635,5.79017132 13.9310345,5.9591917 13.9310345,6.50893231 Z M18.0861376,7.68433374 C18.355276,7.54439149 18.6892752,7.64465383 18.8321458,7.90827595 C18.8720013,7.98181661 18.9375715,8.11202932 19.0202431,8.2917082 C19.1560971,8.58697443 19.2915509,8.91693832 19.4179269,9.27456462 C19.7812788,10.3027992 20,11.3524891 20,12.3708075 C20,12.4609923 19.9982445,12.5520224 19.9947735,12.6438687 C19.9592686,13.5833601 19.7491024,14.5759109 19.4216381,15.5703602 C19.296295,15.9510044 19.1620193,16.305888 19.0274574,16.6261945 C18.945856,16.8204358 18.8814157,16.9617409 18.8427412,17.0411064 C18.7114861,17.3104603 18.3821593,17.4245923 18.1071692,17.2960274 C17.8321791,17.1674625 17.7156588,16.8448856 17.8469139,16.5755317 C17.877205,16.5133703 17.9334544,16.390026 18.0070254,16.2149002 C18.1310842,15.9195949 18.2554291,15.5909578 18.3714653,15.238577 C18.6703034,14.3310601 18.8608089,13.431361 18.8920804,12.6038869 C18.8950532,12.5252257 18.8965517,12.4475193 18.8965517,12.3708075 C18.8965517,11.48768 18.7014798,10.5514884 18.3751765,9.62809594 C18.2601732,9.3026528 18.1370063,9.00261974 18.0142397,8.73579779 C17.9417388,8.57822378 17.8866194,8.46876493 17.8575094,8.41505167 C17.7146389,8.15142955 17.8169992,7.82427599 18.0861376,7.68433374 Z M15.8754476,9.84798864 C16.1434633,9.70599425 16.4782508,9.80370156 16.6232165,10.066224 C16.7053332,10.2149316 16.8207613,10.4625091 16.934828,10.7833482 C17.1260208,11.3211226 17.2413793,11.8767285 17.2413793,12.4278994 L17.2413793,12.4278994 L17.2412851,12.4548912 C17.2375231,12.9950323 17.1241457,13.5582642 16.9385983,14.1185599 C16.8265297,14.4569727 16.7135858,14.7225965 16.6342706,14.8826456 C16.5012095,15.151148 16.1711234,15.2631557 15.8970026,15.1328218 C15.6228818,15.0024879 15.5085303,14.6791673 15.6415914,14.4106649 C15.7002073,14.2923846 15.79416,14.0714246 15.8889879,13.7850736 C16.0424661,13.3216167 16.1349753,12.8620532 16.1378625,12.4475178 L16.1378625,12.4475178 L16.137931,12.4278994 C16.137931,12.0118118 16.046393,11.5709335 15.8927583,11.1388 C15.7999284,10.8776944 15.7084599,10.681507 15.6526456,10.5804312 C15.50768,10.3179087 15.6074318,9.98998303 15.8754476,9.84798864 Z"
  },
  "volume-min": {
    title: "Icon/Volume-Min",
    data: "M13.9310345,6.56036078 L13.9310345,17.4394602 C13.9310345,17.9916694 13.5750775,18.1619685 13.1455554,17.8272931 L9.798,15.219 L5.00554026,15.219617 C4.45019571,15.219617 4,14.7770101 4,14.2134587 L4,9.78636227 C4,9.23067639 4.45506681,8.78020399 5.00554026,8.78020399 L9.82,8.78 L13.1455554,6.17581243 C13.5793635,5.83598337 13.9310345,6.00381583 13.9310345,6.56036078 Z M15.8754476,9.86528116 C16.1434633,9.72428475 16.4782508,9.82130534 16.6232165,10.0819827 C16.7053332,10.2296451 16.8207613,10.4754826 16.934828,10.7940668 C17.1260208,11.3280615 17.2413793,11.8797624 17.2413793,12.4270596 L17.2413793,12.4270596 L17.2412851,12.4538617 C17.2375231,12.9902065 17.1241457,13.5494798 16.9385983,14.1058376 C16.8265297,14.4418719 16.7135858,14.7056288 16.6342706,14.8645531 C16.5012095,15.1311684 16.1711234,15.2423888 15.8970026,15.112971 C15.6228818,14.9835531 15.5085303,14.6625048 15.6415914,14.3958895 C15.7002073,14.2784406 15.79416,14.0590336 15.8889879,13.7746952 C16.0424661,13.3144955 16.1349753,12.858162 16.1378625,12.4465401 L16.1378625,12.4465401 L16.137931,12.4270596 C16.137931,12.0138963 16.046393,11.5761166 15.8927583,11.1470203 C15.7999284,10.8877499 15.7084599,10.6929413 15.6526456,10.5925759 C15.50768,10.3318985 15.6074318,10.0062776 15.8754476,9.86528116 Z"
  },
  "volume-mute": {
    title: "Icon/Volume-Mute",
    data: "M13.9310345,6.56036078 L13.9310345,17.4394602 C13.9310345,17.9916694 13.5750775,18.1619685 13.1455554,17.8272931 L9.799,15.2194561 L5.00554026,15.219617 C4.45019571,15.219617 4,14.7770101 4,14.2134587 L4,9.78636227 C4,9.23067639 4.45506681,8.78020399 5.00554026,8.78020399 L9.821,8.77945609 L13.1455554,6.17581243 C13.5793635,5.83598337 13.9310345,6.00381583 13.9310345,6.56036078 Z M19.8737985,10.1313492 L19.879,10.1352241 C19.9689079,10.3301684 19.9339037,10.5576721 19.788046,10.7035273 L18.476,12.0162241 L19.788046,13.328921 C19.9339037,13.4747762 19.9689079,13.7022799 19.884915,13.8885358 L19.879,13.8962241 C19.7157018,13.9740185 19.5271553,13.9615183 19.3815837,13.8615326 L19.3127191,13.8042398 L18,12.4922241 L16.6872809,13.8042398 C16.5365394,13.9549787 16.3106477,13.9861718 16.1262015,13.9010991 L16.12,13.8962241 C16.0310921,13.7022799 16.0660963,13.4747762 16.211954,13.328921 L17.524,12.0162241 L16.211954,10.7035273 C16.0660963,10.5576721 16.0310921,10.3301684 16.115085,10.1439125 L16.12,10.1352241 L16.1262015,10.1313492 C16.2842982,10.0584297 16.4728447,10.07093 16.6184163,10.1709156 L16.6872809,10.2282085 L18,11.5402241 L19.3127191,10.2282085 C19.4634606,10.0774695 19.6893523,10.0462765 19.8737985,10.1313492 Z"
  },
  warning: {
    title: "Icon/Warning",
    data: "M12.4482031,4.4096 L19.8765719,19.1141661 C20.1237196,19.6033987 19.8788124,20 19.3325956,20 L4.66880948,20 C4.12123193,20 3.88307999,19.59272 4.12483314,19.1141661 L11.553202,4.4096 C11.8003497,3.92036745 12.2064499,3.93104606 12.4482031,4.4096 Z M12.0007025,15.4232684 C11.5264223,15.4232684 11.1355279,15.7735899 11.0821056,16.2312148 L11.0758837,16.3386147 C11.0758837,16.8080371 11.4298305,17.1949277 11.8921912,17.2478028 L12.0007025,17.253961 C12.5114659,17.253961 12.9255214,16.847671 12.9255214,16.3386147 C12.9255214,15.8691923 12.5715746,15.4823016 12.1092139,15.4294266 L12.0007025,15.4232684 Z M12.0007025,9.9311904 C11.4899392,9.9311904 11.0758837,10.3535548 11.0758837,10.8573603 L11.0758837,13.5817521 C11.0758837,14.0567252 11.4298305,14.4481907 11.8921912,14.501691 L12.0007025,14.507922 C12.5114659,14.507922 12.9255214,14.0855576 12.9255214,13.5817521 L12.9255214,10.8573603 C12.9255214,10.3823872 12.5715746,9.99092173 12.1092139,9.93742142 L12.0007025,9.9311904 Z"
  },
  x: {
    title: "Icon/X",
    data: "M6.3916134,6.21176354 C6.78900643,5.90243963 7.35887942,5.93300056 7.72267964,6.29680078 L7.72267964,6.29680078 L12,10.574 L16.2773204,6.29680078 C16.6411206,5.93300056 17.2109936,5.90243963 17.6083866,6.21176354 L17.7039225,6.2961793 C18.0976961,6.68995297 18.0998953,7.3261871 17.703301,7.72278139 L13.426,12 L17.703301,16.2774221 C18.069388,16.6435092 18.0956747,17.2137864 17.787839,17.6090688 L17.7039225,17.7040242 L17.6083866,17.78844 C17.2109936,18.0977639 16.6411206,18.067203 16.2773204,17.7034027 L16.2773204,17.7034027 L12,13.426 L7.72267964,17.7034027 C7.35887942,18.067203 6.78900643,18.0977639 6.3916134,17.78844 L6.29607754,17.7040242 C5.90230387,17.3102505 5.90010473,16.6740164 6.29669903,16.2774221 L10.574,12 L6.29669903,7.72278139 C5.93061198,7.35669435 5.90432526,6.78641716 6.21216101,6.39113474 L6.29607754,6.2961793 Z"
  },
  filter: {
    title: "Icon/Filter",
    customComponent: () => /* @__PURE__ */ React.createElement("g", {
      id: "Filter-Icon",
      transform: "translate(4.000000, 6.000000)"
    }, /* @__PURE__ */ React.createElement("g", {
      id: "Middle",
      transform: "translate(0.000000, 4.500000)"
    }, /* @__PURE__ */ React.createElement("path", {
      d: "M9.6,1.55 C9.6,1.8130713 9.64815805,2.06559767 9.73666016,2.3002535 L0.75,2.3 C0.335786438,2.3 5.07265313e-17,1.96421356 0,1.55 C-5.07265313e-17,1.13578644 0.335786438,0.8 0.75,0.8 L9.7363046,0.800689898 C9.64802908,1.03507911 9.6,1.28728121 9.6,1.55 Z M15.25,0.8 C15.6642136,0.8 16,1.13578644 16,1.55 C16,1.96421356 15.6642136,2.3 15.25,2.3 L14.2633398,2.3002535 C14.3518419,2.06559767 14.4,1.8130713 14.4,1.55 C14.4,1.28728121 14.3519709,1.03507911 14.2636954,0.800689898 L15.25,0.8 Z",
      id: "Combined-Shape"
    }), /* @__PURE__ */ React.createElement("circle", {
      id: "Circle",
      cx: "12",
      cy: "1.5",
      r: "1.5"
    })), /* @__PURE__ */ React.createElement("g", {
      id: "Bottom",
      transform: "translate(0.000000, 9.000000)"
    }, /* @__PURE__ */ React.createElement("path", {
      d: "M1.6,1.55 C1.6,1.8130713 1.64815805,2.06559767 1.73666016,2.3002535 L0.75,2.3 C0.335786438,2.3 5.07265313e-17,1.96421356 0,1.55 C-5.07265313e-17,1.13578644 0.335786438,0.8 0.75,0.8 L1.7363046,0.800689898 C1.64802908,1.03507911 1.6,1.28728121 1.6,1.55 Z M15.25,0.8 C15.6642136,0.8 16,1.13578644 16,1.55 C16,1.96421356 15.6642136,2.3 15.25,2.3 L6.26333984,2.3002535 C6.35184195,2.06559767 6.4,1.8130713 6.4,1.55 C6.4,1.28728121 6.35197092,1.03507911 6.2636954,0.800689898 L15.25,0.8 Z",
      id: "Combined-Shape"
    }), /* @__PURE__ */ React.createElement("circle", {
      id: "Circle",
      cx: "4",
      cy: "1.5",
      r: "1.5"
    })), /* @__PURE__ */ React.createElement("g", {
      id: "Top"
    }, /* @__PURE__ */ React.createElement("path", {
      d: "M4,1.55 C4,1.8130713 4.04815805,2.06559767 4.13666016,2.3002535 L0.75,2.3 C0.335786438,2.3 5.07265313e-17,1.96421356 0,1.55 C-5.07265313e-17,1.13578644 0.335786438,0.8 0.75,0.8 L4.1363046,0.800689898 C4.04802908,1.03507911 4,1.28728121 4,1.55 Z M15.25,0.8 C15.6642136,0.8 16,1.13578644 16,1.55 C16,1.96421356 15.6642136,2.3 15.25,2.3 L8.66333984,2.3002535 C8.75184195,2.06559767 8.8,1.8130713 8.8,1.55 C8.8,1.28728121 8.75197092,1.03507911 8.6636954,0.800689898 L15.25,0.8 Z",
      id: "Combined-Shape"
    }), /* @__PURE__ */ React.createElement("circle", {
      id: "Circle",
      cx: "6.5",
      cy: "1.5",
      r: "1.5"
    })))
  },
  logout: {
    title: "Icon/Logout",
    customComponent: () => /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
      d: "M16.3490777,6.3504017 L21.6359557,11.4880694 C21.9278551,11.7717306 22.0447763,12.1607448 21.9846945,12.5292499 C22.0238396,12.8804226 21.9048758,13.2438637 21.6324897,13.5085624 L16.3456116,18.6462301 C15.860893,19.1172685 15.0772279,19.1194249 14.5876761,18.6436896 C14.1015137,18.171248 14.1061977,17.4007171 14.5850618,16.9353678 L18.056,13.561 L9.21523907,13.5610142 C8.58602844,13.5610142 8.06850653,13.0890671 8.00627414,12.4757107 L8,12.3512519 C8,11.6831187 8.53681569,11.1414897 9.21523907,11.1414897 L17.758,11.141 L14.5885279,8.06126392 C14.1038093,7.59022545 14.1015903,6.82867754 14.5911422,6.35294221 C15.0773046,5.88050065 15.8702136,5.88505245 16.3490777,6.3504017 Z"
    }), /* @__PURE__ */ React.createElement("path", {
      d: "M11.2380952,4 C11.6588836,4 12,4.34111638 12,4.76190476 C12,5.18269314 11.6588836,5.52380952 11.2380952,5.52380952 L4.5,5.523 L4.5,18.476 L11.2380952,18.4761905 C11.6588836,18.4761905 12,18.8173069 12,19.2380952 C12,19.6588836 11.6588836,20 11.2380952,20 L4.5,19.999 L4.5,20 L3.76190476,20 C3.34111638,20 3,19.6588836 3,19.2380952 L3,4.76190476 C3,4.34111638 3.34111638,4 3.76190476,4 L11.2380952,4 Z"
    }))
  },
  minus: {
    title: "Icon/Minus",
    customComponent: () => /* @__PURE__ */ React.createElement("rect", {
      id: "Minus-Icon",
      transform: "translate(12.000000, 12.000000) rotate(-270.000000) translate(-12.000000, -12.000000) ",
      x: "11",
      y: "4",
      width: "2",
      height: "16",
      rx: "1"
    })
  },
  stop: {
    title: "Icon/Stop",
    customComponent: () => /* @__PURE__ */ React.createElement("rect", {
      id: "Stop-Icon",
      x: "6",
      y: "6",
      width: "12",
      height: "12",
      rx: "1"
    })
  },
  "checkbox-selected": {
    title: "Icon/Checkbox/Selected",
    customComponent: ({ fill = "#222222" }) => /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", {
      width: "18",
      height: "18",
      x: "3",
      y: "3",
      fill,
      rx: "1"
    }), /* @__PURE__ */ React.createElement("path", {
      fill: "#FFF",
      d: "M16.605 7.334c.391-.392 1.023-.395 1.416-.002.39.39.385 1.03-.002 1.416l-7.068 7.067c-.391.392-1.022.395-1.415.002-.391-.39-.385-1.03.001-1.416l7.068-7.067z"
    }), /* @__PURE__ */ React.createElement("path", {
      fill: "#FFF",
      d: "M10.956 14.41c.387.386.387 1.014-.006 1.407-.39.39-1.026.388-1.408.007l-2.841-2.842c-.387-.387-.387-1.014.006-1.407.39-.39 1.026-.389 1.408-.007l2.841 2.842z"
    }))
  },
  split: {
    title: "Icon/Split",
    customComponent: ({ fill = "#222222" }) => /* @__PURE__ */ React.createElement("g", {
      fill
    }, /* @__PURE__ */ React.createElement("path", {
      d: "M8.56 5.417v1.25H3.75v6.553h4.81v1.25l-5.225.001a.624.624 0 0 1-.835-.588V6.042c0-.346.28-.625.625-.625h5.436zM16.547 5.417a.63.63 0 0 1 .185.027.592.592 0 0 1 .768.564v7.983a.592.592 0 0 1-.698.583.737.737 0 0 1-.12.01H11.74a.764.764 0 1 1 0-1.528l4.576-.001v-6.38l-4.737-.007a.626.626 0 0 1 0-1.251h4.969z"
    }), /* @__PURE__ */ React.createElement("path", {
      d: "M10.625 2.5h1.25v14.394h-1.25z"
    }))
  },
  pin: {
    title: "Icon/Pin",
    data: "M19.8171563,8.59555083 L15.4045798,4.18306166 C15.2535093,4.0319529 15.038702,3.96901541 14.8307597,4.01450758 C14.6220826,4.05978983 14.4529995,4.20649002 14.378451,4.40707966 C14.1266528,5.08511672 14.0651624,5.84433433 14.2001097,6.56945904 L9.90463661,10.3537069 C7.57641712,9.52594666 5.74345907,10.8053538 5.66383006,10.8621822 C5.51448106,10.9690794 5.42021946,11.1353872 5.40527196,11.3176288 C5.38982062,11.5009411 5.45563579,11.6807265 5.58579657,11.8108841 L8.61393501,14.8389577 L4.11334222,19.3394292 C3.96222976,19.490538 3.96220876,19.7355702 4.11334222,19.8866789 C4.18889846,19.9622123 4.28790463,20 4.38695278,20 C4.48597995,20 4.5850281,19.9622123 4.66056334,19.8866789 L9.16134506,15.3860395 L12.1893775,18.4139668 C12.3070681,18.5317384 12.4654024,18.5968592 12.6298458,18.5968592 C12.6471866,18.5968592 12.6646114,18.5961454 12.6820361,18.5946759 C12.865038,18.5796028 13.0312869,18.4853855 13.1391104,18.3347806 C13.2038759,18.2435443 13.5377593,17.7492814 13.7506351,16.9780347 C14.0145046,16.0221322 13.9778287,15.0305833 13.6462756,14.095464 L17.4306163,9.80007534 C18.1560528,9.93543923 18.9155199,9.87376133 19.5934477,9.62142355 C19.7936643,9.54698181 19.9402422,9.3779239 19.9853996,9.16988169 C20.0310608,8.96120968 19.9681638,8.74647066 19.8171563,8.59555083 Z"
  },
  unpin: {
    title: "Icon/unpin",
    customComponent: ({ fill = "#222222" }) => /* @__PURE__ */ React.createElement("g", {
      id: "icon/unpin",
      stroke: "none",
      "stroke-width": "1",
      fill,
      "fill-rule": "evenodd"
    }, /* @__PURE__ */ React.createElement("path", {
      d: "M19.8171563,8.59555083 L15.4045798,4.18306166 C15.2535093,4.0319529 15.038702,3.96901541 14.8307597,4.01450758 C14.6220826,4.05978983 14.4529995,4.20649002 14.378451,4.40707966 C14.1266528,5.08511672 14.0651624,5.84433433 14.2001097,6.56945904 L9.90463661,10.3537069 C7.57641712,9.52594666 5.74345907,10.8053538 5.66383006,10.8621822 C5.51448106,10.9690794 5.42021946,11.1353872 5.40527196,11.3176288 C5.38982062,11.5009411 5.45563579,11.6807265 5.58579657,11.8108841 L8.61393501,14.8389577 L4.11334222,19.3394292 C3.96222976,19.490538 3.96220876,19.7355702 4.11334222,19.8866789 C4.18889846,19.9622123 4.28790463,20 4.38695278,20 C4.48597995,20 4.5850281,19.9622123 4.66056334,19.8866789 L9.16134506,15.3860395 L12.1893775,18.4139668 C12.3070681,18.5317384 12.4654024,18.5968592 12.6298458,18.5968592 C12.6471866,18.5968592 12.6646114,18.5961454 12.6820361,18.5946759 C12.865038,18.5796028 13.0312869,18.4853855 13.1391104,18.3347806 C13.2038759,18.2435443 13.5377593,17.7492814 13.7506351,16.9780347 C14.0145046,16.0221322 13.9778287,15.0305833 13.6462756,14.095464 L17.4306163,9.80007534 C18.1560528,9.93543923 18.9155199,9.87376133 19.5934477,9.62142355 C19.7936643,9.54698181 19.9402422,9.3779239 19.9853996,9.16988169 C20.0310608,8.96120968 19.9681638,8.74647066 19.8171563,8.59555083 Z",
      id: "Path"
    }), /* @__PURE__ */ React.createElement("rect", {
      id: "Rectangle",
      transform: "translate(11.750000, 12.500000) rotate(-45.000000) translate(-11.750000, -12.500000) ",
      x: "11",
      y: "4",
      width: "1.5",
      height: "17",
      rx: "0.75"
    }))
  },
  comment: {
    title: "Icon/Comment",
    data: "M10.666 2.667c2.21 0 4 1.8 4 3.998v1.336a4.004 4.004 0 0 1-4 3.999H10L10 14l-3-2H5.333c-2.21 0-4-1.8-4-3.999V6.665a4.004 4.004 0 0 1 4-3.998h5.332zM8 8H4v1.333h4V8zm4-2.667H4v1.334h8V5.333z"
  }
};
const dimensions = {
  small: "16",
  medium: "24"
};
const Icon = (props) => {
  const { variant, fill = "sp-black", size = "medium", ...rest } = props;
  const svgData = iconData[variant];
  const dimension = `${dimensions[size]}px`;
  const paletteFill = palette[fill];
  return /* @__PURE__ */ React.createElement("svg", {
    className: props.className,
    width: dimension,
    height: dimension,
    viewBox: "0 0 24 24",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    ...rest
  }, /* @__PURE__ */ React.createElement("title", null, svgData.title), /* @__PURE__ */ React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: paletteFill,
    fillRule: "evenodd"
  }, svgData.customComponent ? /* @__PURE__ */ React.createElement(svgData.customComponent, {
    fill: paletteFill
  }) : /* @__PURE__ */ React.createElement("path", {
    d: svgData.data,
    transform: svgData.transform
  })));
};
const StyledWrapper$o = styled.span`
  position: relative;
  cursor: pointer;
  display: inline-flex;
  &.hovered::after,
  &:hover::after {
    content: '';
    position: absolute;
    border-radius: 50%;
    left: -8px;
    top: -8px;
    height: 40px;
    width: 40px;
    background-color: ${palette["sp-hover-light"]};
  }

  &.small.hovered::after,
  &.small:hover::after {
    height: 32px;
    width: 32px;
  }
`;
const IconWithHover = (props) => {
  const wrapperClassname = classNames(props.className, props.size || "medium");
  return /* @__PURE__ */ React.createElement(StyledWrapper$o, {
    className: wrapperClassname,
    onClick: props.onClick
  }, /* @__PURE__ */ React.createElement(Icon, {
    ...props
  }));
};
const AccordionPanelToggle = (props) => {
  const iconVariant = props.open ? "chevron-up" : "chevron-down";
  return /* @__PURE__ */ React.createElement("span", {
    className: props.className,
    onClick: props.onClick
  }, /* @__PURE__ */ React.createElement(IconWithHover, {
    variant: iconVariant,
    size: "small"
  }));
};
const StyledAccordionPanel = styled.div`
  ${typography};

  width: 100%;
  font-size: 12px;
  background-color: ${palette["sp-white"]};
  padding: 0 8px 4px;

  .panel-header {
    font-weight: 700;
    padding: 8px 0;
    display: flex;
    align-items: center;
    cursor: pointer;
    .panel-header-text {
      flex: 1 1;
      padding-left: 8px;
    }
  }

  .panel-content {
    overflow: hidden;
    padding-left: 24px;
    &.open {
      max-height: 9999px;
      transition: max-height 0.3s cubic-bezier(1, 0, 1, 0);
    }
    &.closed {
      max-height: 0;
      transition: all 0.3s cubic-bezier(0, 1, 0, 1);
    }
  }
`;
const AccordionPanel = (props) => {
  const { title, initialOpen = false, children, ...rest } = props;
  const [open, changeOpen] = useState(initialOpen);
  const contentClassName = classNames("panel-content", { open, closed: !open });
  return /* @__PURE__ */ React.createElement(StyledAccordionPanel, {
    ...rest
  }, /* @__PURE__ */ React.createElement("div", {
    className: "panel-header",
    onClick: () => changeOpen(!open)
  }, /* @__PURE__ */ React.createElement(AccordionPanelToggle, {
    open
  }), /* @__PURE__ */ React.createElement("span", {
    className: "panel-header-text"
  }, title)), /* @__PURE__ */ React.createElement("div", {
    className: contentClassName
  }, children));
};
const StyledWrapper$n = styled.div`
  ${typography};

  width: 100%;
`;
const Accordion = (props) => {
  const { panels, ...rest } = props;
  return /* @__PURE__ */ React.createElement(StyledWrapper$n, {
    ...rest
  }, panels.map((panel) => /* @__PURE__ */ React.createElement(AccordionPanel, {
    title: panel.title,
    initialOpen: panel.initialOpen
  }, panel.content)));
};
const StyledWrapper$m = styled.div`
  ${typography};
  color: ${palette["sp-mid-gray"]};
  cursor: pointer;

  .active {
    color: ${palette["sp-black"]};
  }

  .separator {
    padding: 0 4px;
  }
`;
const Breadcrumbs = (props) => {
  const { items, separator, ...rest } = props;
  return /* @__PURE__ */ React.createElement(StyledWrapper$m, {
    ...rest
  }, items.map((item, index) => /* @__PURE__ */ React.createElement("span", {
    key: item.value || index,
    onClick: () => {
      item.handleClick && item.handleClick(item.value);
    },
    className: classNames({ active: item.active })
  }, /* @__PURE__ */ React.createElement("span", null, item.name), index < items.length - 1 && /* @__PURE__ */ React.createElement("span", {
    className: "separator"
  }, separator ? separator : "/"))));
};
const StyledButton = styled.button`
  ${typography};
  font-weight: bold;
  text-transform: uppercase;
  text-align: center;
  cursor: pointer;

  height: 32px;
  padding: 0 16px;
  min-width: 120px;
  max-width: 240px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  border-radius: 20px;
  background: linear-gradient(
    257deg,
    ${palette["ripkin"]},
    ${palette["jordan"]}
  );
  border: none;
  color: ${palette["sp-white"]};
  &:hover {
    background: linear-gradient(
      257deg,
      ${palette["sp-hover-orange"]},
      ${palette["sp-hover-red"]}
    );
  }

  &.primary-black {
    background: ${palette["sp-black"]};
    &:hover {
      background: linear-gradient(
        257deg,
        ${palette["sp-hover-orange"]},
        ${palette["sp-hover-red"]}
      );
    }
  }

  &.secondary-light {
    background: ${palette["sp-white"]};
    border: 1px solid ${palette["sp-black"]};
    box-shadow: 0 0 1px 0 ${palette["sp-black"]} inset,
      0 0 1px 0 ${palette["sp-black"]};
    color: ${palette["sp-black"]};
    &:hover {
      border: 1px solid ${palette["jordan"]};
      box-shadow: 0 0 1px 0 ${palette["jordan"]} inset,
        0 0 1px 0 ${palette["jordan"]};
      color: ${palette["jordan"]};
    }
  }

  &.secondary-dark {
    background: transparent;
    border: 1px solid ${palette["sp-white"]};
    box-shadow: 0 0 1px 0 ${palette["sp-white"]} inset,
      0 0 1px 0 ${palette["sp-white"]};
    color: ${palette["sp-white"]};
    &:hover {
      background: ${palette["sp-dark-gray-75"]};
      border: 1px solid ${palette["sp-white"]};
      box-shadow: 0 0 1px 0 ${palette["sp-white"]} inset,
        0 0 1px 0 ${palette["sp-white"]};
      color: ${palette["sp-white"]};
    }
  }

  &:disabled {
    opacity: 0.3;
    pointer-events: none;
    cursor: initial;
  }
`;
const Button = ({ children, ...props }) => {
  const { variant, className, ...rest } = props;
  const buttonClassName = classNames(variant, className);
  return /* @__PURE__ */ React.createElement(StyledButton, {
    className: buttonClassName,
    ...rest
  }, /* @__PURE__ */ React.createElement("span", null, children));
};
const StyledLabel$2 = styled.label`
  ${typography};
  font-size: 10px;
  line-height: 1.6;
  height: 16px;

  display: block;
  color: inherit;
  background: transparent;

  &.disabled {
    color: ${palette["sp-mid-gray"]};
  }

  .required {
    color: ${palette["jordan"]};
    padding-left: 4px;
  }
`;
const Label = (props) => {
  const {
    children,
    label,
    disabled,
    required,
    className,
    ref: unused,
    as: unused2,
    ...rest
  } = props;
  const labelClasses = classNames(className, { disabled });
  return /* @__PURE__ */ React.createElement(StyledLabel$2, {
    className: labelClasses,
    ...rest
  }, children || label, required && /* @__PURE__ */ React.createElement("span", {
    className: "required"
  }, "*"));
};
const StyledWrapper$l = styled.span`
  cursor: pointer;
  display: flex;
`;
const CheckedIconContainer = styled.div`
  display: none;
`;
const UncheckedIconContainer = styled.div`
  display: none;
`;
const StyledInput$1 = styled.input`
  position: absolute;
  display: block;
  width: 1rem;
  height: 1rem;
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  opacity: 0;
  cursor: pointer;

  :disabled {
    cursor: not-allowed;
  }
  :disabled ~ ${CheckedIconContainer}, :disabled ~ ${UncheckedIconContainer} {
    pointer-events: none;
  }

  :checked ~ ${CheckedIconContainer} {
    display: block;
  }

  :not(:checked) ~ ${UncheckedIconContainer} {
    display: block;
  }
`;
const StyledLabel$1 = styled(Label)`
  font-size: 14px;
  margin-left: 4px;
  padding: 2px 0;
`;
const Checkbox = ({
  id,
  className,
  label,
  name,
  value,
  checked,
  defaultChecked,
  onClick,
  disabled,
  required,
  ...rest
}) => {
  return /* @__PURE__ */ React.createElement(StyledWrapper$l, {
    className: "playbook-checkbox-wrapper"
  }, /* @__PURE__ */ React.createElement(StyledInput$1, {
    id,
    type: "checkbox",
    disabled,
    name,
    value,
    checked,
    defaultChecked,
    className: classNames("playbook-checkbox", className),
    onClick,
    ...rest
  }), /* @__PURE__ */ React.createElement(CheckedIconContainer, null, /* @__PURE__ */ React.createElement(Icon, {
    variant: "checkbox-selected"
  })), /* @__PURE__ */ React.createElement(UncheckedIconContainer, null, /* @__PURE__ */ React.createElement(Icon, {
    variant: "checkbox-unselected"
  })), label && /* @__PURE__ */ React.createElement(StyledLabel$1, {
    className: "playbook-checkbox-label",
    htmlFor: id,
    label,
    required
  }));
};
const StyledWrapper$k = styled.div`
  ${typography};
  background-color: transparent;
  display: flex;
  flex-direction: column;

  input {
    background-color: ${palette["sp-light-gray-25"]};
  }

  &.dark {
    color: ${palette["sp-white"]};
    input {
      background-color: ${palette["sp-black"]};
    }
  }

  .inner-wrapper {
    position: relative;

    .state-icon {
      position: absolute;
      right: 8px;
      top: 8px;
    }
  }

  &.slim .inner-wrapper .state-icon {
    top: 4px;
  }

  &.side-label {
    flex-direction: row;

    label {
      height: 40px;
      line-height: 44px;
      width: 96px;
      font-size: 14px;
      padding-right: 16px;
      text-align: right;
    }
  }

  &.side-label.slim {
    label {
      height: 32px;
      line-height: 36px;
    }
  }

  .helper-text {
    color: ${palette["sp-dark-gray-25"]};
    font-size: 10px;
    line-height: 1.6;
    padding: 4px 0;
  }
`;
const StyledInput = styled.input`
  ${typography};
  height: 40px;
  box-sizing: border-box;
  width: 100%;
  padding: 0 0 0 16px;

  color: inherit;
  background-color: inherit;
  border-radius: 2px;
  border: solid 1px ${palette["sp-light-gray-50"]};

  .slim & {
    height: 32px;
  }

  &.success {
    border: solid 1px ${palette["serena"]};
  }

  &.error {
    border: solid 1px ${palette["jordan"]};
  }

  &.warning {
    border: solid 1px ${palette["pele"]};
  }

  &.disabled {
    color: ${palette["sp-mid-gray"]};
  }

  &:focus-visible {
    outline-color: ${palette.tendulkar};
  }
`;
const iconVariantsMap = {
  success: "check",
  warning: "warning",
  error: "error"
};
const iconColors$1 = {
  success: "serena",
  warning: "pele",
  error: "jordan"
};
const Input = (props) => {
  const {
    state,
    theme,
    size,
    labelPosition,
    helperText,
    className,
    ...rest
  } = props;
  const inputClass = classNames(state, {
    disabled: props.disabled
  });
  const wrapperClass = classNames("input-wrapper", className, {
    "side-label": labelPosition === "side",
    dark: theme === "dark",
    slim: size === "slim"
  });
  const loadFocusOption = (event) => {
    var _a;
    const listElements = Array();
    const elements = document.getElementsByTagName("li");
    for (let i = 0; i < elements.length; i++) {
      if (elements[i].hasAttribute("tabindex") && !elements[i].className.includes("readOnly")) {
        listElements.push(elements[i]);
      }
    }
    if (event.keyCode === 40) {
      (_a = listElements[0]) == null ? void 0 : _a.focus();
    }
  };
  return /* @__PURE__ */ React.createElement(StyledWrapper$k, {
    className: wrapperClass
  }, /* @__PURE__ */ React.createElement(Label, {
    label: props.label,
    htmlFor: props.id,
    required: props.required,
    disabled: props.disabled
  }), /* @__PURE__ */ React.createElement("div", {
    className: "inner-wrapper"
  }, /* @__PURE__ */ React.createElement(StyledInput, {
    autoFocus: !!props.autoFocus,
    onKeyDown: loadFocusOption,
    className: inputClass,
    ...rest
  }), state && /* @__PURE__ */ React.createElement(Icon, {
    className: "state-icon",
    variant: iconVariantsMap[state],
    fill: iconColors$1[state]
  }), helperText && /* @__PURE__ */ React.createElement("div", {
    className: "helper-text"
  }, helperText)));
};
const SearchIcon = (props) => {
  return /* @__PURE__ */ React.createElement("span", {
    className: props.className
  }, /* @__PURE__ */ React.createElement(Icon, {
    variant: "search",
    size: "small",
    fill: "sp-black"
  }));
};
const StyledSearchIcon = styled(SearchIcon)`
  position: absolute;
  top: 14px;
  left: 12px;

  .slim & {
    top: 10px;
  }
`;
const StyledWrapper$j = styled.div`
  position: relative;
  & label {
    display: none;
  }
  & input {
    padding-left: 36px;
  }
`;
const Search = (props) => {
  const onChangeDelegate = (event) => {
    props.searchChangeHandler && props.searchChangeHandler(event.currentTarget.value);
  };
  const searchClassName = classNames(props.className, "search-wrapper", {
    slim: props.size === "slim"
  });
  return /* @__PURE__ */ React.createElement(StyledWrapper$j, {
    className: searchClassName
  }, /* @__PURE__ */ React.createElement(Input, {
    ...props,
    label: "Search",
    placeholder: "Search",
    onChange: onChangeDelegate,
    autoFocus: props.autoFocus
  }), /* @__PURE__ */ React.createElement(StyledSearchIcon, null));
};
const StyledWrapper$i = styled.div`
  ${typography};
  display: inline-flex;
  align-items: center;
  background: ${palette["sp-light-gray-25"]};
  padding: 8px 12px;
  font-size: 12px;
  line-height: 1.33;
  border-radius: 16px;

  .up,
  .down {
    cursor: pointer;
  }

  .current,
  .total {
    width: 24px;
    font-weight: bold;
  }

  .current {
    text-align: right;
  }

  .total {
    text-align: left;
  }

  .of {
    padding: 0 8px;
  }
`;
const Pagination = (props) => {
  const { numberOfPages, initialStartPage, handlePageChange, ...rest } = props;
  const [current, changeCurrent] = useState(initialStartPage != null ? initialStartPage : 1);
  const changePage = (newPage) => {
    changeCurrent(newPage);
    handlePageChange(newPage);
  };
  const pageUp = () => {
    if (current !== numberOfPages) {
      changePage(current + 1);
    }
  };
  const pageDown = () => {
    if (current !== 1) {
      changePage(current - 1);
    }
  };
  return /* @__PURE__ */ React.createElement(StyledWrapper$i, {
    ...rest
  }, /* @__PURE__ */ React.createElement(Icon, {
    className: classNames({ down: current > 1 }),
    variant: "chevron-left",
    size: "small",
    onClick: pageDown,
    fill: current > 1 ? "sp-black" : "sp-light-gray-75"
  }), /* @__PURE__ */ React.createElement("span", {
    className: "current"
  }, current), /* @__PURE__ */ React.createElement("span", {
    className: "of"
  }, "of"), /* @__PURE__ */ React.createElement("span", {
    className: "total"
  }, numberOfPages), /* @__PURE__ */ React.createElement(Icon, {
    className: classNames({ up: current < numberOfPages }),
    variant: "chevron-right",
    size: "small",
    onClick: pageUp,
    fill: current < numberOfPages ? "sp-black" : "sp-light-gray-75"
  }));
};
const StyledTH = styled.th`
  text-align: left;
  font-weight: normal;
`;
const TH = (props) => {
  const { children, ...rest } = props;
  return /* @__PURE__ */ React.createElement(StyledTH, {
    ...rest
  }, children);
};
const StyledTD = styled.td``;
const TD = (props) => {
  const { children, ...rest } = props;
  return /* @__PURE__ */ React.createElement(StyledTD, {
    ...rest
  }, children);
};
const StyledTR = styled.tr`
  height: 40px;

  .small & {
    height: 32px;
  }

  .tiny & {
    height: 24px;
  }
`;
const TR = (props) => {
  const { children, ...rest } = props;
  return /* @__PURE__ */ React.createElement(StyledTR, {
    ...rest
  }, children);
};
const StyledTHead = styled.thead``;
const THead = (props) => {
  const { children, ...rest } = props;
  return /* @__PURE__ */ React.createElement(StyledTHead, {
    ...rest
  }, children);
};
const StyledTBody = styled.tbody``;
const TBody = (props) => {
  const { children, ...rest } = props;
  return /* @__PURE__ */ React.createElement(StyledTBody, {
    ...rest
  }, children);
};
const StyledTFoot = styled.tfoot``;
const TFoot = (props) => {
  const { children, ...rest } = props;
  return /* @__PURE__ */ React.createElement(StyledTFoot, {
    ...rest
  }, children);
};
const StyledTable = styled.table`
  ${typography};
  font-size: 14px;
  width: 100%;
  border-collapse: collapse;

  &.tiny {
    font-size: 12px;
  }

  th,
  td {
    padding: 0 4px 0 8px;
  }

  thead tr th {
    background: ${palette["sp-black"]};
    color: ${palette["sp-white"]};
  }
  tfoot tr {
    background: ${palette["sp-dark-gray-25"]};
    color: ${palette["sp-white"]};
  }
  tbody tr:hover {
    background-color: ${palette["sp-table-hover"]};
  }
  tbody tr:nth-child(odd) {
    background-color: ${palette["sp-white"]};
  }
  tbody tr:nth-child(even) {
    background-color: ${palette["sp-light-gray-25"]};
  }

  &.secondary,
  &.tertiary {
    tbody tr:nth-child(odd),
    tbody tr:nth-child(even) {
      background-color: transparent;
    }
  }
  &.secondary tr {
    border-bottom: 2px solid ${palette["sp-light-gray-25"]};
  }
  &.tertiary tr {
    border-bottom: 2px solid ${palette["sp-black"]};
  }
`;
const Table = (props) => {
  const { children, className, variant, size, ...rest } = props;
  const tableClassName = classNames(className, variant, size);
  return /* @__PURE__ */ React.createElement(StyledTable, {
    className: tableClassName,
    ...rest
  }, children);
};
const StyledWrapper$h = styled.div`
  display: flex;
  flex-direction: column;
  .up,
  .down {
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
  }

  .up {
    border-bottom: 4px solid ${palette["sp-mid-gray"]};
    margin-bottom: 4px;
  }
  .down {
    border-top: 4px solid ${palette["sp-mid-gray"]};
  }
  &.asc .up {
    border-bottom-color: ${palette.jordan};
  }
  &.dec .down {
    border-top-color: ${palette.jordan};
  }
`;
const SortIndicator = (props) => {
  return /* @__PURE__ */ React.createElement(StyledWrapper$h, {
    ...props
  }, /* @__PURE__ */ React.createElement("div", {
    className: "up"
  }), /* @__PURE__ */ React.createElement("div", {
    className: "down"
  }));
};
const StyledWrapper$g = styled.div`
  display: flex;
  cursor: pointer;
  .title {
    padding-right: 8px;
  }
  .spacer {
    width: 8px;
  }
`;
const SortableTH = (props) => {
  const {
    className,
    columnId,
    columnTitle,
    isSorted,
    sortDescending,
    changeSortDir,
    changeSortCol,
    ...rest
  } = props;
  const ascendingOrDescending = sortDescending ? "dec" : "asc";
  return /* @__PURE__ */ React.createElement(TH, {
    className,
    ...rest
  }, /* @__PURE__ */ React.createElement(StyledWrapper$g, {
    onClick: () => {
      isSorted ? changeSortDir(!sortDescending) : changeSortCol(columnId);
    }
  }, /* @__PURE__ */ React.createElement("div", {
    className: "title"
  }, columnTitle), isSorted ? /* @__PURE__ */ React.createElement(SortIndicator, {
    className: ascendingOrDescending
  }) : /* @__PURE__ */ React.createElement("div", {
    className: "spacer"
  })));
};
const StyledWrapper$f = styled.div`
  .center {
    position: relative;
    overflow-y: auto;
  }

  thead tr th {
    position: sticky;
    top: 0;
  }

  .below {
    display: flex;
    justify-content: center;
  }
`;
function DataTable(props) {
  const {
    data,
    dataIdAttribute,
    headers,
    pageSize = 20,
    tableHeight,
    includeSearch,
    ...rest
  } = props;
  const [currentRows, changeCurrentRows] = useState(data);
  const [searchTerm, changeSearchTerm] = useState();
  const [sortCol, changeSortCol] = useState();
  const [sortDir, changeSortDir] = useState(true);
  const sortableHeader = (header) => {
    return /* @__PURE__ */ React.createElement(SortableTH, {
      changeSortCol,
      changeSortDir,
      columnId: `${String(header.columnId)}`,
      columnTitle: header.columnName,
      isSorted: sortCol === header.columnId,
      sortDescending: sortDir
    });
  };
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const totalPages = useMemo(() => {
    return Math.ceil(((data == null ? void 0 : data.length) || 0) / pageSize);
  }, [data == null ? void 0 : data.length, pageSize]);
  useEffect(() => {
    if (data) {
      changeCurrentRows(
        data.filter((row) => {
          return !includeSearch || !searchTerm || Object.values(row).some((value) => value.includes(searchTerm));
        }).sort((a, b) => {
          const aSortValue = `${a[sortCol]}`;
          const bSortValue = `${b[sortCol]}`;
          return sortDir ? aSortValue.localeCompare(bSortValue) : bSortValue.localeCompare(aSortValue);
        }).slice(
          (currentPageNumber - 1) * pageSize,
          currentPageNumber * pageSize
        )
      );
    }
  }, [
    sortCol,
    sortDir,
    data,
    currentPageNumber,
    pageSize,
    includeSearch,
    searchTerm
  ]);
  return /* @__PURE__ */ React.createElement(StyledWrapper$f, null, /* @__PURE__ */ React.createElement("div", {
    className: "above"
  }, includeSearch && /* @__PURE__ */ React.createElement(Search, {
    searchChangeHandler: changeSearchTerm
  })), /* @__PURE__ */ React.createElement("div", {
    className: "center",
    style: { height: tableHeight }
  }, /* @__PURE__ */ React.createElement(Table, {
    ...rest
  }, /* @__PURE__ */ React.createElement(THead, null, /* @__PURE__ */ React.createElement(TR, null, headers.map(
    (header) => header.enableSort ? sortableHeader(header) : /* @__PURE__ */ React.createElement(TH, {
      key: `${String(header.columnId)}`
    }, header.columnName)
  ))), /* @__PURE__ */ React.createElement(TBody, null, currentRows.map((row) => /* @__PURE__ */ React.createElement(TR, {
    key: `${row[dataIdAttribute]}`
  }, headers.map((header) => {
    var _a;
    return /* @__PURE__ */ React.createElement(TD, {
      key: `${String(header.columnId)}`
    }, (_a = row[header.columnId]) != null ? _a : "");
  })))))), /* @__PURE__ */ React.createElement("div", {
    className: "below"
  }, /* @__PURE__ */ React.createElement(Pagination, {
    initialStartPage: currentPageNumber,
    handlePageChange: setCurrentPageNumber,
    numberOfPages: totalPages
  })));
}
const StyledDivider = styled.div`
  background-color: ${palette["sp-light-gray-75"]};
  &.secondary {
    background-color: ${palette["sp-mid-gray"]};
  }

  &.horizontal {
    height: 1px;
    width: 100%;
    &.large {
      height: 2px;
    }
  }

  &.vertical {
    height: 100%;
    width: 1px;
    &.large {
      width: 2px;
    }
  }
`;
const Divider = (props) => {
  const { variant, size, orientation = "horizontal", ...rest } = props;
  const dividerClassName = classNames(variant, size, orientation);
  return /* @__PURE__ */ React.createElement(StyledDivider, {
    className: dividerClassName,
    ...rest
  });
};
const StyledWrapper$e = styled.div`
  margin: 16px 16px 2px 16px;
  .input-wrapper {
    background-color: ${palette["sp-light-gray-25"]};
  }
`;
const MenuSearch = (props) => {
  const { includeSearch, ...rest } = props;
  if (!props.includeSearch) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(StyledWrapper$e, null, /* @__PURE__ */ React.createElement(Search, {
    ...rest,
    size: "slim"
  }));
};
const StyledMenuItem = styled.li`
  list-style: none;
  padding: 8px 32px 8px 16px;
  position: relative;
  display: flex;

  &.readOnly {
    color: ${palette["sp-mid-gray"]};
  }

  &:hover {
    background: ${palette["sp-hover-light"]};
  }
  & .selected {
    position: absolute;
    top: 4px;
    right: 8px;
  }

  &:focus {
    outline: none;
    background: ${palette["sp-hover-light"]};
  }
`;
const StyledMenuItemValue$1 = styled.span`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
const BasicMenuItem = (props) => {
  const { name, value, selected, onChange } = props;
  const textToDisplay = name != null ? name : value;
  const handleClick = () => {
    onChange && !selected && onChange(props);
  };
  return /* @__PURE__ */ React.createElement(StyledMenuItem, {
    onClick: handleClick
  }, /* @__PURE__ */ React.createElement(StyledMenuItemValue$1, null, textToDisplay));
};
const StyledMenu = styled.div`
  ${typography};
  position: absolute;
  z-index: 999;
  width: 100%;
  border-radius: 4px;
  box-shadow: 0 0 8px 0 ${palette["sp-shadow"]};
  background-color: ${palette["sp-white"]};
`;
const GenericMenu = (props) => {
  const {
    open,
    closeMenu,
    variant,
    includeSearch,
    MenuItem,
    AboveListComponent,
    ListComponent,
    listComponentProps,
    ...rest
  } = props;
  const [search, changeSearch] = useState("");
  useEffect(() => {
    changeSearch("");
  }, [open]);
  if (!open) {
    return null;
  }
  const MenuItemComponent = MenuItem || BasicMenuItem;
  const menuClassname = classNames(variant);
  return /* @__PURE__ */ React.createElement(StyledMenu, {
    className: menuClassname,
    onBlur: closeMenu,
    ...rest
  }, /* @__PURE__ */ React.createElement(MenuSearch, {
    includeSearch,
    searchChangeHandler: changeSearch,
    autoFocus: true
  }), AboveListComponent ? AboveListComponent : null, /* @__PURE__ */ React.createElement(ListComponent, {
    MenuItem: MenuItemComponent,
    search,
    ...listComponentProps
  }));
};
const filterItems = (items, search) => {
  return search ? items.filter((item) => {
    const target = (item.name || item.value).toLowerCase();
    return target.includes(search.toLowerCase()) || item.divider;
  }) : items;
};
const scrollbars = (selector) => {
  return `
  ${selector} {
    scrollbar-color: ${palette["sp-dark-gray-25"]} ${palette["sp-light-gray-25"]}
  }
  ${selector}::-webkit-scrollbar {
    width: 10px;
    border-radius: 10px;
    background-color: ${palette["sp-light-gray-25"]};
  }
  ${selector}::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: ${palette["sp-light-gray-25"]};
  }
  ${selector}::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: ${palette["sp-dark-gray-25"]}; 
  }
`;
};
const StyledMenuWrapper$1 = styled.div`
  .menu-list {
    margin: 8px;
    padding: 0;
    max-height: 176px;
    overflow: auto;
  }
  ${scrollbars(".menu-list")}
`;
const List$1 = ({ search, menuItems, onChange, MenuItem }) => {
  const [displayedItems, changeDisplayedItems] = useState(menuItems);
  useEffect(() => {
    changeDisplayedItems(filterItems(menuItems, search));
  }, [search, menuItems]);
  return /* @__PURE__ */ React.createElement(StyledMenuWrapper$1, null, /* @__PURE__ */ React.createElement("ul", {
    id: "style-6",
    className: "menu-list"
  }, displayedItems.map((item) => /* @__PURE__ */ React.createElement(MenuItem, {
    key: item.value,
    ...item,
    onChange
  }))));
};
const Menu = (props) => {
  const { onChange, ...genericMenuProps } = props;
  return /* @__PURE__ */ React.createElement(GenericMenu, {
    ...genericMenuProps,
    ListComponent: List$1,
    listComponentProps: {
      menuItems: props.menuItems,
      onChange: props.onChange
    }
  });
};
const DropdownLabel = (props) => {
  if (!props.label) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Label, {
    className: props.className,
    label: props.label,
    required: props.required,
    disabled: props.disabled
  });
};
const PLACEHOLDER = "Select";
const MenuToggle$1 = (props) => {
  const iconVariant = props.open ? "chevron-up" : "chevron-down";
  const fill = props.disabled ? "sp-mid-gray" : "sp-black";
  return /* @__PURE__ */ React.createElement("span", {
    className: props.className
  }, /* @__PURE__ */ React.createElement(Icon, {
    variant: iconVariant,
    size: "small",
    fill
  }));
};
const StyledMenuToggle$1 = styled(MenuToggle$1)`
  flex: 0 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const StyledDropdownField = styled.div`
  width: calc(100% - 26px);
  min-width: 30px;
  padding: 8px 8px 8px 16px;
  border-radius: 2px;
  border: solid 1px ${palette["sp-light-gray-50"]};
  background-color: ${palette["sp-light-gray-25"]};

  display: flex;

  &.is-enabled {
    cursor: pointer;
  }

  &.has-label {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  &.secondary {
    width: 100%;
    text-align: right;
    background-color: transparent;
    padding: 2px;
    border: none;
  }
`;
const StyledValue$1 = styled("span")`
  ${typography};
  line-height: 1.71;
  flex: 1 1;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: ${(props) => props.disabled ? palette["sp-mid-gray"] : palette["sp-black"]};

  &.secondary {
    font-size: 12px;
    padding-right: 8px;
  }
`;
const BaseDropdownField = forwardRef((props, ref) => {
  const dropdownFieldClass = classNames(
    "dropdown-field",
    props.dropdownValueClass
  );
  return /* @__PURE__ */ React.createElement(StyledDropdownField, {
    ref,
    className: dropdownFieldClass,
    "aria-label": props.label || PLACEHOLDER,
    onClick: props.handleMenuToggleClick,
    onKeyDown: props.openMenuOption,
    tabIndex: 0,
    role: "button"
  }, props.children, /* @__PURE__ */ React.createElement(StyledMenuToggle$1, {
    open: props.open,
    disabled: props.disabled
  }));
});
const DropdownField = forwardRef(
  (props, ref) => {
    const dropdownValueClass = classNames(props.variant, {
      "has-label": props.label,
      "is-enabled": !props.disabled
    });
    return /* @__PURE__ */ React.createElement(BaseDropdownField, {
      ref,
      tabIndex: 0,
      dropdownValueClass,
      ...props
    }, /* @__PURE__ */ React.createElement(StyledValue$1, {
      className: dropdownValueClass,
      disabled: props.disabled
    }, props.displayValue));
  }
);
const ReStyledMenuItem$1 = styled(StyledMenuItem)`
  padding-left: 0;
  padding-right: 0;
  &:hover {
    background: none;
  }
`;
const DividerMenuItem = () => {
  return /* @__PURE__ */ React.createElement(ReStyledMenuItem$1, null, /* @__PURE__ */ React.createElement(Divider, null));
};
const SelectedIcon$1 = (props) => {
  return /* @__PURE__ */ React.createElement("span", {
    className: "selected",
    "data-testid": `${props.value}-selected`
  }, /* @__PURE__ */ React.createElement(Icon, {
    variant: "check",
    fill: "serena"
  }));
};
const DropdownMenuItem = (props) => {
  var _a;
  if (props.divider) {
    return /* @__PURE__ */ React.createElement(DividerMenuItem, null);
  }
  const textToDisplay = (_a = props.name) != null ? _a : props.value;
  const handleClick = () => {
    props.onChange && props.onChange(props);
  };
  const keyEventHandler = (event) => {
    var _a2, _b;
    const listElements = Array();
    const elements = document.getElementsByTagName("li");
    for (let i = 0; i < elements.length; i++) {
      if (elements[i].hasAttribute("tabindex") && !elements[i].className.includes("readOnly")) {
        listElements.push(elements[i]);
      }
    }
    if (!props.readOnly && event.keyCode === 13) {
      props.onChange && props.onChange(props);
    } else if (!props.readOnly && event.keyCode === 40) {
      for (let i = 0; i < listElements.length; i++) {
        if (listElements[i] === document.activeElement) {
          (_a2 = listElements[i + 1]) == null ? void 0 : _a2.focus();
          break;
        }
      }
    } else if (!props.readOnly && event.keyCode === 38) {
      for (let i = 0; i < listElements.length; i++) {
        if (listElements[i] === document.activeElement) {
          (_b = listElements[i - 1]) == null ? void 0 : _b.focus();
          break;
        }
      }
    }
  };
  return /* @__PURE__ */ React.createElement(StyledMenuItem, {
    onClick: handleClick,
    tabIndex: 0,
    onKeyDown: keyEventHandler,
    className: props.selected ? "selectedItem" : ""
  }, /* @__PURE__ */ React.createElement(StyledMenuItemValue$1, null, textToDisplay), props.selected && /* @__PURE__ */ React.createElement(SelectedIcon$1, {
    ...props
  }));
};
function useDetectClickOutside({
  onTriggered,
  disableClick,
  disableKeys,
  allowAnyKey,
  triggerKeys
}) {
  const ref = useRef(null);
  const keyListener = useCallback((e) => {
    if (allowAnyKey) {
      onTriggered(e);
    } else if (triggerKeys) {
      if (triggerKeys.includes(e.key)) {
        onTriggered(e);
      }
    } else {
      if (e.key === "Escape") {
        onTriggered(e);
      }
    }
  }, []);
  const clickListener = useCallback(
    (e) => {
      if (ref == null ? void 0 : ref.current) {
        if (!ref.current.contains(e.target)) {
          onTriggered == null ? void 0 : onTriggered(e);
        }
      }
    },
    [ref.current]
  );
  useEffect(() => {
    !disableClick && document.addEventListener("click", clickListener, { capture: true });
    !disableKeys && document.addEventListener("keyup", keyListener);
    return () => {
      !disableClick && document.removeEventListener("click", clickListener, { capture: true });
      !disableKeys && document.removeEventListener("keyup", keyListener);
    };
  }, []);
  return ref;
}
const StyledWrapper$d = styled.div`
  position: relative;
`;
const Dropdown = (props) => {
  const {
    variant,
    label,
    required,
    menuItems,
    value,
    className,
    includeSearch,
    onItemSelect,
    placeholderText = "Select",
    disabled = false,
    excludeDeselectOption,
    AboveListComponent,
    inputId,
    ...rest
  } = props;
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(value || placeholderText);
  const [displayValue, setDisplayValue] = useState("default");
  const dropdownRef = useRef(null);
  const getMenuItems = () => {
    const deselectMenuItem = { name: placeholderText, value: "default" };
    const menuItems2 = props.menuItems.map((item) => {
      return { ...item, selected: item.value === selectedValue };
    });
    return excludeDeselectOption ? menuItems2 : [deselectMenuItem, ...menuItems2];
  };
  const nodeRef = useDetectClickOutside({
    onTriggered: () => {
      setMenuOpen(false);
    }
  });
  useEffect(() => {
    const selectedItem = getMenuItems().find(
      (item) => item.value === selectedValue
    );
    const selectedDisplayValue = selectedItem && (selectedItem.name || selectedItem.value);
    setDisplayValue(`${selectedDisplayValue || value || placeholderText}`);
  }, [menuItems, selectedValue]);
  useEffect(() => {
    setSelectedValue(`${value || "default"}`);
  }, [value]);
  const handleMenuToggleClick = () => {
    !disabled && setMenuOpen(!menuOpen);
  };
  const menuOnChange = (selectedItem) => {
    setSelectedValue(selectedItem.value);
    onItemSelect && onItemSelect(selectedItem.value);
    setMenuOpen(false);
    if (dropdownRef == null ? void 0 : dropdownRef.current) {
      dropdownRef.current.focus();
    }
  };
  const openMenuOption = (event) => {
    var _a;
    const listElements = Array();
    const elements = document.getElementsByTagName("li");
    for (let i = 0; i < elements.length; i++) {
      if (elements[i].hasAttribute("tabindex") && !elements[i].className.includes("readOnly")) {
        listElements.push(elements[i]);
      }
    }
    if (event.keyCode === 40) {
      if (menuOpen) {
        (_a = listElements[0]) == null ? void 0 : _a.focus();
      } else {
        setMenuOpen(true);
      }
    }
  };
  const closeMenuOption = (event) => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setMenuOpen(false);
    }
  };
  return /* @__PURE__ */ React.createElement(StyledWrapper$d, {
    className,
    ref: nodeRef,
    ...rest
  }, /* @__PURE__ */ React.createElement(DropdownLabel, {
    label: props.label,
    required,
    disabled: props.disabled
  }), /* @__PURE__ */ React.createElement(DropdownField, {
    id: inputId,
    ref: dropdownRef,
    displayValue,
    tabIndex: 0,
    handleMenuToggleClick,
    openMenuOption,
    open: menuOpen,
    label: props.label,
    variant: props.variant,
    disabled
  }), /* @__PURE__ */ React.createElement(Menu, {
    variant: props.variant,
    MenuItem: DropdownMenuItem,
    closeMenu: closeMenuOption,
    open: menuOpen,
    includeSearch,
    menuItems: getMenuItems(),
    onChange: menuOnChange,
    AboveListComponent
  }));
};
var loader = "data:image/gif;base64,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";
const Loader = (props) => {
  return /* @__PURE__ */ React.createElement("img", {
    src: loader,
    alt: "loading",
    ...props
  });
};
const StyledOverlay = styled.div`
  @keyframes overlay {
    0% {
      background-color: inherit;
    }
    100% {
      background-color: ${palette["sp-overlay"]};
    }
  }

  position: fixed;
  top: 0;
  left: 0;
  z-index: 9000;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background-color: ${palette["sp-overlay"]};
  animation: overlay 0.5s;
`;
const StyledModal = styled.div`
  ${typography};

  @keyframes slide-down {
    0% {
      transform: translate3d(0, -52px, 0);
    }
    100% {
      transform: translate3d(0, 0, 0);
    }
  }

  width: 400px;
  max-width: 100%;
  height: 240px;
  max-height: 100%;
  display: flex;
  flex-direction: column;

  padding: 24px;
  background-color: ${palette["sp-white"]};
  border-top: 4px solid ${palette["sp-black"]};
  border-radius: 4px;
  animation: slide-down 0.5s;

  .modal-header {
    font-weight: bold;
    line-height: 24px;
    letter-spacing: 3px;
    text-transform: uppercase;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    .icon {
      padding-right: 16px;
    }
  }

  .modal-content {
    flex: 1 1;
    line-height: 1.71;
  }

  .modal-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    height: 48px;
    .close {
      position: absolute;
      right: 24px;
      cursor: pointer;
    }
  }

  &.success {
    border-top-color: ${palette["serena"]};
  }

  &.error {
    border-top-color: ${palette["jordan"]};
  }

  &.warning {
    border-top-color: ${palette["pele"]};
  }
`;
const Modal = (props) => {
  const {
    title,
    children,
    variant,
    className,
    modalAction,
    closeText = "Close",
    handleClose,
    ...rest
  } = props;
  const modalClassName = classNames(className, variant);
  return /* @__PURE__ */ React.createElement(StyledOverlay, null, /* @__PURE__ */ React.createElement(StyledModal, {
    className: modalClassName,
    ...rest
  }, title && /* @__PURE__ */ React.createElement("div", {
    className: "modal-header"
  }, variant === "success" && /* @__PURE__ */ React.createElement(Icon, {
    className: "icon",
    variant: "check",
    fill: "serena"
  }), variant === "error" && /* @__PURE__ */ React.createElement(Icon, {
    className: "icon",
    variant: "error",
    fill: "jordan"
  }), variant === "warning" && /* @__PURE__ */ React.createElement(Icon, {
    className: "icon",
    variant: "warning",
    fill: "pele"
  }), /* @__PURE__ */ React.createElement("span", null, title)), /* @__PURE__ */ React.createElement("div", {
    className: "modal-content"
  }, children), /* @__PURE__ */ React.createElement("div", {
    className: "modal-footer"
  }, modalAction && /* @__PURE__ */ React.createElement(Button, {
    onClick: modalAction.onClick,
    disabled: modalAction.disabled
  }, modalAction.text), /* @__PURE__ */ React.createElement("span", {
    className: "close",
    onClick: handleClose
  }, closeText))));
};
const StyledWrapper$c = styled.span`
  ${typography};
  font-size: 12px;
  line-height: 1.33;
  border-radius: 16px;
  padding: 8px 8px 8px 16px;
  display: inline-flex;
  align-items: center;

  color: ${palette["sp-white"]};
  background-color: ${palette["sp-black"]};

  span:first-child {
    padding-right: 8px;
  }
  svg {
    cursor: pointer;
  }
`;
const Tag = (props) => {
  const { value, name, handleIconClick, ...rest } = props;
  const handleClick = useCallback(
    (e, value2) => {
      handleIconClick && handleIconClick(value2);
      e.stopPropagation();
    },
    [handleIconClick]
  );
  return /* @__PURE__ */ React.createElement(StyledWrapper$c, {
    ...rest
  }, /* @__PURE__ */ React.createElement("span", null, name != null ? name : value), /* @__PURE__ */ React.createElement(Icon, {
    variant: "x",
    fill: "sp-white",
    size: "small",
    onClick: (e) => handleClick(e, value)
  }));
};
const StyledWrapper$b = styled.div`
  ${typography};
  min-height: 23px;
  flex-wrap: wrap;
  line-height: 1.71;
  flex: 1 1;
  span {
    cursor: auto;
    span:last-child {
      cursor: pointer !important;
    }
  }
`;
const StyledTag = styled(Tag)`
  margin: 0 4px 4px 0;
`;
const DropdownFieldWithTags = (props) => {
  const { selectedItems, placeholder, ...rest } = props;
  const dropdownValueClass = classNames({
    "has-label": props.label
  });
  const handleIconClick = (value) => {
    const selectedItem = props.selectedItems.find(
      (item) => item.value === value
    );
    selectedItem && props.handleMenuItemClick(selectedItem);
  };
  return /* @__PURE__ */ React.createElement(BaseDropdownField, {
    onKeyDown: props.openMenuOption,
    dropdownValueClass,
    ...rest
  }, /* @__PURE__ */ React.createElement(StyledWrapper$b, null, selectedItems.length ? selectedItems.map((item) => /* @__PURE__ */ React.createElement(StyledTag, {
    name: item.name,
    value: item.value,
    key: item.value,
    handleIconClick
  })) : placeholder));
};
const ReStyledMenuItem = styled(StyledMenuItem)`
  padding-left: 8px;
`;
const StyledValueWrapper = styled(StyledMenuItemValue$1)`
  padding: 1px 0 0 8px;
`;
const StyledIcon = styled(Icon)`
  cursor: pointer;
  &.readOnly {
    cursor: auto;
  }
`;
const MultiSelectMenuItem = (props) => {
  var _a;
  const [checked, changeChecked] = useState(props.selected || false);
  useEffect(() => {
    changeChecked(props.selected || false);
  }, [props.selected]);
  if (props.divider) {
    return /* @__PURE__ */ React.createElement(DividerMenuItem, null);
  }
  const textToDisplay = (_a = props.name) != null ? _a : props.value;
  const handleClick = () => {
    if (!props.readOnly) {
      changeChecked(!checked);
      props.onChange && props.onChange(props);
    }
  };
  const keyEventHandler = (event) => {
    var _a2, _b;
    const listElements = Array();
    const elements = document.getElementsByTagName("li");
    for (let i = 0; i < elements.length; i++) {
      if (elements[i].hasAttribute("tabindex") && !elements[i].className.includes("readOnly")) {
        listElements.push(elements[i]);
      }
    }
    if (!props.readOnly && event.keyCode === 13) {
      changeChecked(!checked);
      props.onChange && props.onChange(props);
    } else if (!props.readOnly && event.keyCode === 40) {
      for (let i = 0; i < listElements.length; i++) {
        if (listElements[i] === document.activeElement) {
          (_a2 = listElements[i + 1]) == null ? void 0 : _a2.focus();
          break;
        }
      }
    } else if (!props.readOnly && event.keyCode === 38) {
      for (let i = 0; i < listElements.length; i++) {
        if (listElements[i] === document.activeElement) {
          (_b = listElements[i - 1]) == null ? void 0 : _b.focus();
          break;
        }
      }
    }
  };
  const menuItemClassName = classNames({ readOnly: props.readOnly });
  return /* @__PURE__ */ React.createElement(ReStyledMenuItem, {
    className: menuItemClassName,
    onClick: handleClick,
    tabIndex: 0,
    onKeyDown: keyEventHandler
  }, /* @__PURE__ */ React.createElement(StyledIcon, {
    className: menuItemClassName,
    variant: checked ? "checkbox-selected" : "checkbox-unselected",
    size: "small",
    fill: props.readOnly ? "sp-mid-gray" : "sp-black"
  }), /* @__PURE__ */ React.createElement(StyledValueWrapper, null, textToDisplay));
};
const StyledWrapper$a = styled.ul`
  font-size: 12px;
  margin: 0;
  padding: 0 0 0 8px;
  border-bottom: 1px solid ${palette["sp-light-gray-75"]};
  li {
    cursor: pointer;
    font-weight: bold;
    align-items: center;
  }
  li:focus {
    outline: none;
    background: ${palette["sp-hover-light"]};
  }
`;
const MultiSelectToggleAll = (props) => {
  return /* @__PURE__ */ React.createElement(StyledWrapper$a, {
    className: props.className
  }, /* @__PURE__ */ React.createElement(MultiSelectMenuItem, {
    value: `${props.selected ? "Deselect" : "Select"} All`,
    selected: props.selected,
    onChange: props.handleToggleAll
  }));
};
const StyledWrapper$9 = styled.div`
  position: relative;
`;
const getDisplayValue$1 = (selectedItems, menuItems, itemDisplayType) => {
  if (selectedItems.length > 1) {
    const everyItemSelected = menuItems.every(
      (item) => selectedItems.includes(item) || item.divider
    );
    const countOrAll = everyItemSelected ? "All" : `${selectedItems.length}`;
    return `${countOrAll} ${itemDisplayType ? pluralize(
      itemDisplayType,
      menuItems.length === 1 ? 0 : selectedItems.length
    ) : "Selected"}`;
  } else if (selectedItems.length === 1 && menuItems && menuItems.length) {
    const index = selectedItems.length - 1;
    return selectedItems[index].name || selectedItems[index].value;
  }
  return `Select ${itemDisplayType ? pluralize(itemDisplayType, selectedItems.length) : ""}`;
};
const isDifferent = (a1, a2) => {
  const a1Set = new Set(a1.map((item) => item.value));
  const a2Set = new Set(a2.map((item) => item.value));
  return a1Set.size !== a2Set.size || [...a1Set].some((value) => !a2Set.has(value));
};
const GenericMultiSelect = (props) => {
  const {
    menuItems,
    includeSearch,
    includeSelectAll,
    initialSelectedItems = [],
    label,
    required,
    className,
    itemDisplayType,
    fixedDisplayText,
    handleMenuItemClick,
    handleSelectedItemsChange,
    handleSelectAllClick,
    handleMenuClose,
    MenuComponent,
    menuComponentProps,
    ...rest
  } = props;
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState(initialSelectedItems);
  const [displayValue, setDisplayValue] = useState(
    getDisplayValue$1(initialSelectedItems, props.menuItems, itemDisplayType)
  );
  const [toggleAllChecked, setToggleAllChecked] = useState(
    initialSelectedItems.length === props.menuItems.length
  );
  const multiSelectRef = useDetectClickOutside({
    onTriggered: () => {
      setMenuOpen(false);
    }
  });
  const closeMenuOption = (event) => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setMenuOpen(false);
    }
  };
  const openMenuOption = (event) => {
    var _a;
    const listElements = Array();
    const elements = document.getElementsByTagName("li");
    for (let i = 0; i < elements.length; i++) {
      if (elements[i].hasAttribute("tabindex") && !elements[i].className.includes("readOnly")) {
        listElements.push(elements[i]);
      }
    }
    if (event.keyCode === 40) {
      if (menuOpen) {
        (_a = listElements[0]) == null ? void 0 : _a.focus();
      } else {
        setMenuOpen(true);
      }
    }
  };
  useEffect(() => {
    if (props.initialSelectedItems) {
      if (isDifferent(initialSelectedItems, selectedItems)) {
        setSelectedItems(initialSelectedItems);
      }
    }
  }, [props.initialSelectedItems]);
  useEffect(() => {
    setDisplayValue(
      getDisplayValue$1(selectedItems, props.menuItems, itemDisplayType)
    );
  }, [selectedItems, props.menuItems, itemDisplayType]);
  useEffect(() => {
    handleSelectedItemsChange == null ? void 0 : handleSelectedItemsChange(selectedItems.map((item) => item.value));
  }, [selectedItems, handleSelectedItemsChange]);
  const handleMenuToggleClick = () => {
    const newMenuOpenState = !menuOpen;
    setMenuOpen(newMenuOpenState);
    !newMenuOpenState && handleMenuClose && handleMenuClose();
  };
  const _handleMenuItemClick = (clickedItem) => {
    const newSelectedItems = selectedItems.find(
      (selectedItem) => selectedItem.value === clickedItem.value
    ) ? selectedItems.filter((item) => item.value !== clickedItem.value) : [...selectedItems, clickedItem];
    setSelectedItems(newSelectedItems);
    setToggleAllChecked(newSelectedItems.length === props.menuItems.length);
    handleMenuItemClick && handleMenuItemClick(clickedItem);
  };
  const handleToggleAll = () => {
    if (selectedItems.length === props.menuItems.length) {
      setSelectedItems([]);
      setToggleAllChecked(false);
      handleSelectAllClick && handleSelectAllClick(false);
    } else {
      setSelectedItems(props.menuItems);
      setToggleAllChecked(true);
      handleSelectAllClick && handleSelectAllClick(true);
    }
  };
  const enhancedMenuItems = props.menuItems.map((item) => {
    return {
      ...item,
      selected: !!selectedItems.find(
        (selectedItem) => selectedItem.value === item.value
      )
    };
  });
  return /* @__PURE__ */ React.createElement(StyledWrapper$9, {
    className,
    ref: multiSelectRef,
    ...rest
  }, /* @__PURE__ */ React.createElement(DropdownLabel, {
    tabIndex: 0,
    label: props.label,
    required
  }), props.includeTags ? /* @__PURE__ */ React.createElement(DropdownFieldWithTags, {
    tabIndex: 0,
    openMenuOption,
    selectedItems,
    handleMenuToggleClick,
    handleMenuItemClick: _handleMenuItemClick,
    open: menuOpen,
    label: props.label,
    placeholder: fixedDisplayText || getDisplayValue$1([], [], itemDisplayType)
  }) : /* @__PURE__ */ React.createElement(DropdownField, {
    displayValue: fixedDisplayText || displayValue,
    handleMenuToggleClick,
    open: menuOpen,
    tabIndex: 0,
    openMenuOption,
    label: props.label
  }), /* @__PURE__ */ React.createElement(MenuComponent, {
    MenuItem: MultiSelectMenuItem,
    open: menuOpen,
    closeMenu: closeMenuOption,
    menuItems: enhancedMenuItems,
    onChange: _handleMenuItemClick,
    includeSearch: props.includeSearch,
    AboveListComponent: props.includeSelectAll ? /* @__PURE__ */ React.createElement(MultiSelectToggleAll, {
      tabIndex: 0,
      selected: toggleAllChecked,
      handleToggleAll
    }) : void 0,
    ...menuComponentProps
  }));
};
const MultiSelect = (props) => {
  return /* @__PURE__ */ React.createElement(GenericMultiSelect, {
    ...props,
    MenuComponent: Menu,
    menuComponentProps: {}
  });
};
const StyledWrapper$8 = styled.div`
  position: relative;
`;
const getDisplayValue = (selectedItems, menuItems, itemDisplayType) => {
  if (selectedItems.length > 1) {
    const everyItemSelected = menuItems.every(
      (item) => selectedItems.includes(item) || item.divider
    );
    const countOrAll = everyItemSelected ? "All" : `${selectedItems.length}`;
    return `${countOrAll} ${itemDisplayType ? pluralize(
      itemDisplayType,
      menuItems.length === 1 ? 0 : selectedItems.length
    ) : "Selected"}`;
  } else if (selectedItems.length === 1 && menuItems && menuItems.length) {
    const index = selectedItems.length - 1;
    return selectedItems[index].name || selectedItems[index].value;
  }
  return `Select ${itemDisplayType ? pluralize(itemDisplayType, selectedItems.length) : ""}`;
};
const ControlledMultiSelect = (props) => {
  const {
    menuItems,
    selectedItems,
    includeSearch,
    includeSelectAll,
    label,
    required,
    className,
    itemDisplayType,
    fixedDisplayText,
    handleMenuItemClick,
    handleSelectedItemsChange,
    handleMenuClose,
    handleSelectAllClick,
    ...rest
  } = props;
  const [menuOpen, setMenuOpen] = useState(false);
  const multiSelectRef = useDetectClickOutside({
    onTriggered: () => {
      setMenuOpen(false);
    }
  });
  const closeMenuOption = (event) => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setMenuOpen(false);
    }
  };
  const openMenuOption = (event) => {
    var _a;
    const listElements = Array();
    const elements = document.getElementsByTagName("li");
    for (let i = 0; i < elements.length; i++) {
      if (elements[i].hasAttribute("tabindex") && !elements[i].className.includes("readOnly")) {
        listElements.push(elements[i]);
      }
    }
    if (event.keyCode === 40) {
      if (menuOpen) {
        (_a = listElements[0]) == null ? void 0 : _a.focus();
      } else {
        setMenuOpen(true);
      }
    }
  };
  const handleMenuToggleClick = () => {
    const newMenuOpenState = !menuOpen;
    setMenuOpen(newMenuOpenState);
    !newMenuOpenState && handleMenuClose && handleMenuClose();
  };
  const _handleMenuItemClick = (clickedItem) => {
    const menuItemFromClicked = menuItems.find(
      (item) => item.value === clickedItem.value
    );
    if (!menuItemFromClicked) {
      return;
    }
    const selectedItemFromClicked = selectedItems.find(
      (item) => item.value === clickedItem.value
    );
    const newSelectedItems = selectedItemFromClicked ? selectedItems.filter((item) => item.value !== clickedItem.value) : [...selectedItems, menuItemFromClicked];
    handleSelectedItemsChange(newSelectedItems.map((item) => item.value));
    handleMenuItemClick && handleMenuItemClick(clickedItem);
  };
  const handleToggleAll = () => {
    if (selectedItems.length === props.menuItems.length) {
      handleSelectedItemsChange([]);
      handleSelectAllClick && handleSelectAllClick(false);
    } else {
      handleSelectedItemsChange(props.menuItems.map((item) => item.value));
      handleSelectAllClick && handleSelectAllClick(true);
    }
  };
  const enhancedMenuItems = props.menuItems.map((item) => {
    return {
      ...item,
      selected: !!selectedItems.find(
        (selectedItem) => selectedItem.value === item.value
      )
    };
  });
  return /* @__PURE__ */ React.createElement(StyledWrapper$8, {
    className,
    ref: multiSelectRef,
    ...rest
  }, /* @__PURE__ */ React.createElement(DropdownLabel, {
    tabIndex: 0,
    label: props.label,
    required
  }), props.includeTags ? /* @__PURE__ */ React.createElement(DropdownFieldWithTags, {
    tabIndex: 0,
    openMenuOption,
    selectedItems,
    handleMenuToggleClick,
    handleMenuItemClick: _handleMenuItemClick,
    open: menuOpen,
    label: props.label,
    placeholder: fixedDisplayText || getDisplayValue([], [], itemDisplayType)
  }) : /* @__PURE__ */ React.createElement(DropdownField, {
    displayValue: fixedDisplayText || getDisplayValue(selectedItems, props.menuItems, itemDisplayType),
    handleMenuToggleClick,
    open: menuOpen,
    tabIndex: 0,
    openMenuOption,
    label: props.label
  }), /* @__PURE__ */ React.createElement(Menu, {
    MenuItem: MultiSelectMenuItem,
    open: menuOpen,
    closeMenu: closeMenuOption,
    menuItems: enhancedMenuItems,
    onChange: _handleMenuItemClick,
    includeSearch: props.includeSearch,
    AboveListComponent: props.includeSelectAll ? /* @__PURE__ */ React.createElement(MultiSelectToggleAll, {
      tabIndex: 0,
      selected: selectedItems.length === menuItems.length,
      handleToggleAll
    }) : void 0
  }));
};
const Row = ({
  index,
  style: style2,
  data,
  RowComponent
}) => {
  const item = data == null ? void 0 : data[index];
  return /* @__PURE__ */ React.createElement("div", {
    style: style2
  }, /* @__PURE__ */ React.createElement(RowComponent, {
    index,
    item
  }));
};
const LazyList = ({
  items,
  itemCount,
  RowComponent,
  itemSize,
  maxHeight,
  onItemsRendered,
  listRef
}) => {
  const height = Math.min(maxHeight, itemSize * itemCount);
  return /* @__PURE__ */ React.createElement(FixedSizeList, {
    className: "lazy-list",
    height,
    itemCount,
    itemSize,
    width: "100%",
    itemData: items,
    onItemsRendered,
    ref: listRef
  }, (rowProps) => /* @__PURE__ */ React.createElement(Row, {
    RowComponent,
    ...rowProps
  }));
};
const LoadingWrapper = styled.span`
  margin: 8px;
`;
const AsyncLazyList = ({
  items,
  itemSize,
  maxHeight,
  RowComponent,
  hasNextPage,
  loadNextPage,
  threshold,
  infiniteLoaderRef,
  isInitializing
}) => {
  const isItemLoaded = (index) => !hasNextPage || index < items.length;
  const Loader2 = () => /* @__PURE__ */ React.createElement(LoadingWrapper, null, "Loading...");
  const LoadingRowComponent = ({ index, item }) => isItemLoaded(index) ? /* @__PURE__ */ React.createElement(RowComponent, {
    index,
    item
  }) : /* @__PURE__ */ React.createElement(Loader2, null);
  const itemCount = hasNextPage ? items.length + 1 : items.length;
  if (isInitializing)
    return /* @__PURE__ */ React.createElement(Loader2, null);
  return /* @__PURE__ */ React.createElement(InfiniteLoader, {
    isItemLoaded,
    itemCount,
    loadMoreItems: loadNextPage,
    threshold,
    ref: infiniteLoaderRef
  }, ({ onItemsRendered, ref }) => /* @__PURE__ */ React.createElement(LazyList, {
    items,
    itemCount,
    itemSize,
    maxHeight,
    RowComponent: LoadingRowComponent,
    onItemsRendered,
    listRef: ref
  }));
};
const StyledMenuWrapper = styled.div`
  .lazy-list {
    background-color: ${palette["sp-white"]};
  }
  ${scrollbars(".lazy-list")}
`;
const List = ({
  search,
  menuItems,
  setMenuItems,
  loadNextPage,
  searchLoadNextPage,
  MenuItem,
  onChange,
  itemSize = 36,
  maxHeight = 176,
  threshold
}) => {
  const [displayedItems, changeDisplayedItems] = useState(menuItems);
  const [
    currentLoadNextPage,
    setCurrentLoadNextPage
  ] = useState();
  const [hasNextPage, setHasNextPage] = useState(false);
  const [isInitializingList, setIsInitializingList] = useState(false);
  const infiniteLoaderRef = useRef(null);
  useEffect(() => {
    if (searchLoadNextPage) {
      changeDisplayedItems(menuItems);
    } else {
      changeDisplayedItems(filterItems(menuItems, search));
    }
  }, [search, menuItems]);
  useEffect(() => {
    setHasNextPage(false);
    if (search && !searchLoadNextPage) {
      return;
    }
    let active = true;
    const concurrentLoadNextPage = (startIndex, endIndex) => {
      const loadingData = search ? searchLoadNextPage == null ? void 0 : searchLoadNextPage(search, startIndex, endIndex) : loadNextPage(startIndex, endIndex);
      return loadingData == null ? void 0 : loadingData.then(({ data, hasNextPage: hasNextPage2 }) => {
        if (!active) {
          return;
        }
        setIsInitializingList(false);
        setMenuItems == null ? void 0 : setMenuItems(
          (prevData) => prevData && Array.isArray(prevData) ? [...prevData, ...data] : data
        );
        setHasNextPage(hasNextPage2);
      });
    };
    setCurrentLoadNextPage(() => concurrentLoadNextPage);
    return () => {
      active = false;
    };
  }, [search]);
  useEffect(() => {
    var _a;
    if (!currentLoadNextPage)
      return;
    if (displayedItems == null ? void 0 : displayedItems.length)
      setMenuItems == null ? void 0 : setMenuItems([]);
    (_a = infiniteLoaderRef == null ? void 0 : infiniteLoaderRef.current) == null ? void 0 : _a.resetloadMoreItemsCache();
    setIsInitializingList(true);
    currentLoadNextPage(0);
  }, [currentLoadNextPage]);
  if (!currentLoadNextPage)
    return null;
  return /* @__PURE__ */ React.createElement(StyledMenuWrapper, null, /* @__PURE__ */ React.createElement(AsyncLazyList, {
    infiniteLoaderRef,
    items: displayedItems,
    hasNextPage,
    loadNextPage: currentLoadNextPage,
    itemSize,
    maxHeight,
    threshold,
    RowComponent: ({ item }) => /* @__PURE__ */ React.createElement(MenuItem, {
      key: item.value,
      ...item,
      onChange
    }),
    isInitializing: isInitializingList
  }));
};
const AsyncMenu = (props) => {
  const {
    onChange,
    menuItems,
    setMenuItems,
    loadNextPage,
    searchLoadNextPage,
    itemSize,
    maxHeight,
    threshold,
    ...genericMenuProps
  } = props;
  return /* @__PURE__ */ React.createElement(GenericMenu, {
    ...genericMenuProps,
    ListComponent: List,
    listComponentProps: {
      menuItems,
      onChange,
      setMenuItems,
      loadNextPage,
      searchLoadNextPage,
      itemSize,
      maxHeight,
      threshold
    }
  });
};
const AsyncMultiSelect = (props) => {
  const {
    loadNextPage,
    searchLoadNextPage,
    itemSize,
    maxHeight,
    threshold,
    ...multiSelectProps
  } = props;
  const [menuItems, setMenuItems] = useState([]);
  return /* @__PURE__ */ React.createElement(GenericMultiSelect, {
    ...multiSelectProps,
    menuItems,
    MenuComponent: AsyncMenu,
    menuComponentProps: {
      setMenuItems,
      loadNextPage,
      searchLoadNextPage,
      itemSize,
      maxHeight,
      threshold
    }
  });
};
const StyledWrapper$7 = styled.div`
  ${typography};
  height: 40px;
  padding: 0 12px 0 16px;
  display: flex;
  align-items: center;
  opacity: 1;

  background-color: ${palette["tendulkar-op-24"]};
  .message {
    flex: 1 1;
    padding-left: 8px;
    font-weight: 500;
    line-height: 1.71;
  }
  &.success {
    background-color: ${palette["serena-op-24"]};
  }
  &.warning {
    background-color: ${palette["pele-op-24"]};
  }
  &.error {
    background-color: ${palette["jordan-op-24"]};
  }

  &.closed {
    opacity: 0;
    transition: opacity 1s ease-out;
  }
`;
const variantIcons = {
  success: { variant: "check", fill: "serena" },
  warning: { variant: "warning", fill: "pele" },
  error: { variant: "error", fill: "jordan" },
  information: { variant: "info", fill: "tendulkar" }
};
const Notification = (props) => {
  const { variant = "information", iconOnClick, children, ...rest } = props;
  const [status, changeStatus] = useState("open");
  if (status === "closed") {
    return null;
  }
  const onClick = (event) => {
    iconOnClick && iconOnClick(event);
    changeStatus("closing");
    setTimeout(() => changeStatus("closed"), 1e3);
  };
  const notificationClassName = classNames(variant, {
    closed: status !== "open"
  });
  return /* @__PURE__ */ React.createElement(StyledWrapper$7, {
    className: notificationClassName,
    ...rest
  }, /* @__PURE__ */ React.createElement(Icon, {
    variant: variantIcons[variant].variant,
    fill: variantIcons[variant].fill,
    size: "small"
  }), /* @__PURE__ */ React.createElement("div", {
    className: "message"
  }, children), /* @__PURE__ */ React.createElement(IconWithHover, {
    variant: "x",
    size: "small",
    onClick
  }));
};
const PanelToggle = (props) => {
  const iconVariant = props.open ? "chevron-up" : "chevron-down";
  return /* @__PURE__ */ React.createElement("span", {
    className: props.className,
    onClick: props.onClick
  }, /* @__PURE__ */ React.createElement(IconWithHover, {
    variant: iconVariant,
    size: "medium"
  }));
};
const StyledPanel = styled.div`
  ${typography};

  display: inline-block;
  width: 100%;

  &.shadow {
    box-shadow: 0 0 8px 0 ${palette["sp-shadow"]};
  }

  .panel-header,
  .panel-content {
    background-color: ${palette["sp-white"]};
  }

  .panel-header {
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 2px;
    text-transform: uppercase;
    padding: 12px 24px 8px 24px;
    border-radius: 4px 4px 0 0;
    display: flex;
    align-items: center;
    .panel-header-text {
      flex: 1 1;
    }
  }

  .panel-content {
    border-radius: 0 0 4px 4px;
    padding: 24px 24px 16px 24px;
  }

  .panel-toggle {
    cursor: pointer;
  }
`;
const Panel = (props) => {
  const {
    title,
    shadow,
    resetClose = false,
    handleOpen,
    handleClose,
    children,
    className,
    ...rest
  } = props;
  const [open, changeOpen] = useState(!resetClose);
  useEffect(() => {
    changeOpen(!resetClose);
  }, [resetClose]);
  const togglePanel = (newState) => {
    changeOpen(newState);
    newState ? handleOpen && handleOpen() : handleClose && handleClose();
  };
  const panelClassName = classNames(className, {
    shadow: props.shadow
  });
  return /* @__PURE__ */ React.createElement(StyledPanel, {
    className: panelClassName,
    ...rest
  }, title && /* @__PURE__ */ React.createElement("div", {
    className: "panel-header"
  }, /* @__PURE__ */ React.createElement("span", {
    className: "panel-header-text"
  }, title), /* @__PURE__ */ React.createElement(PanelToggle, {
    className: "panel-toggle",
    open,
    onClick: () => togglePanel(!open)
  })), open && /* @__PURE__ */ React.createElement("div", {
    className: "panel-content"
  }, children));
};
const StyledLabel = styled.label`
  ${typography};
  display: inline-flex;
  align-items: center;
  cursor: pointer;

  div {
    display: flex;
  }

  input {
    visibility: hidden;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    margin: 0;
    padding: 0;
  }

  span {
    padding: 0 3px;
  }

  input[type='radio'] ~ .playbook--radioButton--svg-checked {
    display: none;
  }
  input[type='radio'] ~ .playbook--radioButton--svg-unchecked {
    display: inline-block;
  }

  input[type='radio']:checked ~ .playbook--radioButton--svg-checked {
    display: inline-block;
  }
  input[type='radio']:checked ~ .playbook--radioButton--svg-unchecked {
    display: none;
  }
`;
const prefixClassName = (componentName, modifier) => `playbook--${componentName}${modifier ? `--${modifier}` : ""}`;
const RadioButton = ({
  className,
  textClassName,
  label,
  name,
  defaultChecked,
  checked,
  fill = "sp-black",
  size = "medium",
  ...rest
}) => {
  return /* @__PURE__ */ React.createElement(StyledLabel, {
    className: classNames(prefixClassName("radioButton"), className)
  }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("input", {
    type: "radio",
    checked,
    defaultChecked,
    name,
    ...rest
  }), /* @__PURE__ */ React.createElement(Icon, {
    variant: "radio-selected",
    className: "playbook--radioButton--svg-checked",
    fill,
    size
  }), /* @__PURE__ */ React.createElement(Icon, {
    variant: "radio-unselected",
    className: "playbook--radioButton--svg-unchecked",
    fill,
    size
  })), label && /* @__PURE__ */ React.createElement("span", {
    className: classNames(
      prefixClassName("radioButton", "labelText"),
      textClassName
    )
  }, label));
};
const StyledWrapper$6 = styled.div`
  width: 40px;
  cursor: pointer;
  &.slim {
    width: 28px;
  }
  &.disabled {
    cursor: not-allowed;
  }
`;
const StyledSwitch = styled.div`
  background-color: ${palette["sp-light-gray-25"]};
  border-radius: 100px;
  padding: 4px;
  transition: background-color 0.5s ease-in-out;

  .checked & {
    background-color: ${palette.serena};
  }

  .slim & {
    padding: 2px 4px;
  }
`;
const StyledHandle = styled.div`
  border-radius: 100px;
  height: 16px;
  width: 16px;
  background-color: ${palette["sp-mid-gray"]};
  transition: all 0.5s ease-in-out;
  transition-property: background-color, transform;
  .checked & {
    background-color: ${palette["sp-white"]};
    opacity: 0.8;
    transform: translate(16px, 0);
  }
  .slim & {
    height: 11px;
    width: 11px;
  }
  .slim.checked & {
    transform: translate(9px, 0);
  }
`;
const Switch = (props) => {
  const { className, onClick, size = "normal", disabled, ...rest } = props;
  const [checked, changeChecked] = useState(
    props.defaultChecked || false
  );
  const toggleChecked = (event) => {
    if (disabled)
      return;
    changeChecked(!checked);
    onClick == null ? void 0 : onClick(event);
  };
  const switchClassName = classNames(className, size, {
    checked,
    disabled
  });
  return /* @__PURE__ */ React.createElement(StyledWrapper$6, {
    className: switchClassName,
    onClick: toggleChecked,
    ...rest
  }, /* @__PURE__ */ React.createElement("input", {
    type: "checkbox",
    style: { display: "none" }
  }), /* @__PURE__ */ React.createElement(StyledSwitch, null, /* @__PURE__ */ React.createElement(StyledHandle, null)));
};
const DefaultStyledTab = styled.div`
  ${typography};
  padding: 4px 12px;
  line-height: 24px;
  cursor: pointer;
  color: ${palette["sp-black"]};

  &:hover,
  &.selected:hover {
    color: ${palette["jordan"]};
  }

  &.selected {
    border-bottom: 2px solid ${palette["jordan"]};
  }

  &.inactive {
    color: ${palette["sp-mid-gray"]};
    cursor: auto;
    pointer-events: none;
  }
`;
const Tab = (props) => {
  const { className, title, selected, inactive, id, ...rest } = props;
  const tabClassName = classNames(className, {
    selected,
    inactive
  });
  return /* @__PURE__ */ React.createElement(DefaultStyledTab, {
    className: tabClassName,
    ...rest
  }, title);
};
const StyledTabList = styled.div`
  display: flex;
  flex-direction: row;
`;
const Tabs = (props) => {
  var _a;
  const { className, onChangeCallback, forceSelectedTabId, ...rest } = props;
  const initialTabId = (_a = props.forceSelectedTabId) != null ? _a : props.tabList[0].id;
  const [selectedTabId, setSelectedTabId] = useState(initialTabId);
  useEffect(() => {
    if (forceSelectedTabId) {
      setSelectedTabId(forceSelectedTabId);
    }
  }, [forceSelectedTabId]);
  const onTabClick = (id) => {
    if (id !== selectedTabId) {
      onChangeCallback(id);
      setSelectedTabId(id);
    }
  };
  return /* @__PURE__ */ React.createElement(StyledTabList, {
    className,
    ...rest
  }, props.tabList.map((tab) => {
    return /* @__PURE__ */ React.createElement(Tab, {
      title: tab.title,
      onClick: () => onTabClick(tab.id),
      selected: selectedTabId === tab.id,
      inactive: tab.inactive,
      id: tab.id,
      key: tab.id
    });
  }));
};
const StyledWrapper$5 = styled.div`
  ${typography};
  background-color: transparent;
  display: flex;
  flex-direction: column;
  width: ${(props) => props["data-width"] || "100%"};

  input {
    background-color: ${palette["sp-light-gray-25"]};
  }

  &.dark {
    color: ${palette["sp-white"]};
    textarea {
      background-color: ${palette["sp-black"]};
    }
  }

  .playbook-textarea-inner-wrapper {
    width: 100%;
    position: relative;

    .state-icon {
      position: absolute;
      right: 8px;
      top: 8px;
    }
  }

  &.side-label {
    flex-direction: row;

    label {
      height: 40px;
      line-height: 44px;
      width: 96px;
      font-size: 14px;
      padding-right: 16px;
      text-align: right;
    }
  }

  .playbook-textarea-helper-text {
    color: ${palette["sp-dark-gray-25"]};
    font-size: 10px;
    line-height: 1.6;
    padding: 4px 0;
  }
`;
const StyledTextArea = styled.textarea`
  height: ${(props) => props["data-height"] || "auto"};
  min-height: 50px;
  max-width: 100%;
  max-height: 100%;
  ${typography};
  box-sizing: border-box;
  width: 100%;
  padding: 16px;

  color: inherit;
  background-color: inherit;
  border-radius: 2px;
  border: solid 1px ${palette["sp-light-gray-50"]};

  &.success {
    border: solid 1px ${palette["serena"]};
    padding-right: 32px;
  }

  &.error {
    border: solid 1px ${palette["jordan"]};
    padding-right: 32px;
  }

  &.warning {
    border: solid 1px ${palette["pele"]};
    padding-right: 32px;
  }

  &.disabled {
    color: ${palette["sp-mid-gray"]};
  }
`;
const iconVariants = {
  success: "check",
  warning: "warning",
  error: "error"
};
const iconColors = {
  success: "serena",
  warning: "pele",
  error: "jordan"
};
const TextArea = (props) => {
  const {
    value,
    state,
    theme,
    labelPosition,
    helperText,
    className,
    height,
    width,
    ...rest
  } = props;
  const textAreaClass = classNames(state, {
    disabled: props.disabled
  });
  const wrapperClass = classNames("playbook-textarea-wrapper", className, {
    "side-label": labelPosition === "side",
    dark: theme === "dark"
  });
  return /* @__PURE__ */ React.createElement(StyledWrapper$5, {
    className: wrapperClass,
    "data-width": width
  }, /* @__PURE__ */ React.createElement(Label, {
    label: props.label,
    htmlFor: props.id,
    required: props.required,
    disabled: props.disabled
  }), /* @__PURE__ */ React.createElement("div", {
    className: "playbook-textarea-inner-wrapper"
  }, /* @__PURE__ */ React.createElement(StyledTextArea, {
    className: textAreaClass,
    defaultValue: value,
    "data-height": height,
    ...rest
  }), state && /* @__PURE__ */ React.createElement(Icon, {
    className: "state-icon",
    variant: iconVariants[state],
    fill: iconColors[state]
  }), helperText && /* @__PURE__ */ React.createElement("div", {
    className: "playbook-textarea-helper-text"
  }, helperText)));
};
const StyledTile = styled.div`
  ${typography};

  display: inline-block;
  box-shadow: 0 0 8px 0 ${palette["sp-shadow"]};
  margin-bottom: 24px;

  .tile-header,
  .tile-content {
    padding: 24px 24px 16px 24px;
    background-color: ${palette["sp-white"]};
  }

  .tile-header {
    font-size: 21px;
    font-weight: 300;
    border-bottom: 1px solid ${palette["sp-light-gray-25"]};
    border-radius: 4px 4px 0 0;
    display: flex;
    .tile-header-text {
      flex: 1 1;
    }
  }

  .tile-content {
    border-radius: 0 0 4px 4px;
  }

  &.secondary {
    .tile-header {
      color: ${palette["sp-white"]};
      background-color: ${palette["sp-black"]};
      font-size: 16px;
      font-weight: 700;
      padding: 0 24px;
      height: 40px;
      line-height: 40px;
      text-transform: uppercase;
    }
  }
`;
const Tile = (props) => {
  const {
    title,
    children,
    variant,
    iconVariant,
    iconOnClick,
    className,
    ...rest
  } = props;
  const tileClassName = classNames(className, {
    secondary: variant === "secondary"
  });
  return /* @__PURE__ */ React.createElement(StyledTile, {
    className: tileClassName,
    ...rest
  }, title && /* @__PURE__ */ React.createElement("div", {
    className: "tile-header"
  }, /* @__PURE__ */ React.createElement("span", {
    className: "tile-header-text"
  }, title), iconVariant && variant !== "secondary" && /* @__PURE__ */ React.createElement(IconWithHover, {
    variant: iconVariant,
    onClick: iconOnClick
  })), /* @__PURE__ */ React.createElement("div", {
    className: "tile-content"
  }, children));
};
const StyledWrapper$4 = styled.div`
  ${typography};
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  text-transform: uppercase;
  color: ${palette["sp-dark-gray-25"]};

  .item {
    display: inline-block;
    position: relative;

    input {
      opacity: 0;
      display: block;
      margin: 0;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    label {
      display: inline-block;
      padding: 8px 27px;
      background-color: ${palette["sp-light-gray-25"]};
      cursor: pointer;
      border-right: 1px solid ${palette["sp-mid-gray"]};

      &:hover {
        background-color: ${palette["sp-light-gray-50"]};
      }
    }

    &:first-of-type label {
      border-radius: 16px 0 0 16px;
    }

    &:last-of-type label {
      border-right: none;
      border-radius: 0 16px 16px 0;
    }

    input:focus-visible + label {
      outline: 2px solid ${palette["tendulkar"]};
      outline-offset: -2px;
    }

    input:checked + label {
      color: ${palette["sp-white"]};
      background-color: ${palette["sp-black"]};
    }
  }
`;
const Toggle = (props) => {
  var _a;
  const {
    items,
    defaultValue,
    onChange,
    name = getUniqueId("toggle"),
    value,
    ...rest
  } = props;
  const internalDefaultValue = defaultValue ? defaultValue : (_a = items[0]) == null ? void 0 : _a.value;
  return /* @__PURE__ */ React.createElement(StyledWrapper$4, {
    className: "playbook-toggle-wrapper",
    "aria-label": "toggle",
    role: "radiogroup"
  }, items.map((item) => {
    var _a2;
    return /* @__PURE__ */ React.createElement("div", {
      className: "item",
      key: item.value
    }, /* @__PURE__ */ React.createElement("input", {
      ...rest,
      type: "radio",
      name,
      value: item.value,
      defaultChecked: internalDefaultValue ? internalDefaultValue === item.value : void 0,
      checked: value ? item.value === value : void 0,
      onChange: (event) => onChange && onChange(event, item.value)
    }), /* @__PURE__ */ React.createElement("label", null, /* @__PURE__ */ React.createElement("span", null, (_a2 = item.name) != null ? _a2 : item.value)));
  }));
};
const StyledWrapper$3 = styled.span`
  ${typography};
  position: relative;
  display: inline-block;
  font-size: 12px;

  .content {
    background-color: ${palette["sp-black"]};
    color: ${palette["sp-white"]};
    border-radius: 2px;
    padding: 16px;
    position: absolute;
    white-space: nowrap;
    ${({ zIndex }) => zIndex !== void 0 && `z-index: ${zIndex};`}

    visibility: hidden;
    opacity: 0;
  }

  &:hover {
    .content {
      visibility: visible;
      opacity: 1;
      transition: opacity 300ms ease-out;
    }
  }

  .content:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border: 4px solid transparent;
  }

  &.up {
    .content {
      left: 50%;
      transform: translateX(-50%);
      bottom: 100%;
      margin-bottom: 8px;
    }
    .content:after {
      border-top-color: ${palette["sp-black"]};
      right: 50%;
      transform: translateX(50%);
      bottom: -8px;
    }
  }

  &.down {
    .content {
      left: 50%;
      transform: translateX(-50%);
      top: 100%;
      margin-top: 8px;
    }
    .content:after {
      border-bottom-color: ${palette["sp-black"]};
      right: 50%;
      transform: translateX(50%);
      top: -8px;
    }
  }

  &.right {
    .content {
      top: 50%;
      transform: translateY(-50%);
      left: 100%;
      margin-left: 8px;
    }
    .content:after {
      border-right-color: ${palette["sp-black"]};
      top: 50%;
      transform: translateY(-50%);
      left: -8px;
    }
  }

  &.left {
    .content {
      top: 50%;
      transform: translateY(-50%);
      right: 100%;
      margin-right: 8px;
    }
    .content:after {
      border-left-color: ${palette["sp-black"]};
      top: 50%;
      transform: translateY(-50%);
      right: -8px;
    }
  }
`;
const Tooltip = (props) => {
  const {
    className,
    direction,
    tooltipContent,
    children,
    zIndex,
    ...rest
  } = props;
  const tooltipClassName = classNames("playbook-tooltip", direction, className);
  return /* @__PURE__ */ React.createElement(StyledWrapper$3, {
    className: tooltipClassName,
    zIndex,
    ...rest
  }, /* @__PURE__ */ React.createElement("span", {
    className: "target"
  }, children), /* @__PURE__ */ React.createElement("span", {
    className: "content",
    "data-testid": "content"
  }, tooltipContent));
};
const StyledWrapper$2 = styled.div`
  padding: 16px;
  padding-right: 32px;

  .playbook-daterange-title {
    font-size: 14px;
    font-weight: bold;
    line-height: 1.71;
    text-align: left;
    text-transform: uppercase;
  }

  .playbook-daterange-options {
    font-size: 14px;
    line-height: 2.57;
    text-align: left;
  }

  .playbook-daterange-option {
    cursor: pointer;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .playbook-daterange-selected {
    margin-left: 16px;
  }

  .playbook-daterange-hide {
    visibility: hidden;
  }
`;
function getXDaysBeforeToday(days) {
  const today = new Date();
  return new Date(today.setDate(today.getDate() - days).valueOf());
}
function getFirstDayInPreviousMonth(today) {
  return new Date(today.getFullYear(), today.getMonth() - 1, 1);
}
function getLastDayInPreviousMonth() {
  const date = new Date();
  date.setDate(0);
  return date;
}
const DateRangeTile = (props) => {
  const { handleDateChange, options } = props;
  const today = getXDaysBeforeToday(0);
  const yesterday = getXDaysBeforeToday(1);
  const oneWeekAgo = getXDaysBeforeToday(6);
  const thirtyDaysAgo = getXDaysBeforeToday(29);
  const firstDayOfPreviousMonth = getFirstDayInPreviousMonth(today);
  const lastDayOfPreviousMonth = getLastDayInPreviousMonth();
  const [selectedRange, setSelectedRange] = useState("");
  const defaultOptions = [
    {
      label: "Yesterday",
      startDate: yesterday,
      endDate: today
    },
    {
      label: "Last 7 Days",
      startDate: oneWeekAgo,
      endDate: today
    },
    {
      label: "Last 30 Days",
      startDate: thirtyDaysAgo,
      endDate: today
    },
    {
      label: "Last Month",
      startDate: firstDayOfPreviousMonth,
      endDate: lastDayOfPreviousMonth
    },
    {
      label: "Custom Range",
      startDate: null,
      endDate: null
    }
  ];
  const onSelectRange = (option) => {
    setSelectedRange(option.label);
    handleDateChange(option.startDate, option.endDate);
  };
  return /* @__PURE__ */ React.createElement(StyledWrapper$2, null, /* @__PURE__ */ React.createElement("div", {
    className: "playbook-daterange-title"
  }, "Date Range"), /* @__PURE__ */ React.createElement("div", {
    className: "playbook-daterange-options"
  }, (options || defaultOptions).map((option, index) => /* @__PURE__ */ React.createElement("div", {
    key: index,
    className: "playbook-daterange-option",
    onClick: () => onSelectRange(option)
  }, /* @__PURE__ */ React.createElement("span", null, option.label), /* @__PURE__ */ React.createElement(Icon, {
    variant: "check",
    className: classNames("playbook-daterange-selected", {
      "playbook-daterange-hide": selectedRange !== option.label
    }),
    fill: "serena"
  })))));
};
const StyledWrapper$1 = styled.div`
  ${typography};
  display: inline-flex;
  background-color: ${palette["sp-white"]};

  .playbook-daterange-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-right: 2px solid ${palette["sp-light-gray-50"]};
  }

  .playbook-daterange-footer {
    border-top: 1px solid ${palette["sp-light-gray-50"]};
    padding: 16px;
    padding-right: 8px;
    font-size: 10.75px;
    display: flex;
    align-items: center;
  }

  .playbook-date-selected {
    font-size: 12px;
    width: 72px;
    padding: 7px 0;
    text-align: center;
    background: ${palette["sp-light-gray-25"]};
    margin: 0 5px;
  }
`;
const StyledDatePicker = styled.div`
  padding: 0.25rem;

  .react-datepicker {
    border: none;
    border-radius: 0;
  }

  .react-datepicker__header {
    background-color: ${palette["sp-white"]};
    border-bottom: none;
    text-transform: uppercase;
    font-size: 14px;
    font-family: 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans',
      'Droid Sans', 'Helvetica Neue', sans-serif;
    .react-datepicker__day-name {
      text-transform: capitalize;
      font-weight: 500;
    }
  }

  .react-datepicker__header {
    background-color: ${palette["sp-white"]};
  }

  .react-datepicker__day-name,
  .react-datepicker__day,
  .react-datepicker__time-name {
    color: ${palette["sp-black"]};
    margin: 4px 0;
    padding: 2px 6px;
    font-family: 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans',
      'Droid Sans', 'Helvetica Neue', sans-serif;
  }

  .react-datepicker__current-month {
    margin-top: 2px;
    text-transform: uppercase;
    font-size: 14px;
    font-family: 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans',
      'Droid Sans', 'Helvetica Neue', sans-serif;
  }

  .react-datepicker__month {
    margin-top: 0;
  }

  .react-datepicker__month,
  .react-datepicker__quarter {
    &--in-selecting-range,
    &--in-range {
      border-radius: 0;
      background-color: ${palette["jordan-dp-30"]};
    }
  }

  .react-datepicker__day--outside-month {
    color: ${palette["sp-mid-gray"]};
  }

  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-range {
    border-radius: 0;
    background-color: ${palette["jordan-dp-30"]};
    color: ${palette["sp-black"]};
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--range-start,
  .react-datepicker__day--range-end,
  .react-datepicker__day--selected:hover,
  .react-datepicker__day--in-selecting-range:hover,
  .react-datepicker__day--in-range:hover {
    border-radius: 0;
    background-color: ${palette["jordan-dp"]};
    color: ${palette["sp-white"]};
    font-weight: bold;
  }

  &.playbook-datepicker-custom {
    padding: 0;
  }

  &.playbook-datepicker-custom .react-datepicker {
    padding: 0.25rem;
  }

  .playbook-datepicker-month-wrapper {
    display: none;
    align-items: center;
    justify-content: center;
    padding: 16px;
    border-bottom: 1px solid ${palette["sp-light-gray-50"]};
  }

  &.playbook-datepicker-custom .playbook-datepicker-month-wrapper {
    display: flex;
  }

  .playbook-datepicker-dropdown:first-child {
    margin-right: 12px;
    width: 110px;
  }

  .playbook-datepicker-dropdown .dropdown-field .secondary {
    font-size: 14px;
    font-weight: bold;
    text-align: center;
  }

  .playbook-datepicker-dropdown .secondary:not(.dropdown-field) {
    width: min-content;
    right: 0;
  }

  &.playbook-datepicker-custom .react-datepicker__month {
    padding: 0 32px;
  }

  .playbook-datepicker--previous-month,
  .playbook-datepicker--next-month {
    position: absolute;
    margin: 0 8px;
    margin-top: 35%;
    cursor: pointer;
  }

  .playbook-datepicker--previous-month {
    left: 0;
  }

  .playbook-datepicker--next-month {
    right: 0;
  }
`;
const monthMenuItems = [
  { value: "0", name: "January" },
  { value: "1", name: "February" },
  { value: "2", name: "March" },
  { value: "3", name: "April" },
  { value: "4", name: "May" },
  { value: "5", name: "June" },
  { value: "6", name: "July" },
  { value: "7", name: "August" },
  { value: "8", name: "September" },
  { value: "9", name: "October" },
  { value: "10", name: "November" },
  { value: "11", name: "December" }
];
const getYearMenuItems = (startYear, endYear) => {
  const yearMenuItems = [];
  for (let tempYear = endYear; tempYear >= startYear; tempYear--) {
    yearMenuItems.push({
      value: tempYear.toString(),
      name: tempYear.toString()
    });
  }
  return yearMenuItems;
};
const DatePicker = (props) => {
  const {
    startDate,
    endDate,
    handleDateChange,
    variant,
    styleVariant,
    onChange: ignoredOnChange,
    options,
    footer,
    ...rest
  } = props;
  const onChange = (dates) => {
    if (dates instanceof Date) {
      handleDateChange(dates, null);
    } else {
      if (dates !== null && dates.length > 0) {
        const [start, end] = dates;
        handleDateChange(start, end);
      }
    }
  };
  return /* @__PURE__ */ React.createElement(StyledWrapper$1, {
    ...rest,
    className: "playbook-datepicker-wrapper"
  }, variant === "range" && /* @__PURE__ */ React.createElement("div", {
    className: "playbook-daterange-wrapper"
  }, /* @__PURE__ */ React.createElement(DateRangeTile, {
    handleDateChange,
    options
  }), footer && /* @__PURE__ */ React.createElement("div", {
    className: "playbook-daterange-footer"
  }, "From", /* @__PURE__ */ React.createElement("div", {
    className: "playbook-date-selected"
  }, startDate ? format(startDate, "M/dd/yyyy") : "-"), "To", /* @__PURE__ */ React.createElement("div", {
    className: "playbook-date-selected"
  }, endDate ? format(endDate, "M/dd/yyyy") : "-"))), /* @__PURE__ */ React.createElement(StyledDatePicker, {
    className: classNames({
      "playbook-datepicker-custom": styleVariant === "custom"
    })
  }, /* @__PURE__ */ React.createElement(ReactDatePicker, {
    selected: startDate,
    startDate,
    endDate,
    onChange,
    selectsRange: variant === "range",
    disabledKeyboardNavigation: true,
    inline: true,
    formatWeekDay: (day) => day.substring(0, 3),
    renderCustomHeader: styleVariant === "custom" ? ({
      increaseMonth,
      decreaseMonth,
      changeMonth,
      changeYear,
      date
    }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", {
      className: "playbook-datepicker-month-wrapper"
    }, /* @__PURE__ */ React.createElement(Dropdown, {
      onItemSelect: changeMonth,
      menuItems: monthMenuItems,
      value: date.getMonth().toString(),
      className: "playbook-datepicker-dropdown",
      variant: "secondary"
    }), /* @__PURE__ */ React.createElement(Dropdown, {
      onItemSelect: changeYear,
      menuItems: getYearMenuItems(
        1900,
        new Date().getFullYear()
      ),
      value: date.getFullYear().toString(),
      className: "playbook-datepicker-dropdown",
      variant: "secondary"
    })), /* @__PURE__ */ React.createElement(Icon, {
      className: "playbook-datepicker--previous-month",
      onClick: decreaseMonth,
      variant: "chevron-left"
    }), /* @__PURE__ */ React.createElement(Icon, {
      className: "playbook-datepicker--next-month",
      onClick: increaseMonth,
      variant: "chevron-right"
    })) : void 0,
    ...rest
  })));
};
const MenuToggle = (props) => {
  const iconVariant = props.open ? "chevron-up" : "chevron-down";
  return /* @__PURE__ */ React.createElement("span", {
    className: props.className
  }, /* @__PURE__ */ React.createElement(Icon, {
    variant: iconVariant,
    size: "small"
  }));
};
const StyledListboxButton = styled(ListboxButton)`
  text-align: left;
  min-width: 30px;
  padding: 8px 8px 8px 16px;
  border-radius: 2px;
  border: solid 1px ${palette["sp-light-gray-50"]};
  background-color: ${palette["sp-light-gray-25"]};
  cursor: pointer;

  display: flex;

  &.has-label {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  &.secondary {
    width: 100%;
    text-align: right;
    background-color: transparent;
    padding: 2px;
    border: none;
  }
`;
const StyledValue = styled.span`
  ${typography};
  line-height: 1.71;
  flex: 1 1;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  &.secondary {
    font-size: 12px;
    padding-right: 8px;
  }
`;
const StyledMenuToggle = styled(MenuToggle)`
  padding-top: 4px;
`;
const DropdownFieldV2 = ({
  displayValue,
  isExpanded,
  variant,
  label
}) => {
  const variantAndLabelClasses = classNames(variant, {
    "has-label": label
  });
  const dropdownFieldClass = classNames(
    "playbook-dropdown-field",
    variantAndLabelClasses
  );
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledListboxButton, {
    className: dropdownFieldClass
  }, /* @__PURE__ */ React.createElement(StyledValue, {
    className: variantAndLabelClasses
  }, displayValue), /* @__PURE__ */ React.createElement(StyledMenuToggle, {
    open: isExpanded
  })));
};
const StyledDropdownMenuItemV2 = styled(ListboxOption)`
  ${typography};
  list-style: none;
  padding: 8px 32px 8px 16px;
  position: relative;
  display: flex;

  &.readOnly {
    color: ${palette["sp-mid-gray"]};
  }

  &:hover {
    color: ${palette["sp-black"]};
    background: ${palette["sp-hover-light"]};
  }
  & .selected {
    position: absolute;
    top: 4px;
    right: 8px;
  }

  &:focus {
    outline: none;
    background: ${palette["sp-hover-light"]};
  }

  &[data-reach-listbox-option][data-current-nav] {
    background: ${palette["sp-hover-light"]};
    color: ${palette["sp-black"]};
  }
`;
const StyledMenuItemValue = styled.span`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
const SelectedIcon = (props) => {
  return /* @__PURE__ */ React.createElement("span", {
    className: "selected",
    "data-testid": `${props.value}-selected`
  }, /* @__PURE__ */ React.createElement(Icon, {
    variant: "check",
    fill: "serena"
  }));
};
const DropdownMenuItemV2 = ({ option }) => {
  const optionDisplayString = option.name || option.value;
  if (option.divider) {
    return /* @__PURE__ */ React.createElement(DividerMenuItem, null);
  }
  return /* @__PURE__ */ React.createElement(StyledDropdownMenuItemV2, {
    className: classNames(
      "playbook-menu-item",
      option.selected && "selectedItem"
    ),
    value: option.value
  }, /* @__PURE__ */ React.createElement(StyledMenuItemValue, null, optionDisplayString), option.selected && /* @__PURE__ */ React.createElement(SelectedIcon, {
    value: option.value
  }));
};
const StyledDropdownMenuV2 = styled(ListboxPopover)`
  ${typography};
  position: absolute;
  z-index: 999;
  width: 100%;
  border: none;
  border-radius: 4px;
  box-shadow: 0 0 8px 0 ${palette["sp-shadow"]};
  background-color: ${palette["sp-white"]};
  .menu-list {
    margin: 8px;
    padding: 0;
    max-height: 176px;
    overflow: auto;
  }
  ${scrollbars(".playbook-menu-list")}
`;
const filteredItems = (items, search) => {
  return search ? items.filter((item) => {
    const target = (item.name || item.value).toLowerCase();
    return target.includes(search.toLowerCase()) || item.divider || item.value === "default";
  }) : items;
};
const DropdownMenuV2 = ({
  menuItems,
  includeSearch,
  variant,
  isExpanded
}) => {
  const [search, changeSearch] = useState("");
  const [displayedItems, changeDisplayedItems] = useState(
    menuItems
  );
  useEffect(() => {
    changeDisplayedItems(filteredItems(menuItems, search));
  }, [search, menuItems]);
  useEffect(() => {
    changeSearch("");
  }, [isExpanded]);
  if (!isExpanded) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(StyledDropdownMenuV2, {
    className: variant
  }, /* @__PURE__ */ React.createElement(ListboxList, {
    className: "playbook-menu-list"
  }, /* @__PURE__ */ React.createElement(MenuSearch, {
    includeSearch,
    searchChangeHandler: changeSearch,
    autoFocus: true
  }), displayedItems.map((option) => {
    return /* @__PURE__ */ React.createElement(DropdownMenuItemV2, {
      option
    });
  })));
};
const StyledWrapper = styled.div`
  position: relative;
`;
const DropdownV2 = ({
  menuItems,
  label,
  value,
  variant,
  required,
  includeSearch,
  onItemSelect,
  placeholderText = "Select",
  className,
  excludeDeselectOption,
  inputId,
  ...rest
}) => {
  const [selectedValue, setSelectedValue] = useState(value || "default");
  const deselectMenuItem = { name: placeholderText, value: "default" };
  const getMenuItems = () => {
    const allMenuItems = excludeDeselectOption ? menuItems : [deselectMenuItem, ...menuItems];
    return allMenuItems.map((item) => {
      return { ...item, selected: item.value === selectedValue };
    });
  };
  const menuItemsWithDefault = getMenuItems();
  const selectedMenuItem = menuItemsWithDefault.find(
    (item) => item.selected
  );
  const getDisplayValue2 = () => {
    if (selectedValue === "default") {
      return placeholderText;
    } else if (selectedMenuItem && selectedMenuItem.name) {
      return selectedMenuItem.name;
    } else {
      return selectedValue;
    }
  };
  const onChange = (value2) => {
    setSelectedValue(value2);
    onItemSelect && onItemSelect(value2);
  };
  return /* @__PURE__ */ React.createElement(StyledWrapper, {
    className,
    ...rest
  }, /* @__PURE__ */ React.createElement(ListboxInput, {
    id: inputId,
    onChange
  }, ({ isExpanded }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(DropdownLabel, {
    label,
    required
  }), /* @__PURE__ */ React.createElement(DropdownFieldV2, {
    displayValue: getDisplayValue2(),
    isExpanded,
    label,
    variant
  }), /* @__PURE__ */ React.createElement(DropdownMenuV2, {
    menuItems: menuItemsWithDefault,
    includeSearch,
    variant,
    isExpanded
  }))));
};
const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);
  return debouncedValue;
};
const isDOMavailable = !!(typeof window !== "undefined" && window.document && window.document.createElement);
const useSSR = () => {
  const [inBrowser, setInBrowser] = useState(isDOMavailable);
  useEffect(() => {
    setInBrowser(isDOMavailable);
    return () => {
      setInBrowser(false);
    };
  }, []);
  const useSSRObject = useMemo(
    () => ({
      isBrowser: inBrowser,
      isServer: !inBrowser,
      canUseWorkers: typeof Worker !== "undefined",
      canUseEventListeners: inBrowser && !!window.addEventListener,
      canUseViewport: inBrowser && !!window.screen
    }),
    [inBrowser]
  );
  return useMemo(
    () => Object.assign(Object.values(useSSRObject), useSSRObject),
    [inBrowser]
  );
};
function useLocalStorage(key, initialValue) {
  const { isBrowser } = useSSR();
  const [storedValue, setStoredValue] = useState(() => {
    try {
      if (isBrowser) {
        const item = window.localStorage.getItem(key);
        return item ? JSON.parse(item) : initialValue;
      }
      return initialValue;
    } catch (error) {
      console.log(error);
      return initialValue;
    }
  });
  const setValue = (value) => {
    try {
      if (isBrowser) {
        const valueToStore = value instanceof Function ? value(storedValue) : value;
        setStoredValue(valueToStore);
        window.localStorage.setItem(key, JSON.stringify(valueToStore));
      }
    } catch (error) {
      console.log(error);
    }
  };
  return [storedValue, setValue];
}
const usePrevious = (value) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
};
const unicodeEncodeB64 = (str) => {
  return Buffer.from(str).toString("base64");
};
const unicodeDecodeB64 = (str) => {
  return Buffer.from(str, "base64").toString();
};
const getInitialValue = (parseAs) => {
  switch (parseAs) {
    case "string":
      return "";
    case "number":
      return 0;
    case "boolean":
      return false;
    case "array":
      return [];
    case "object":
      return {};
    default:
      return null;
  }
};
const parseValue = (parseAs, value, options) => {
  const valueToParse = (options == null ? void 0 : options.encoded) && value ? unicodeDecodeB64(value) : value;
  try {
    if (!value)
      return null;
    switch (parseAs) {
      case "string":
        return valueToParse;
      case "number":
        return parseFloat(valueToParse);
      case "boolean":
        return valueToParse === "true";
      case "array":
        return (options == null ? void 0 : options.joinArrayValues) ? valueToParse.split(",") : JSON.parse(valueToParse);
      case "object":
        return JSON.parse(valueToParse);
      default:
        return null;
    }
  } catch (e) {
    console.error(e);
    return null;
  }
};
const handleArrayManipulation = (newValue, paramValue) => {
  if (paramValue && Array.isArray(paramValue)) {
    if (paramValue.includes(newValue)) {
      return paramValue.filter((value) => value !== newValue);
    } else {
      return [...paramValue, newValue];
    }
  }
  return [];
};
const updateQueryParams = (queryParams) => {
  const paramsStr = queryParams.toString();
  if (typeof window !== "undefined") {
    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}?${paramsStr}`
    );
  }
};
const useQueryParam = (paramId, options) => {
  const parseAs = (options == null ? void 0 : options.parseAs) || "string";
  const encoded = (options == null ? void 0 : options.encoded) || false;
  const joinArrayValues = (options == null ? void 0 : options.joinArrayValues) || false;
  const onInitialParse = options == null ? void 0 : options.onInitialParse;
  const { isBrowser } = useSSR();
  const [paramState, setParamState] = useState(() => getInitialValue(parseAs));
  const queryParams = new URLSearchParams(
    isBrowser ? window.location.search : ""
  );
  const paramValue = queryParams.get(paramId);
  const getParsedValue = () => {
    if (!paramValue)
      return paramValue;
    return parseValue(parseAs, paramValue, {
      encoded,
      joinArrayValues
    });
  };
  useEffect(() => {
    if (isBrowser && paramValue) {
      if (onInitialParse) {
        onInitialParse(paramState);
      }
      setParamState(getParsedValue());
    }
  }, [isBrowser]);
  const setQueryParam = (newValue) => {
    let stringifiedValue = null;
    let paramUpdateValue = null;
    const currentParamValue = getParsedValue();
    if (parseAs === "array") {
      paramUpdateValue = handleArrayManipulation(
        newValue,
        currentParamValue || []
      );
      stringifiedValue = joinArrayValues ? paramUpdateValue.join(",") : JSON.stringify(paramUpdateValue);
    } else if (typeof newValue === "object") {
      paramUpdateValue = newValue;
      stringifiedValue = JSON.stringify(newValue);
    } else {
      paramUpdateValue = newValue;
      if (typeof newValue === "string" || typeof newValue === "number" || typeof newValue === "boolean") {
        stringifiedValue = newValue.toString();
      }
    }
    const isSameValue = stringifiedValue === paramState;
    if (isSameValue) {
      clearQueryParam();
      return;
    }
    if (isBrowser) {
      if (Array.isArray(paramUpdateValue) && paramUpdateValue.length === 0) {
        queryParams.delete(paramId);
      } else {
        queryParams.set(
          paramId,
          encoded ? unicodeEncodeB64(stringifiedValue || "") : stringifiedValue || ""
        );
      }
      updateQueryParams(queryParams);
    }
    setParamState(paramUpdateValue);
  };
  const clearQueryParam = () => {
    queryParams.delete(paramId);
    updateQueryParams(queryParams);
    setParamState(null);
  };
  return [paramState, setQueryParam, clearQueryParam];
};
const useScreenSize = () => {
  const [screenSize, setScreenSize] = useState(() => {
    if (typeof window === "undefined")
      return {
        width: 0,
        height: 0
      };
    return {
      width: window.innerWidth,
      height: window.innerHeight
    };
  });
  const { isBrowser } = useSSR();
  const setNewSize = () => {
    if (!isBrowser)
      return;
    setScreenSize({
      width: window.innerWidth,
      height: window.innerHeight
    });
  };
  useEffect(() => {
    if (!isBrowser)
      return;
    window.addEventListener("resize", setNewSize);
    return () => {
      if (!isBrowser)
        return;
      window.removeEventListener("resize", setNewSize);
    };
  }, [screenSize]);
  return {
    screenSize
  };
};
function useScript(src, disabled) {
  const [status, setStatus] = useState(
    disabled ? "disabled" : src ? "loading" : "idle"
  );
  const { isBrowser } = useSSR();
  useEffect(() => {
    if (!isBrowser)
      return;
    if (disabled) {
      setStatus("disabled");
      return;
    }
    if (!src) {
      setStatus("idle");
      return;
    }
    let script = document.querySelector(`script[src="${src}"]`);
    if (!script) {
      script = document.createElement("script");
      script.src = src;
      script.async = true;
      script.setAttribute("data-status", "loading");
      document.body.appendChild(script);
      const setAttributeFromEvent = (event) => {
        script == null ? void 0 : script.setAttribute(
          "data-status",
          event.type === "load" ? "ready" : "error"
        );
      };
      script.addEventListener("load", setAttributeFromEvent);
      script.addEventListener("error", setAttributeFromEvent);
    } else {
      const currentStatus = script.getAttribute("data-status");
      const statusToSet = currentStatus ? currentStatus : "exists";
      setStatus(statusToSet);
    }
    const setStateFromEvent = (event) => {
      setStatus(event.type === "load" ? "ready" : "error");
    };
    script.addEventListener("load", setStateFromEvent);
    script.addEventListener("error", setStateFromEvent);
    return () => {
      if (script) {
        script.removeEventListener("load", setStateFromEvent);
        script.removeEventListener("error", setStateFromEvent);
      }
    };
  }, [src, disabled, isBrowser]);
  return status;
}
export { Accordion, AsyncMultiSelect, Breadcrumbs, Button, Checkbox, ControlledMultiSelect, DataTable, DatePicker, Divider, Dropdown, DropdownV2, Icon, IconWithHover, Input, Label, Loader, Modal, MultiSelect, Notification, Pagination, Panel, RadioButton, Search, SortableTH, Switch, TBody, TD, TFoot, TH, THead, TR, Table, Tabs, Tag, TextArea, Tile, Toggle, Tooltip, color, getUniqueId, palette, prefixClassName, typography, useDebounce, useDetectClickOutside, useLocalStorage, usePrevious, useQueryParam, useSSR, useScreenSize, useScript };
